/* Bacanime campaign attribution v2: atomic visits, no legacy mixing. */
(function(){
// Attribution is descriptive, client-supplied metadata. Never use it for prices,
// permissions, payment confirmation, or proof of Meta's advertising attribution.
const attributionFields = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','campaign_id','adset_id','ad_id','campaign_name','adset_name','ad_name','placement','site_source_name','fbclid','gclid','ttclid','msclkid','fbc','fbp','attribution_model','attribution_status','attribution_captured_at','landing_page','first_campaign_name','first_adset_name','first_ad_name','first_campaign_id','first_adset_id','first_ad_id'];
function cleanTracking(value,max=250){
 if(typeof value!=='string'&&typeof value!=='number')return '';
 const s=String(value).replace(/[\u0000-\u001f\u007f<>]/g,'').trim();
 return !s||/\{\{|\}\}|%7b%7b|%7d%7d/i.test(s)?'':s.slice(0,max);
}
function normalizeAttribution(input={}){
 if(!input||typeof input!=='object')input={};
 const result={};
 const pick=(...keys)=>keys.map(k=>cleanTracking(input[k])).find(Boolean)||'';
 for(const key of attributionFields)result[key]=cleanTracking(input[key],['landing_page','fbclid','fbc'].includes(key)?700:250);
 result.utm_source=pick('utm_source','source');result.utm_medium=pick('utm_medium','medium');
 result.utm_campaign=pick('utm_campaign','campaign_name','campaign');
 result.utm_content=pick('utm_content','ad_name','content');result.utm_term=pick('utm_term','adset_name','term');
 for(const [key,aliases] of Object.entries({campaign_id:['campaign_id','utm_campaign_id','utm_id'],adset_id:['adset_id','utm_adset_id','adset.id'],ad_id:['ad_id','utm_ad_id','ad.id']})){
  result[key]=pick(...aliases).replace(/[^0-9]/g,'')===pick(...aliases)?pick(...aliases):'';
 }
 result.campaign_name=pick('campaign_name')||(!/^\d+$/.test(result.utm_campaign)?result.utm_campaign:'');
 result.adset_name=pick('adset_name')||(!/^\d+$/.test(result.utm_term)?result.utm_term:'');
 result.ad_name=pick('ad_name')||(!/^\d+$/.test(result.utm_content)?result.utm_content:'');
 result.fbp=pick('fbp','_fbp');result.fbc=pick('fbc','_fbc');
 const names=['campaign_name','adset_name','ad_name'],ids=['campaign_id','adset_id','ad_id'];
 result.attribution_status=names.concat(ids).every(k=>result[k])?'completa':attributionFields.slice(0,18).some(k=>result[k])?'parcial':'sin_parametros';
 result.attribution_model=pick('attribution_model')||'parametros_recibidos';
 if(result.landing_page){try{const u=new URL(result.landing_page);result.landing_page=['https:','http:'].includes(u.protocol)?u.origin+u.pathname:'';}catch{result.landing_page='';}}
 return result;
}
function attributionAttributes(input){
 const a=normalizeAttribution(input);
 const labels={campaign_name:'Campaña',adset_name:'Conjunto de anuncios',ad_name:'Anuncio',campaign_id:'ID campaña',adset_id:'ID conjunto',ad_id:'ID anuncio',attribution_status:'Detalle de atribución',attribution_model:'Modelo de atribución'};
 const attrs=Object.entries(labels).filter(([key])=>a[key]).map(([key,label])=>({key:label,value:a[key]}));
 return attrs.concat(attributionFields.filter(key=>a[key]).map(key=>({key,value:a[key]})));
}

// Pure state transition: every new tagged arrival replaces the entire current
// touch. Direct/internal navigation retains it for at most 30 days. No migration
// from the old field-by-field merged record, which could contain mixed campaigns.
function captureCampaignTouch(previous,params,page,now=Date.now()){
 const ttl=30*86400000;
 const old=previous&&previous.version===2?previous:{};
 const valid=t=>t&&Number.isFinite(t.at)&&t.at<=now&&now-t.at<ttl;
 let current=valid(old.current)?old.current:null,first=valid(old.first)?old.first:null;
 const a=normalizeAttribution(params);
 const signal=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','campaign_id','adset_id','ad_id','campaign_name','adset_name','ad_name','fbclid','gclid','ttclid','msclkid','site_source_name'].some(k=>a[k]);
 if(signal){
  const identity=JSON.stringify(attributionFields.slice(0,18).map(k=>a[k]));
  if(!current||current.identity!==identity){
   a.attribution_model='ultima_visita_etiquetada_30_dias';a.attribution_captured_at=new Date(now).toISOString();a.landing_page=page;
   if(a.fbclid)a.fbc='fb.1.'+now+'.'+a.fbclid;
   current={identity,at:now,data:normalizeAttribution(a)};
  }
  if(!first)first=current;
 }
 return {version:2,first,current};
}
function campaignTouchValue(state){
 const a=normalizeAttribution(state?.current?.data||{});
 for(const k of ['campaign_name','adset_name','ad_name','campaign_id','adset_id','ad_id'])a['first_'+k]=state?.first?.data?.[k]||'';
 return a;
}

var key='bca_campaign_touch_v2',memory={};
function stored(){try{return JSON.parse(localStorage.getItem(key)||'{}');}catch(e){return memory;}}
var params={};new URLSearchParams(location.search).forEach(function(value,name){params[name]=value;});
memory=captureCampaignTouch(stored(),params,location.href);
try{localStorage.setItem(key,JSON.stringify(memory));}catch(e){}
function read(){
 var value=campaignTouchValue(captureCampaignTouch(stored(),{},location.href));
 var match=document.cookie.match(/(?:^|;\s*)_fbp=([^;]*)/);
 value.fbp='';try{value.fbp=match?decodeURIComponent(match[1]):'';}catch(e){}value._fbp=value.fbp;value._fbc=value.fbc;
 return value;
}
async function syncCart(a){
 var attributes={};attributionFields.forEach(function(k){attributes[k]='';});
 ['Campaña','Conjunto de anuncios','Anuncio','ID campaña','ID conjunto','ID anuncio','Detalle de atribución','Modelo de atribución'].forEach(function(k){attributes[k]='';});
 attributionAttributes(a).forEach(function(item){attributes[item.key]=item.value;});
 var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},3000);
 try{var response=await fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attributes}),signal:controller.signal});return response.ok;}catch(e){return false;}finally{clearTimeout(timer);}
}
window.BCA_CAMPAIGN_ATTRIBUTION={read:read,syncCart:syncCart,version:2};
})();

(function () {
  'use strict';

  /*
    BACANIME COD FORM PRO v81.0 ADDI STAGE 1 BOGOTÁ INTELIGENTE + ENVÍO RÁPIDO + LANDING STABLE + CLOUDFLARE WORKER PROXY + META ATTRIBUTION MAX + SERVER IP + CORS SAFE

    Funciones conservadas:
    - Webhook de pedidos.
    - Envío de pedidos contraentrega con event_type cod_order_submit.
    - Abandono de carrito.
    - DataLayer.
    - Tracking preparado para CAPI.
    - Descuento BACANIME10 para Mercado Pago / checkout nativo.
    - Limpieza de carrito después de pedido contraentrega.
    - Protección anti-auto-cart.

    Ajustes aplicados:
    - Formulario universal para tienda normal y landings.
    - Detecta automáticamente landings por URL /pages/... y también permite data-* opcional en #bca-cod-mount.
    - Envía landing_context/tracking_context al sistema de pedidos sin cambiar el webhook ni el flujo principal.
    - Agrega source_type, landing_id, landing_name y offer_name al payload, DataLayer, tags y note_attributes.
    - Agrega campo opcional de código de descuento y muestra el descuento visualmente en el formulario al tocar Aplicar.
    - Aplica visualmente códigos nativos de Shopify en el formulario y permite bloquear códigos exclusivos de pago anticipado.
    - Conserva la lógica bacanime_discount_active eliminada.
    - El formulario no guarda sessionStorage.setItem('bacanime_discount_active', 'true').
    - El cart.js puede limpiar el descuento siempre al entrar al carrito, sin excepciones.
    - Aclara Bogotá D.C. como Distrito independiente y ofrece corrección automática si se busca dentro de Cundinamarca.
    - Optimiza la respuesta al clic sin cambiar eventos, webhook ni payload de Make.
  */

  if (window.BCA_COD_FORM_PRO_LOADED_V80_1_LANDING_STABLE_WORKER_PROXY_CORS_SAFE) return;
  window.BCA_COD_FORM_PRO_LOADED_V80_1_LANDING_STABLE_WORKER_PROXY_CORS_SAFE = true;

  /* =========================================================
     CONFIG EDITABLE
  ========================================================= */
  var CONFIG = {
    brand: 'Bacanime',
    makeWebhookUrl: 'https://bacanime-pedidos.lobonocturno31.workers.dev/order',
    makeWebhookMode: 'cloudflare_worker_proxy',
    makeWebhookRealHiddenInCloudflareSecret: true,

    landingAutoDetect: {
      enabled: true,
      treatShopifyPagesAsLandings: true,
      landingPathPrefixes: ['/pages/', '/landing/', '/landings/'],
      excludedPageHandles: [
        'contact',
        'contacto',
        'about-us',
        'sobre-nosotros',
        'politicas-de-privacidad',
        'privacy-policy',
        'terminos-y-condiciones',
        'terms-of-service',
        'refund-policy',
        'shipping-policy',
        'politica-de-reembolso',
        'politica-de-envios',
        'search',
        'buscar',
        'cart',
        'carrito',
        'checkout',
        'account',
        'login',
        'register'
      ],
      defaultCampaignGroup: '',
      defaultProductFocus: ''
    },

    behavior: {
      closeOnBackdrop: false,
      closeOnEsc: false,
      clearCartAfterCodSubmit: true,
      requireCartItems: true,
      showExitIntent: true,
      autoFocusFirstField: false,
      fastSubmitMode: true,
      nativeCheckoutFastRedirect: true,
      paintBeforeSubmit: true,
      workerPreconnect: true,
      debugLogging: false
    },

    pixel: {
      enabled: true,
      useMetaPixel: false,
      useDataLayer: true,
      currency: 'COP',
      firePurchaseOnCodSubmit: false,
      events: {
        modalOpened: 'InitiateCheckout',
        formInput: 'AddPaymentInfo',
        codSubmit: 'AddPaymentInfo',
        nativeCheckout: 'InitiateCheckout',
        abandoned: 'Lead',
        purchase: 'Purchase'
      },
      dataLayerPrefix: 'bca_',
      sendFullPayloadToDataLayer: false
    },

    /*
      META / MAKE PRO CON PROXY CLOUDFLARE
      - Shopify ya NO expone el webhook real de Make.
      - El formulario envía al Worker: https://bacanime-cod-proxy.lobonocturno31.workers.dev/cod
      - Cloudflare Worker agrega la IP real server-side usando cf-connecting-ip.
      - El Worker inyecta client_ip_address en server_enrichment y meta_capi_ready.user_data para mejorar Meta CAPI.
      - El lookup de IP por frontend queda desactivado por velocidad y porque el proxy ya hace la captura buena.
    */
    trackingPro: {
      enabled: true,
      proxyEnabled: true,
      proxyProvider: 'cloudflare_workers',
      proxyEndpoint: 'https://bacanime-cod-proxy.lobonocturno31.workers.dev/cod',
      serverSideIpOwner: 'cloudflare_worker',
      repairMetaDirectAttribution: true,
      clientIpLookupEnabled: false,
      clientIpLookupTimeoutMs: 1500,
      waitForIpOnOrderSubmit: false,
      clientIpProviders: [
        'https://api64.ipify.org?format=json',
        'https://api.ipify.org?format=json',
        'https://api.my-ip.io/v2/ip.json',
        'https://ipapi.co/json/'
      ],
      preferSiteSourceNameExactPlatform: true,
      repairMetaDirectAttribution: true,
      sendExtraMakeHeaders: false,
      corsSafeMode: true
    },

    nativeCheckout: {
      enabled: true,
      buttonText: 'Pagar anticipado con Mercado Pago',
      subtitle: 'Pago procesado por Mercado Pago · 10% en productos elegibles; algodón y extras no aplican',
      openButtonText: 'PAGAR ANTICIPADO CON MERCADO PAGO',
      openButtonSubtitle: '10% en productos · algodón y extras no aplican',
      discountCode: 'BACANIME10',
      icon: '💳',
      openInSameTab: true
    },

    addiCheckout: {
      enabled: true,
      endpoint: 'https://bacanime-cod-proxy.lobonocturno31.workers.dev/addi-checkout',
      buttonText: 'Pagar con Addi',
      subtitle: 'Precio financiado: incluye ajuste del 6,8% sobre productos y envío',
      openButtonText: 'PAGAR CON ADDI',
      openButtonSubtitle: 'Incluye 6,8% sobre productos, materiales y envío',
      feeRateLabel: '6,8%',
      feeRate: 0.068,
      minimumPurchase: 50000,
      icon: '💙',
      openInSameTab: true
    },

    banner: {
      enabled: true,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0936/0621/6044/files/Descuento_del_10_con_Mercado_Pago.webp?v=1779927649',
      alt: '10% de descuento con Mercado Pago',
      borderRadius: '14px',
      maxHeight: '250px'
    },

    addressGuide: {
      enabled: true,
      imageUrl: 'https://cdn.shopify.com/s/files/1/0936/0621/6044/files/Captura_de_pantalla_2026-01-15_004240_1.webp?v=1779927791',
      imageAlt: 'Ejemplo de dirección correcta e incorrecta'
    },

    icons: {
      whatsappUrl: 'https://cdn.shopify.com/s/files/1/0936/0621/6044/files/pngegg.png?v=1779929059',
      person: '👤',
      address: '📍',
      department: '▾',
      city: '📍',
      email: '@',
      discount: '🏷️',
      iconSize: '18px'
    },

    shipping: {
      enabled: true,
      defaultPrice: 15000,
      methodName: 'Envío al nivel nacional',
      departmentRatesEnabled: false,
      departmentRates: {},
      cityRatesEnabled: true,
      cityRates: {
        'bogota d.c.': 15000,
        'bogota': 15000,
        'medellin': 15000,
        'cali': 15000,
        'barranquilla': 15000
      },
      freeShippingEnabled: false,
      freeShippingFrom: 120000
    },

    discounts: {
      enabled: false,
      label: 'Descuento contraentrega',
      type: 'percentage',
      value: 10,
      quantityDiscountsEnabled: false,
      quantityRules: [
        { minQuantity: 2, type: 'fixed', value: 5000 },
        { minQuantity: 3, type: 'fixed', value: 10000 }
      ]
    },

    /*
      REGLA DE COMPRA MÍNIMA
      - Una cobija habilita el pago sola; los demás pedidos requieren 2 unidades reales.
      - Recargos de material, personalización y opciones internas no cuentan como otra unidad.
      - El cálculo se hace desde el carrito recién leído y nunca desde el contador visual.
      - No cambia los event_type ni la estructura principal que recibe Make.
    */
    codRules: {
      enabled: true,
      ruleType: 'minimum_real_products',
      minimumQuantityForProducts: 2,
      minimumQuantityForShirts: 2,
      showNotice: true,
      allowNativeCheckoutWhenBlocked: false,
      internalOptionHandles: [
        'bacanime-commerce-os-recargo-opciones'
      ],
      internalOptionTitles: [
        'bacanime commerce os opciones de producto'
      ],
      shirtKeywords: [
        'camiseta',
        'camisetas',
        'camisa',
        'camisas',
        't-shirt',
        'tshirt',
        'tee'
      ],
      shirtSkuPrefixes: []
    },

    /*
      DESCUENTO NATIVO SHOPIFY VISIBLE EN EL FORMULARIO
      - El cliente puede escribir cualquier código creado en Shopify.
      - El formulario lo aplica al carrito con /cart/update.js.
      - Si Shopify descuenta el carrito, el formulario muestra el ahorro antes de finalizar.
      - Make recibe el código y el valor descontado para crear el pedido contraentrega con descuento.

      Nota: funciona mejor para descuentos de producto o pedido. Los descuentos solo de envío
      no siempre aplican visualmente aquí porque el envío COD lo calcula este formulario/Make.
    */
    shopifyNativeDiscounts: {
      enabled: true,
      clearDiscountBeforeApplying: true,
      saveCartAttributes: true,

      /*
        CÓDIGOS EXCLUSIVOS DE PAGO ANTICIPADO
        - Estos códigos NO se aplican en el formulario contraentrega.
        - Sí pueden seguir funcionando en el checkout nativo / Mercado Pago.
        - Agrega aquí otros códigos separados por coma, por ejemplo:
          ['BACANIME10', 'PAGOANTICIPADO15', 'MERCADOPAGO20']
      */
      prepaidOnlyCodes: ['BACANIME10']
    },

    abandonedCart: {
      enabled: true,
      debounceMs: 8000,
      idleMs: 45000,
      heartbeatMs: 0,
      sendOnInputWhenQualified: true,
      sendOnExit: true,
      sendOnModalClose: true,
      sendOnPageHidden: true,
      sendOnCartChange: true,
      requireCartItems: true,
      requireValidPhone: true,
      requireValidEmail: false,
      requireUserInteraction: true,
      requiredFields: ['first_name', 'phone'],
      preventDuplicateSameSignature: true,
      useLocalStorageLock: true,
      resendAfterMinutes: 720,
      minSecondsBetweenSends: 60,
      maxSendsPerModalOpen: 2
    },

    modal: {
      title: 'Bacanime Pedidos Form',
      subtitle: 'Cada pedido nos acerca a un sueño.',
      icon: '⌂',
      width: '520px',
      maxWidth: 'calc(100vw - 24px)',
      maxHeight: '92vh',
      borderRadius: '22px',
      backdropColor: 'rgba(0,0,0,.76)',
      backdropBlur: '5px'
    },

    exitPopup: {
      title: '¿Seguro que quieres salir?',
      text: 'Tu pedido aún no está completo. Recuerda que pagas al recibir y antes del despacho confirmamos contigo tallas, color o referencia por WhatsApp.',
      supportText: 'Si terminas tu compra hoy, apoyas a Bacanime y nos ayudas a seguir creando productos para la comunidad.',
      continueText: 'Sí, quiero terminar mi compra',
      exitText: 'Salir del formulario',
      icon: '🛡️'
    },

    thankYouPopup: {
      enabled: true,
      logoUrl: 'https://cdn.shopify.com/s/files/1/0936/0621/6044/files/LOGO_VIDEOS_TIKTOK.png?v=1779991810',
      logoAlt: 'Bacanime',
      title: '¡Gracias por comprar en Bacanime!',
      text: 'Tu pedido fue recibido correctamente. Te contactaremos por WhatsApp para validar los datos antes del despacho.',
      emailTitle: '📩 Correo de confirmación',
      emailText: 'Si escribiste un correo válido, podremos enviarte el resumen por correo. Si no, no te preocupes: la confirmación principal será por WhatsApp.',
      validationTitle: '📲 Validación por WhatsApp',
      validationText: 'Te contactaremos desde 3134555679 o 3106493026 para confirmar tallas, color o referencia.',
      scheduleTitle: '🕘 Horarios de atención',
      scheduleText: 'Atendemos de lunes a viernes de 8:00 a. m. a 5:00 p. m. Sábados, domingos y festivos no laboramos.',
      summaryTitle: 'Resumen de tu pedido',
      closeText: 'Entendido',
      continueShoppingText: 'Seguir viendo productos',
      continueShoppingUrl: '/',
      showSummary: true,
      showContinueShopping: true
    },

    texts: {
      openButtonTitle: 'PAGAR CONTRA ENTREGA',
      openButtonSubtitle: 'Completa tus datos y paga al recibir',
      emptyCart: 'Tu carrito está vacío. Agrega productos al carrito para continuar.',
      orderTitle: 'Tu pedido',
      updateCart: 'Actualizar carrito',
      methodTitle: 'Método de envío',
      formTitle: 'Ingrese su dirección de envío',
      subtotal: 'Subtotal',
      shipping: 'Envío',
      discount: 'Descuento',
      total: 'Total',
      whatsappWarning: 'Recuerda poner tu número de WhatsApp, ya que es la única forma que tenemos para contactarte y enviarte la guía de tu pedido.',
      whatsappNote: 'Confirma que el número que colocaste es tu WhatsApp 📲, ya que por ahí te enviaremos la guía.',
      submit: 'COMPLETA TU COMPRA',
      submitSub: 'oprime acá para pagar contraentrega',
      loading: 'Estamos creando tu pedido contraentrega...',
      submitProcessing: 'PROCESANDO TU PEDIDO...',
      submitProcessingSub: 'No cierres esta ventana',
      nativeProcessing: 'ABRIENDO PAGO SEGURO...',
      nativeProcessingSub: 'Te llevamos al checkout de Shopify',
      success: 'Pedido enviado correctamente. Te contactaremos por WhatsApp para confirmar la guía.',
      webhookMissing: 'No pudimos iniciar el servicio de pedidos. Intenta nuevamente o escríbenos por WhatsApp.',
      phoneError: 'El WhatsApp debe empezar por 3 y tener 10 dígitos.',
      emailError: 'El correo parece estar mal. Puedes corregirlo o dejarlo vacío; la compra se confirma por WhatsApp.',
      requiredError: 'Completa todos los campos obligatorios.',
      genericError: 'No se pudo enviar el pedido. Revisa tus datos o intenta nuevamente.',
      makeError: 'No pudimos confirmar correctamente tu pedido. Revisa tus datos o intenta nuevamente.',
      removeItemLabel: 'Quitar producto',
      searchDepartment: 'Buscar departamento o Bogotá D.C....',
      searchCity: 'Buscar ciudad...',
      noResults: 'No encontramos resultados',
      bogotaDepartmentHelp: '¿Tu dirección es en Bogotá? Selecciona “Bogotá D.C.” como Departamento o Distrito; no selecciones Cundinamarca.',
      bogotaCitySwitch: '¿Buscas Bogotá? Toca aquí para cambiar automáticamente a Bogotá D.C.',
      bogotaSelected: 'Listo: seleccionamos Bogotá D.C. como Departamento o Distrito y como Ciudad.',
      promoHelp: 'Escribe el código exactamente como aparece en tu promoción. Luego toca Aplicar para ver el descuento antes de finalizar.',
      promoApplyButton: 'Aplicar',
      promoRemoveButton: 'Quitar',
      promoApplying: 'Aplicando código de descuento...',
      promoEmpty: 'Escribe un código para aplicarlo.',
      promoApplied: 'Código aplicado correctamente.',
      promoInvalid: 'Ese código no se pudo aplicar. Escríbelo exactamente como aparece en tu promoción o bórralo para continuar sin descuento.',
      promoPrepaidOnly: 'El código {code} es exclusivo para pago anticipado. Para usarlo, toca el botón “Pagar con Mercado Pago”.',
      promoChanged: 'Toca Aplicar para validar este código.',
      promoNetworkError: 'No pudimos aplicar el código. Revisa tu conexión e intenta de nuevo.',
      promoValidationUnavailable: 'No pudimos aplicar el código en este momento. Intenta nuevamente o bórralo para continuar sin descuento.',
      promoAppliedByMake: 'El descuento se muestra antes de finalizar y se confirma al crear tu pedido.',
      codSingleShirtNotice: 'Te falta 1 producto real para completar la misión. El material de algodón y los extras no cuentan como otra unidad.',
      codSingleShirtMissing: 'Te falta {missing} producto real para completar la misión. El material de algodón y los extras no cuentan como otra unidad.',
      codSingleOtherReady: 'Una cobija de cualquier tamaño habilita la compra sola; los demás productos requieren 2 unidades reales.',
      codMultipleReady: '¡Misión completada! Tu pedido cumple el mínimo y puedes continuar.',
      codEmptyNotice: 'Agrega 1 cobija de cualquier tamaño, 2 camisetas o 1 camiseta y otro producto real. Algodón, envío y extras no cuentan como otra unidad.'
    },

    fields: {
      first_name: { label: 'Nombre', placeholder: 'Nombre', iconKey: 'person', required: true },
      last_name: { label: 'Apellido', placeholder: 'Apellido', iconKey: 'person', required: true },
      phone: { label: 'Teléfono (WhatsApp)', placeholder: 'Tu WhatsApp', iconKey: 'whatsapp', required: true },
      address1: { label: 'Dirección (Ejemplo: Calle 5 # 15-65)', placeholder: 'Dirección', iconKey: 'address', required: true },
      address2: { label: 'Barrio', placeholder: 'Barrio, Casa, Apto, Etc', iconKey: 'address', required: true },
      province: { label: 'Departamento o Distrito', placeholder: 'Departamento o Distrito', iconKey: 'department', required: true, dropdownDirection: 'up' },
      city: { label: 'Ciudad', placeholder: 'Ciudad', iconKey: 'city', required: true, dropdownDirection: 'up' },
      email: { label: 'Correo electrónico (opcional)', placeholder: 'Para resumen del pedido y descuentos secretos', iconKey: 'email', required: false },
      promo_code: { label: 'Código de descuento (opcional)', placeholder: 'Escríbelo exactamente igual', iconKey: 'discount', required: false }
    },

    checks: [
      { name: 'confirm_whatsapp', required: true, text: 'Confirmo que es mi número de WhatsApp y deseo adquirir mis productos.' },
      { name: 'confirm_commitment', required: true, text: 'Confirmo que mis datos, talla y material son correctos. Acepto que el pedido se confirma el siguiente día hábil, que la entrega estimada tarda de 3 a 7 días hábiles y adquiero el compromiso de recibirlo.' }
    ],

    locations: {
      /*
        LISTADO COMPLETO DE MUNICIPIOS DE COLOMBIA
        - Fuente fija y versionada para evitar cambios inesperados.
        - Se guarda una copia en localStorage para que siga funcionando si el CDN tarda.
        - El listado corto que aparece abajo se conserva únicamente como respaldo de emergencia.
      */
      remote: {
        enabled: true,
        sourceUrl: 'https://cdn.jsdelivr.net/npm/colombia-cities@1.0.0/colombia_completa.json',
        cacheKey: 'bca_colombia_locations_complete_v2025_10',
        cacheMaxAgeHours: 720,
        timeoutMs: 3500,
        minimumDepartments: 32,
        minimumMunicipalities: 1000
      },
      departments: ['Amazonas','Antioquia','Arauca','Atlántico','Bogotá D.C.','Bolívar','Boyacá','Caldas','Caquetá','Casanare','Cauca','Cesar','Chocó','Córdoba','Cundinamarca','Guainía','Guaviare','Huila','La Guajira','Magdalena','Meta','Nariño','Norte de Santander','Putumayo','Quindío','Risaralda','San Andrés y Providencia','Santander','Sucre','Tolima','Valle del Cauca','Vaupés','Vichada'],
      citiesByDepartment: {
        'Amazonas': ['Leticia','Puerto Nariño'],
        'Antioquia': ['Medellín','Bello','Itagüí','Envigado','Sabaneta','Rionegro','Apartadó','Turbo','Caucasia','La Ceja','Marinilla','Copacabana','Girardota','Barbosa','Caldas','La Estrella','Guarne','Santa Fe de Antioquia','Yarumal','Sonsón'],
        'Arauca': ['Arauca','Arauquita','Cravo Norte','Fortul','Puerto Rondón','Saravena','Tame'],
        'Atlántico': ['Barranquilla','Soledad','Malambo','Sabanalarga','Puerto Colombia','Galapa','Baranoa','Santo Tomás','Palmar de Varela','Luruaco','Tubará'],
        'Bogotá D.C.': ['Bogotá D.C.','Bogotá'],
        'Bolívar': ['Cartagena de Indias','Magangué','Turbaco','Arjona','El Carmen de Bolívar','Mompós','San Juan Nepomuceno','María La Baja','Santa Rosa del Sur','Mahates'],
        'Boyacá': ['Tunja','Duitama','Sogamoso','Chiquinquirá','Paipa','Villa de Leyva','Puerto Boyacá','Nobsa','Samacá','Moniquirá','Garagoa','Guateque'],
        'Caldas': ['Manizales','Villamaría','Chinchiná','La Dorada','Riosucio','Anserma','Aguadas','Salamina','Supía','Neira'],
        'Caquetá': ['Florencia','San Vicente del Caguán','Cartagena del Chairá','Puerto Rico','El Doncello','El Paujil','La Montañita','Solano'],
        'Casanare': ['Yopal','Aguazul','Villanueva','Tauramena','Paz de Ariporo','Monterrey','Maní','Orocué','Trinidad'],
        'Cauca': ['Popayán','Santander de Quilichao','Puerto Tejada','Patía','Piendamó - Tunía','El Tambo','Guapi','Caloto','Corinto','Miranda','Timbío'],
        'Cesar': ['Valledupar','Aguachica','Agustín Codazzi','Bosconia','Chiriguaná','Curumaní','El Copey','La Jagua de Ibirico','San Alberto'],
        'Chocó': ['Quibdó','Istmina','Tadó','Condoto','Acandí','Bahía Solano','Nuquí','Riosucio','El Carmen de Atrato'],
        'Córdoba': ['Montería','Cereté','Sahagún','Lorica','Planeta Rica','Montelíbano','Tierralta','Chinú','Ayapel','Puerto Libertador'],
        'Cundinamarca': ['Soacha','Chía','Zipaquirá','Facatativá','Fusagasugá','Girardot','Mosquera','Funza','Madrid','Cajicá','Cota','La Calera','Tocancipá','Ubaté','Villeta','La Mesa'],
        'Guainía': ['Inírida','Barrancominas'],
        'Guaviare': ['San José del Guaviare','Calamar','El Retorno','Miraflores'],
        'Huila': ['Neiva','Pitalito','Garzón','La Plata','Campoalegre','San Agustín','Palermo','Aipe','Gigante','Rivera'],
        'La Guajira': ['Riohacha','Maicao','Uribia','Manaure','Fonseca','San Juan del Cesar','Barrancas','Dibulla','Villanueva'],
        'Magdalena': ['Santa Marta','Ciénaga','Fundación','El Banco','Aracataca','Plato','Pivijay','Zona Bananera','Sabanas de San Ángel'],
        'Meta': ['Villavicencio','Acacías','Granada','Puerto López','Restrepo','Cumaral','San Martín','Puerto Gaitán','La Macarena','Vista Hermosa'],
        'Nariño': ['Pasto','Ipiales','Tumaco','Túquerres','Samaniego','La Unión','Chachagüí','Sandoná','Barbacoas','Buesaco'],
        'Norte de Santander': ['Cúcuta','Ocaña','Pamplona','Villa del Rosario','Los Patios','Tibú','Ábrego','Chinácota','El Zulia','Sardinata'],
        'Putumayo': ['Mocoa','Puerto Asís','Orito','Valle del Guamuez','Villagarzón','Sibundoy','Puerto Leguízamo','San Miguel'],
        'Quindío': ['Armenia','Calarcá','Montenegro','Quimbaya','La Tebaida','Circasia','Filandia','Salento','Génova'],
        'Risaralda': ['Pereira','Dosquebradas','Santa Rosa de Cabal','La Virginia','Marsella','Belén de Umbría','Quinchía','Apía','Santuario'],
        'San Andrés y Providencia': ['San Andrés','Providencia'],
        'Santander': ['Bucaramanga','Floridablanca','Girón','Piedecuesta','Barrancabermeja','San Gil','Socorro','Málaga','Barbosa','Vélez','Lebrija','Rionegro'],
        'Sucre': ['Sincelejo','Corozal','Sampués','San Marcos','Tolú','Coveñas','San Onofre','Sincé','Los Palmitos'],
        'Tolima': ['Ibagué','Espinal','Melgar','Honda','Chaparral','Líbano','Mariquita','Flandes','Guamo','Lérida','Natagaima'],
        'Valle del Cauca': ['Cali','Palmira','Buenaventura','Tuluá','Buga','Cartago','Jamundí','Yumbo','Zarzal','Sevilla','Florida','Candelaria','Pradera'],
        'Vaupés': ['Mitú','Carurú','Taraira'],
        'Vichada': ['Puerto Carreño','La Primavera','Cumaribo','Santa Rosalía']
      }
    },

    theme: {
      fontFamily: 'Inter, Outfit, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      openButtonEffect: 'scan',
      openButtonPulse: true
    }
  };


  var merchantSettings = window.BacanimeFormSettings || {};
  CONFIG.modal.title = merchantSettings.title || 'Bacanime Pedidos Form';
  var formPhrases = String(merchantSettings.phrases || 'Cada pedido nos acerca a un sueño.').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
  CONFIG.modal.subtitle = formPhrases[Math.floor(Math.random() * formPhrases.length)] || '';
  CONFIG.texts.submit = merchantSettings.submit || CONFIG.texts.submit;
  CONFIG.texts.openButtonText = merchantSettings.open || CONFIG.texts.openButtonText;
  CONFIG.behavior.showExitIntent = merchantSettings.showExit !== false;
  CONFIG.exitPopup.title = merchantSettings.exitTitle || CONFIG.exitPopup.title;
  CONFIG.exitPopup.text = merchantSettings.exitText || CONFIG.exitPopup.text;
  CONFIG.modal.width = (Number(merchantSettings.widthPc) || 760) + 'px';
  var merchantStyle = document.createElement('style');
  merchantStyle.textContent = 'html body #bca-modal.bca-modal .bca-panel{width:min('+(Number(merchantSettings.widthPc)||760)+'px,96vw)!important;max-width:calc(100vw - 12px)!important}html body #bca-modal.bca-modal .bca-panel input,html body #bca-modal.bca-modal .bca-panel select,html body #bca-modal.bca-modal .bca-panel label{font-size:'+(Number(merchantSettings.textPc)||14)+'px!important}@media(max-width:749px){html body #bca-modal.bca-modal .bca-panel{width:'+(Number(merchantSettings.widthMobile)||96)+'vw!important;max-width:calc(100vw - 12px)!important}html body #bca-modal.bca-modal .bca-panel input,html body #bca-modal.bca-modal .bca-panel select,html body #bca-modal.bca-modal .bca-panel label{font-size:'+(Number(merchantSettings.textMobile)||16)+'px!important}}';
  merchantStyle.textContent += 'html body #bca-modal.bca-modal .bca-check .bca-check-hint{background:#e8fff5!important;color:#073d31!important;-webkit-text-fill-color:#073d31!important;opacity:1!important;font-style:normal!important;font-size:12px!important;line-height:1.4!important;text-shadow:none!important}';
  document.head.appendChild(merchantStyle);

  var state = {
    modalRendered: false,
    modalCssLoaded: false,
    eventsBound: false,
    cart: null,
    cartRequestVersion: 0,
    totals: { subtotal: 0, discount: 0, shipping: 0, total: 0, qty: 0 },
    promoVisual: {
      code: '',
      status: 'idle',
      applied: false,
      discountType: '',
      discountValue: 0,
      shopifyDiscountValueType: '',
      shopifyDiscountValue: 0,
      shopifyDiscountTitle: '',
      shopifyDiscountApplicationType: '',
      discountAmount: 0,
      discountAmountCents: 0,
      freeShipping: false,
      source: '',
      shopifyCartApplied: false,
      shopifyCartOriginalTotal: 0,
      shopifyCartTotalAfterDiscount: 0,
      shopifyCartOriginalTotalCents: 0,
      shopifyCartTotalAfterDiscountCents: 0,
      message: ''
    },
    sessionId: getSessionId(),
    eventIds: {},
    inputEventSent: false,
    hasUserInteractedWithForm: false,
    codSubmitClicked: false,
    orderSubmitted: false,
    nativeCheckoutClicked: false,
    nativeCheckoutEventSent: false,
    addiCheckoutClicked: false,
    preferredPaymentRoute: 'cod',
    currentOrderAttemptId: '',
    lastSuccessfulCartFingerprint: '',
    pendingAbandonmentTimer: null,
    idleTimer: null,
    abandonmentHeartbeatTimer: null,
    abandonmentSendsThisModal: 0,
    lastAbandonmentSignature: '',
    lastAbandonmentAt: 0,
    dawnRefreshTimer: null,
    dawnObserverStarted: false,
    clientIpInfo: null,
    clientIpLookupPromise: null,
    clientIpLookupStartedAt: 0,
    locationsLoaded: false,
    locationsSource: 'fallback_config',
    locationsLoadPromise: null
  };

  var moneyFormatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0
  });

  function qs(s, ctx) { return (ctx || document).querySelector(s); }
  function qsa(s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); }
  function money(v) { return moneyFormatter.format(Number(v || 0)); }
  function normalize(v) { return String(v || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function cleanPhone(v) { return String(v || '').replace(/\D/g, ''); }
  function validPhone(v) { var p = cleanPhone(v); return /^3\d{9}$/.test(p) ? '+57' + p : null; }
  function cleanEmail(v) { return String(v || '').trim().toLowerCase().replace(/\s+/g, ''); }
  function cleanPromoCode(v) { return String(v || '').trim().toUpperCase().replace(/\s+/g, '').replace(/[^A-Z0-9_-]/g, ''); }

  function getPrepaidOnlyCodes() {
    var codes = CONFIG.shopifyNativeDiscounts && Array.isArray(CONFIG.shopifyNativeDiscounts.prepaidOnlyCodes)
      ? CONFIG.shopifyNativeDiscounts.prepaidOnlyCodes
      : [];

    return codes.map(function (code) {
      return cleanPromoCode(code);
    }).filter(Boolean);
  }

  function isPrepaidOnlyCode(code) {
    var cleanedCode = cleanPromoCode(code || '');

    if (!cleanedCode) return false;

    return getPrepaidOnlyCodes().indexOf(cleanedCode) > -1;
  }

  function getPrepaidOnlyMessage(code) {
    return String(CONFIG.texts.promoPrepaidOnly || '')
      .replace(/\{code\}/g, cleanPromoCode(code || '')) ||
      'Este código es exclusivo para pago anticipado.';
  }

  function validEmail(v) { var e = cleanEmail(v); return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(e) ? e : ''; }
  function nowIso() { return new Date().toISOString(); }
  function nowUnix() { return Math.floor(Date.now() / 1000); }
  function escapeHtml(v) { return String(v || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;'); }
  function safeJsonParse(v, fallback) { try { return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } }
  function safeStorageGet(storage, key) { try { return storage.getItem(key) || ''; } catch (e) { return ''; } }
  function safeStorageSet(storage, key, value) { try { storage.setItem(key, value); } catch (e) {} }

  function getProvinceCodeByDepartment(department) {
    var codes = {
      'amazonas': 'AMA',
      'antioquia': 'ANT',
      'arauca': 'ARA',
      'atlantico': 'ATL',
      'bogota d.c.': 'DC',
      'bogota dc': 'DC',
      'bogota': 'DC',
      'bolivar': 'BOL',
      'boyaca': 'BOY',
      'caldas': 'CAL',
      'caqueta': 'CAQ',
      'casanare': 'CAS',
      'cauca': 'CAU',
      'cesar': 'CES',
      'choco': 'CHO',
      'cordoba': 'COR',
      'cundinamarca': 'CUN',
      'guainia': 'GUA',
      'guaviare': 'GUV',
      'huila': 'HUI',
      'la guajira': 'LAG',
      'magdalena': 'MAG',
      'meta': 'MET',
      'narino': 'NAR',
      'norte de santander': 'NSA',
      'putumayo': 'PUT',
      'quindio': 'QUI',
      'risaralda': 'RIS',
      'san andres y providencia': 'SAP',
      'santander': 'SAN',
      'sucre': 'SUC',
      'tolima': 'TOL',
      'valle del cauca': 'VAC',
      'vaupes': 'VAU',
      'vichada': 'VID'
    };

    return codes[normalize(department)] || '';
  }


  function normalizeLocationKey(value) {
    return normalize(value || '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getCanonicalDepartmentName(remoteDepartment) {
    remoteDepartment = remoteDepartment || {};

    var rawCode = String(
      remoteDepartment.codigo ||
      remoteDepartment.code ||
      remoteDepartment.id ||
      remoteDepartment.department_id ||
      ''
    ).replace(/\D/g, '');

    var departmentCode = rawCode ? rawCode.padStart(2, '0').slice(0, 2) : '';
    var byCode = {
      '91': 'Amazonas',
      '05': 'Antioquia',
      '81': 'Arauca',
      '08': 'Atlántico',
      '11': 'Bogotá D.C.',
      '13': 'Bolívar',
      '15': 'Boyacá',
      '17': 'Caldas',
      '18': 'Caquetá',
      '85': 'Casanare',
      '19': 'Cauca',
      '20': 'Cesar',
      '27': 'Chocó',
      '23': 'Córdoba',
      '25': 'Cundinamarca',
      '94': 'Guainía',
      '95': 'Guaviare',
      '41': 'Huila',
      '44': 'La Guajira',
      '47': 'Magdalena',
      '50': 'Meta',
      '52': 'Nariño',
      '54': 'Norte de Santander',
      '86': 'Putumayo',
      '63': 'Quindío',
      '66': 'Risaralda',
      '88': 'San Andrés y Providencia',
      '68': 'Santander',
      '70': 'Sucre',
      '73': 'Tolima',
      '76': 'Valle del Cauca',
      '97': 'Vaupés',
      '99': 'Vichada'
    };

    if (byCode[departmentCode]) return byCode[departmentCode];

    var remoteName = remoteDepartment.nombre || remoteDepartment.name || remoteDepartment.departamento || remoteDepartment.department || '';
    var remoteKey = normalizeLocationKey(remoteName);
    var aliases = {
      'bogota d c': 'Bogotá D.C.',
      'distrito capital de bogota': 'Bogotá D.C.',
      'archipielago de san andres providencia y santa catalina': 'San Andrés y Providencia',
      'san andres providencia y santa catalina': 'San Andrés y Providencia',
      'san andres y providencia': 'San Andrés y Providencia'
    };

    if (aliases[remoteKey]) return aliases[remoteKey];

    return (CONFIG.locations.departments || []).find(function (department) {
      return normalizeLocationKey(department) === remoteKey;
    }) || '';
  }

  function getMunicipalityName(municipality) {
    if (typeof municipality === 'string') return String(municipality).trim();
    if (!municipality || typeof municipality !== 'object') return '';

    return String(
      municipality.nombre ||
      municipality.name ||
      municipality.municipio ||
      municipality.city ||
      municipality.ciudad ||
      ''
    ).trim();
  }

  function uniqueLocationNames(values) {
    var seen = {};

    return (values || []).filter(function (value) {
      var key = normalizeLocationKey(value);

      if (!key || seen[key]) return false;

      seen[key] = true;
      return true;
    }).sort(function (a, b) {
      return String(a).localeCompare(String(b), 'es', { sensitivity: 'base' });
    });
  }

  function parseCompleteColombiaLocations(data) {
    var remoteDepartments = data && Array.isArray(data.departamentos) ? data.departamentos : [];
    var parsed = {};
    var totalMunicipalities = 0;

    remoteDepartments.forEach(function (remoteDepartment) {
      var departmentName = getCanonicalDepartmentName(remoteDepartment);
      var municipalities = remoteDepartment && Array.isArray(remoteDepartment.municipios)
        ? remoteDepartment.municipios
        : [];

      if (!departmentName || !municipalities.length) return;

      var names = uniqueLocationNames(municipalities.map(getMunicipalityName).filter(Boolean).map(function (name) {
        if (departmentName === 'Bogotá D.C.' && normalizeLocationKey(name).indexOf('bogota') === 0) {
          return 'Bogotá D.C.';
        }

        return name;
      }));

      if (!names.length) return;

      parsed[departmentName] = names;
      totalMunicipalities += names.length;
    });

    var remoteConfig = CONFIG.locations.remote || {};
    var minimumDepartments = Number(remoteConfig.minimumDepartments || 32);
    var minimumMunicipalities = Number(remoteConfig.minimumMunicipalities || 1000);

    if (Object.keys(parsed).length < minimumDepartments || totalMunicipalities < minimumMunicipalities) {
      throw new Error('El listado remoto de municipios llegó incompleto.');
    }

    var merged = {};

    (CONFIG.locations.departments || []).forEach(function (department) {
      merged[department] = parsed[department] && parsed[department].length
        ? parsed[department]
        : ((CONFIG.locations.citiesByDepartment && CONFIG.locations.citiesByDepartment[department]) || []);
    });

    return {
      departments: (CONFIG.locations.departments || []).slice(),
      citiesByDepartment: merged,
      totalMunicipalities: totalMunicipalities
    };
  }

  function applyCompleteColombiaLocations(parsed, source) {
    if (!parsed || !parsed.citiesByDepartment) return false;

    CONFIG.locations.departments = parsed.departments.slice();
    CONFIG.locations.citiesByDepartment = parsed.citiesByDepartment;
    state.locationsLoaded = true;
    state.locationsSource = source || 'remote_complete';

    refreshLocationSelectOptions();
    return true;
  }

  function readLocationsCache() {
    var remoteConfig = CONFIG.locations.remote || {};
    var cacheKey = remoteConfig.cacheKey || '';

    if (!cacheKey) return null;

    var cached = safeJsonParse(safeStorageGet(localStorage, cacheKey), null);

    if (!cached || !cached.data || !cached.savedAt) return null;

    var maxAgeMs = Number(remoteConfig.cacheMaxAgeHours || 720) * 60 * 60 * 1000;
    var ageMs = Date.now() - Number(cached.savedAt || 0);

    return {
      data: cached.data,
      fresh: ageMs >= 0 && ageMs <= maxAgeMs
    };
  }

  function saveLocationsCache(parsed) {
    var remoteConfig = CONFIG.locations.remote || {};
    var cacheKey = remoteConfig.cacheKey || '';

    if (!cacheKey || !parsed) return;

    safeStorageSet(localStorage, cacheKey, JSON.stringify({
      savedAt: Date.now(),
      data: parsed
    }));
  }

  async function fetchCompleteColombiaLocations() {
    var remoteConfig = CONFIG.locations.remote || {};
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = null;

    if (controller) {
      timer = setTimeout(function () {
        try { controller.abort(); } catch (e) {}
      }, Number(remoteConfig.timeoutMs || 3500));
    }

    try {
      var response = await fetch(remoteConfig.sourceUrl, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'force-cache',
        signal: controller ? controller.signal : undefined,
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        throw new Error('No se pudo descargar el listado completo de municipios.');
      }

      return response.json();
    } finally {
      if (timer) clearTimeout(timer);
    }
  }

  async function ensureColombiaLocationsLoaded(forceRefresh) {
    var remoteConfig = CONFIG.locations.remote || {};

    if (!remoteConfig.enabled || !remoteConfig.sourceUrl) {
      state.locationsLoaded = true;
      state.locationsSource = 'fallback_config';
      return true;
    }

    if (!forceRefresh && state.locationsLoaded && state.locationsSource !== 'fallback_config') {
      return true;
    }

    if (!forceRefresh && state.locationsLoadPromise) {
      return state.locationsLoadPromise;
    }

    state.locationsLoadPromise = (async function () {
      var cached = readLocationsCache();

      if (cached && cached.data) {
        applyCompleteColombiaLocations(cached.data, cached.fresh ? 'local_cache_fresh' : 'local_cache_stale');

        if (cached.fresh && !forceRefresh) {
          return true;
        }
      }

      try {
        var remoteData = await fetchCompleteColombiaLocations();
        var parsed = parseCompleteColombiaLocations(remoteData);

        saveLocationsCache(parsed);
        applyCompleteColombiaLocations(parsed, 'cdn_versioned_complete');
        return true;
      } catch (error) {
        console.warn('Bacanime: se usó el listado local de respaldo porque no cargó el listado completo.', error);

        if (!state.locationsLoaded) {
          state.locationsLoaded = true;
          state.locationsSource = 'fallback_config';
        }

        return false;
      }
    })();

    try {
      return await state.locationsLoadPromise;
    } finally {
      state.locationsLoadPromise = null;
    }
  }

  function refreshLocationSelectOptions() {
    var provinceSelect = qs('.bca-select[data-select="province"]');
    var citySelect = qs('.bca-select[data-select="city"]');

    if (!provinceSelect) return;

    var provinceInput = provinceSelect.querySelector('input[type="hidden"]');
    var provinceList = provinceSelect.querySelector('.bca-option-list');
    var currentProvince = provinceInput ? provinceInput.value : '';

    if (provinceList) {
      provinceList.innerHTML = renderOptions(CONFIG.locations.departments || []);
    }

    if (!citySelect) return;

    var cityInput = citySelect.querySelector('input[type="hidden"]');
    var cityButton = citySelect.querySelector('.bca-select-btn');
    var cityButtonText = cityButton ? cityButton.querySelector('span') : null;
    var cityList = citySelect.querySelector('.bca-option-list');
    var currentCity = cityInput ? cityInput.value : '';
    var cities = currentProvince ? (CONFIG.locations.citiesByDepartment[currentProvince] || []) : [];

    if (cityList) {
      cityList.innerHTML = renderSelectOptions('city', cities, '');
    }

    if (!currentProvince) {
      citySelect.classList.add('is-disabled');
      if (cityButton) cityButton.disabled = true;
      return;
    }

    citySelect.classList.remove('is-disabled');
    if (cityButton) cityButton.disabled = false;

    var cityStillExists = cities.some(function (city) {
      return normalizeLocationKey(city) === normalizeLocationKey(currentCity);
    });

    if (!cityStillExists && currentCity) {
      if (cityInput) cityInput.value = '';
      if (cityButtonText) {
        cityButtonText.textContent = CONFIG.fields.city.placeholder;
        cityButtonText.classList.add('ph');
      }
    }
  }

  function isCodShirtItem(item) {
    return window.BCA_PURCHASE_RULES.classify(item) === 'shirt';
  }

  function isCodInternalOptionItem(item) {
    return window.BCA_PURCHASE_RULES.classify(item) === 'extra';
  }

  function isCodEligibleProductItem(item) {
    return !!item && Number(item.quantity || 0) > 0 && !isCodInternalOptionItem(item);
  }

  function setPaymentControlLocked(control, locked) {
    if (!control) return;

    locked = !!locked;
    control.classList.toggle('is-payment-locked', locked);
    control.setAttribute('aria-disabled', locked ? 'true' : 'false');

    if (control.tagName === 'BUTTON') {
      control.disabled = locked;
    }

    if (locked) {
      if (!control.hasAttribute('data-bca-original-tabindex')) {
        control.setAttribute('data-bca-original-tabindex', control.getAttribute('tabindex') || '');
      }
      control.setAttribute('tabindex', '-1');
    } else if (control.hasAttribute('data-bca-original-tabindex')) {
      var originalTabindex = control.getAttribute('data-bca-original-tabindex');
      control.removeAttribute('data-bca-original-tabindex');
      if (originalTabindex) control.setAttribute('tabindex', originalTabindex);
      else control.removeAttribute('tabindex');
    }
  }

  function lockPaymentControlsForCartRefresh(reason) {
    setPaymentControlLocked(qs('#bca-open-native'), true);
    setPaymentControlLocked(qs('#bca-open-addi'), true);
    setPaymentControlLocked(qs('#bca-native-checkout'), true);
    setPaymentControlLocked(qs('#bca-addi-checkout'), true);
    setPaymentControlLocked(qs('.bca-submit'), true);

    var notice = qs('#bca-payment-minimum');

    if (notice) {
      notice.classList.remove('is-ready');
      notice.innerHTML =
        '<div class="bca-progress-copy">' +
          '<span>⌛</span>' +
          '<strong>Verificando productos reales...</strong>' +
          '<span class="bca-progress-percent">--</span>' +
        '</div>' +
        '<div class="bca-progress-track" aria-hidden="true"><span class="bca-progress-fill" style="width:0"></span></div>' +
        '<small class="bca-progress-help">Material y extras no cuentan como otra unidad</small>';
    }
  }

  function getCodMinimumStatus() {
    var rules = CONFIG.codRules || {};
    var result = window.BCA_PURCHASE_RULES.analyze(state.cart);
    var items = ((state.cart && state.cart.items) || []).filter(isCodEligibleProductItem);
    var singleItem = result.quantity === 1 && items.length === 1 ? items[0] : null;
    var valid = !result.failed && result.quantity > 0 && (!rules.enabled || result.qualified);
    return {
      enabled: !!rules.enabled,
      rule_type: rules.ruleType || 'minimum_real_products',
      minimum: result.minimum,
      quantity: result.quantity,
      cart_quantity: result.cartQuantity,
      excluded_option_quantity: result.excluded,
      shirt_quantity: result.shirts,
      blanket_quantity: result.blankets,
      has_other_product: result.blankets + result.others > 0,
      missing: valid ? 0 : result.missing,
      single_item: !!singleItem,
      single_item_is_shirt: !!singleItem && isCodShirtItem(singleItem),
      blocked: !valid,
      valid: valid,
      detected_item_title: singleItem ? (singleItem.product_title || singleItem.title || '') : '',
      detected_item_sku: singleItem ? (singleItem.sku || '') : ''
    };
  }

  function getPaymentEligibility() {
    var cart = state.cart || { items: [] };
    var codStatus = getCodMinimumStatus();
    var subtotal = getCodCartSubtotalPesos(cart);
    var addiMinimum = Number(CONFIG.addiCheckout.minimumPurchase || 50000);

    return {
      empty: !cart.items || !cart.items.length,
      productRuleValid: codStatus.valid,
      missingShirts: Number(codStatus.missing || 0),
      subtotal: subtotal,
      addiMinimum: addiMinimum,
      addiMissingMoney: Math.max(addiMinimum - subtotal, 0),
      addiValid: codStatus.valid && subtotal >= addiMinimum
    };
  }

  function renderDirectPaymentEligibility() {
    var prepaid = qs('#bca-prepaid-eligibility');
    var addi = qs('#bca-addi-eligibility');
    var minimumNotice = qs('#bca-payment-minimum');
    var nativeBtn = qs('#bca-open-native');
    var addiBtn = qs('#bca-open-addi');
    var status = getPaymentEligibility();
    var minimumText = '';
    var progressValue = 0;
    var progressHelp = '1 cobija sola, 2 camisetas o 1 camiseta y otro producto real';

    if (status.empty) {
      minimumText = 'Inicia la misión agregando tus productos';
      progressValue = 0;
    } else if (!status.productRuleValid) {
      minimumText = '¡Ya casi! Te falta ' + status.missingShirts + ' producto real para completar la misión';
      progressValue = 50;
      progressHelp = 'Completa el logro y desbloquea los 3 métodos de pago';
    } else {
      minimumText = '¡Logro completado! Compra habilitada';
      progressValue = 100;
      progressHelp = 'Desbloqueaste todos los métodos de pago';
    }

    if (minimumNotice) {
      minimumNotice.innerHTML =
        '<div class="bca-progress-copy">' +
          '<span>' + ((!status.empty && status.productRuleValid) ? '✓' : '⚡') + '</span>' +
          '<strong>' + escapeHtml(minimumText) + '</strong>' +
          '<span class="bca-progress-percent">' + progressValue + '%</span>' +
        '</div>' +
        '<div class="bca-progress-track" aria-hidden="true"><span class="bca-progress-fill" style="width:' + progressValue + '%"></span></div>' +
        '<small class="bca-progress-help">' + escapeHtml(progressHelp) + '</small>';
      minimumNotice.classList.toggle('is-ready', !status.empty && status.productRuleValid);
    }

    if (prepaid) prepaid.textContent = '';
    if (addi) addi.textContent = '';

    setPaymentControlLocked(nativeBtn, status.empty || !status.productRuleValid);
    setPaymentControlLocked(addiBtn, !status.addiValid);

    if (status.empty || status.productRuleValid) {
      showDirectPaymentMessage('', '');
    }
  }

  function formatCodMinimumText(template, status) {
    return String(template || '')
      .replace(/\{min\}/g, String(status.minimum || 0))
      .replace(/\{qty\}/g, String(status.quantity || 0))
      .replace(/\{missing\}/g, String(status.missing || 0));
  }

  function getCodMinimumErrorMessage(status) {
    status = status || getCodMinimumStatus();

    return formatCodMinimumText(
      CONFIG.texts.codSingleShirtMissing || CONFIG.texts.codSingleShirtNotice,
      status
    );
  }

  function renderCodMinimumNotice() {
    var notice = qs('#bca-cod-minimum-notice');
    var achievement = qs('#bca-form-achievement');
    var codSubmit = qs('.bca-submit');
    var modalNative = qs('#bca-native-checkout');
    var modalAddi = qs('#bca-addi-checkout');
    var rules = CONFIG.codRules || {};
    var status = getCodMinimumStatus();

    if (!notice) return;

    if (achievement) {
      var achievementReady = !!rules.enabled && status.quantity > 0 && !status.blocked;
      achievement.classList.toggle('is-visible', achievementReady);
      achievement.setAttribute('aria-hidden', achievementReady ? 'false' : 'true');
    }

    [codSubmit, modalNative, modalAddi].forEach(function (button) {
      if (!button) return;
      var locked = status.quantity <= 0 || status.blocked;
      setPaymentControlLocked(button, locked);
    });

    notice.classList.remove('is-ready', 'is-missing');

    if (!rules.enabled || rules.showNotice === false) {
      notice.style.display = 'none';
      notice.textContent = '';
      return;
    }

    notice.style.display = '';

    if (status.quantity <= 0) {
      notice.classList.add('is-missing');
      notice.textContent = CONFIG.texts.codEmptyNotice;
      return;
    }

    if (status.blocked) {
      notice.classList.add('is-missing');
      notice.textContent = getCodMinimumErrorMessage(status);
      return;
    }

    notice.classList.add('is-ready');
    notice.textContent = CONFIG.texts.codMultipleReady;
  }

  function getSessionId() {
    var key = 'bca_cod_session_id';
    var id = safeStorageGet(localStorage, key);

    if (!id) {
      id = 'bca_' + Date.now() + '_' + Math.random().toString(16).slice(2);
      safeStorageSet(localStorage, key, id);
    }

    return id;
  }

  function getBrowserId() {
    var key = 'bca_browser_id';
    var id = safeStorageGet(localStorage, key);

    if (!id) {
      id = 'bca_bid_' + Date.now() + '_' + Math.random().toString(16).slice(2) + Math.random().toString(16).slice(2);
      safeStorageSet(localStorage, key, id);
    }

    return id;
  }

  function iconHtml(key) {
    if (key === 'whatsapp') {
      return `<svg class="bca-icon-svg bca-icon-whatsapp" viewBox="0 0 32 32" role="img" aria-label="WhatsApp"><path fill="#25D366" d="M16.04 3C8.86 3 3.03 8.74 3.03 15.82c0 2.46.7 4.86 2.03 6.92L3 29l6.45-1.99a13.15 13.15 0 0 0 6.59 1.78h.01c7.17 0 13-5.74 13-12.82C29.05 8.74 23.21 3 16.04 3Z"/><path fill="#fff" d="M23.64 19.24c-.32-.16-1.9-.93-2.19-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.57-.94-.84-1.58-1.88-1.76-2.2-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.98-2.34-.25-.6-.51-.52-.71-.53h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.63s1.14 3.05 1.3 3.26c.16.21 2.24 3.55 5.53 4.83 2.74 1.07 3.3.85 3.9.8.6-.05 1.9-.77 2.16-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37Z"/></svg>`;
    }

    return escapeHtml(CONFIG.icons[key] || '');
  }

  /* =========================================================
     PROTECCIÓN ANTI-AUTO-CART
  ========================================================= */
  (function protectAntiAutoCart() {
    if (window.BCA_ANTI_AUTO_CART_ACTIVE_V63) return;
    window.BCA_ANTI_AUTO_CART_ACTIVE_V63 = true;

    var userActionUntil = 0;
    var blockTime = 0;
    var BLOCK_DURATION = 1800;
    var USER_ACTION_DURATION = 7000;

    function isRealCartButton(target) {
      if (!target || !target.closest) return false;
      if (target.closest('#bca-cod-root') || target.closest('#bca-modal') || target.closest('#bca-form')) return false;
      if (target.closest('[data-bca-product-cod-button], .bca-product-cod-button')) return false;

      return target.closest('button, .button, [type="submit"], .product-form__submit, [name="add"], [data-add-to-cart], add-to-cart-component, quick-add-component');
    }

    window.BCA_BLOCK_AUTO_CART_NOW = function () {
      userActionUntil = 0;
      blockTime = Date.now();

      setTimeout(function () {
        if (Date.now() - blockTime >= BLOCK_DURATION) blockTime = 0;
      }, BLOCK_DURATION + 80);
    };

    ['click','mousedown','touchstart','pointerdown'].forEach(function (eventType) {
      document.addEventListener(eventType, function (e) {
        if (e.isTrusted && isRealCartButton(e.target)) {
          userActionUntil = Date.now() + USER_ACTION_DURATION;
          blockTime = 0;
        }
      }, true);
    });

    document.addEventListener('change', function (e) {
      if (
        e.target &&
        e.target.matches &&
        e.target.matches('[name="id"], select, input[type="radio"], input[type="checkbox"], .variant-select, variant-picker input, variant-picker select')
      ) {
        if (Date.now() > userActionUntil) {
          blockTime = Date.now();

          setTimeout(function () {
            if (Date.now() - blockTime >= BLOCK_DURATION) {
              blockTime = 0;
            }
          }, BLOCK_DURATION + 80);
        }
      }
    }, true);

    function shouldBlockAutoCart(urlString, options) {
      if (Date.now() < userActionUntil) return false;
      if (!blockTime || (Date.now() - blockTime) >= BLOCK_DURATION) return false;

      var body = options && options.body ? String(options.body) : '';

      if (urlString.indexOf('/cart/add') > -1) return true;

      if (
        (urlString.indexOf('graphql.json') > -1 || urlString.indexOf('/api/') > -1) &&
        body.indexOf('cartLinesAdd') > -1
      ) {
        return true;
      }

      return false;
    }

    if (window.fetch && !window.BCA_FETCH_ANTI_AUTO_CART_WRAPPED_V63) {
      window.BCA_FETCH_ANTI_AUTO_CART_WRAPPED_V63 = true;

      var originalFetch = window.fetch;

      window.fetch = function (url, options) {
        var urlString = '';

        try {
          urlString = typeof url === 'string' ? url : (url && url.url ? url.url : String(url));
        } catch (e) {}

        if (shouldBlockAutoCart(urlString, options || {})) {
          return Promise.reject(new Error('Auto cart add blocked by Bacanime'));
        }

        var fetchResult = originalFetch.apply(this, arguments);

        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(urlString)) {
          Promise.resolve(fetchResult).then(function (response) {
            if (!response || response.ok !== false) {
              scheduleLiveCartProgressRefresh('fetch_cart_mutation', 120);
            }
          }).catch(function () {});
        }

        return fetchResult;
      };
    }

    if (window.XMLHttpRequest && !window.BCA_XHR_ANTI_AUTO_CART_WRAPPED_V63) {
      window.BCA_XHR_ANTI_AUTO_CART_WRAPPED_V63 = true;

      var originalOpen = XMLHttpRequest.prototype.open;
      var originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function (method, url) {
        this.__bcaUrl = url;
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function (body) {
        if (shouldBlockAutoCart(String(this.__bcaUrl || ''), { body: body })) {
          try {
            this.abort();
          } catch (e) {}

          return;
        }

        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(String(this.__bcaUrl || ''))) {
          try {
            this.addEventListener('load', function () {
              if (!this.status || (this.status >= 200 && this.status < 400)) {
                scheduleLiveCartProgressRefresh('xhr_cart_mutation', 120);
              }
            });
          } catch (liveCartXhrError) {}
        }

        return originalSend.apply(this, arguments);
      };
    }
  })();

  function setBaseCss() {
    if (qs('#bca-cod-base-style')) return;

    var style = document.createElement('style');
    style.id = 'bca-cod-base-style';
    style.textContent = '\n' +
      '.bca-cod-root{width:100%;margin:14px 0;font-family:' + CONFIG.theme.fontFamily + ';box-sizing:border-box}' +
      '.bca-cod-root *{box-sizing:border-box}' +
      '.bca-open-modal{width:100%;min-height:62px;border:0!important;border-radius:0;padding:14px 25px!important;background:linear-gradient(180deg,#2c6fb0,#1a4f8a,#0d2e5a)!important;color:#fff!important;font-weight:900!important;text-transform:uppercase!important;letter-spacing:1px!important;display:flex;align-items:center;justify-content:center;gap:10px;cursor:pointer;clip-path:polygon(0% 0%,92% 0%,100% 35%,100% 100%,8% 100%,0% 65%);box-shadow:0 0 8px rgba(0,180,255,.55),inset 0 0 6px rgba(255,255,255,.18);position:relative;overflow:hidden;isolation:isolate;transition:transform .18s ease,background .18s ease,color .18s ease}' +
      '.bca-open-modal span{position:relative;z-index:1}.bca-open-modal strong{display:block;font-size:17px;line-height:1.06;font-weight:900}.bca-open-modal small{display:block;font-size:12px;text-transform:none;margin-top:4px;font-weight:700}' +
      '.bca-open-modal.bca-has-scan:after{content:"";position:absolute;top:0;left:-120%;width:60%;height:100%;background:linear-gradient(90deg,transparent,rgba(0,255,255,.45),transparent);animation:bcaScan 3s linear infinite;z-index:0}.bca-open-modal:hover{background:linear-gradient(180deg,#fff700,#ffd000,#ffb800)!important;color:#000!important;transform:scale(1.01)}' +
      '.bca-payment-console{width:100%;margin:16px 0 8px;padding:14px;background:linear-gradient(155deg,rgba(8,12,42,.98),rgba(20,18,70,.98));border:1px solid rgba(78,226,255,.45);border-radius:18px;box-shadow:0 0 0 3px rgba(70,40,255,.12),0 14px 35px rgba(2,5,28,.35),inset 0 0 28px rgba(73,49,220,.13);position:relative;overflow:hidden}.bca-payment-console:before{content:"";position:absolute;inset:0;background:linear-gradient(90deg,transparent 49%,rgba(65,230,255,.04) 50%,transparent 51%),linear-gradient(rgba(65,230,255,.035) 1px,transparent 1px);background-size:36px 100%,100% 6px;pointer-events:none}.bca-payment-console>*{position:relative;z-index:1}.bca-payment-console-head{display:flex;align-items:center;justify-content:center;gap:11px;margin:0 0 12px;padding:2px 2px 12px;border-bottom:1px solid rgba(93,223,255,.25);color:#fff;text-align:center}.bca-console-icon{width:39px;height:39px;flex:0 0 39px;display:grid;place-items:center;border-radius:11px;background:linear-gradient(145deg,#00e5ff,#684cff);box-shadow:0 0 15px rgba(0,229,255,.42);font-size:20px}.bca-payment-console-head strong{display:block;font-size:15px;line-height:1.1;letter-spacing:.8px;text-transform:uppercase}.bca-payment-console-head small{display:block;margin-top:4px;color:#a9c9e9;font-size:11px;font-weight:700;line-height:1.3}.bca-payment-minimum{margin:0 0 11px;padding:10px 12px;border-radius:11px;font-size:12px;font-weight:850;line-height:1.35;color:#ffe8a6;background:linear-gradient(135deg,rgba(255,189,32,.16),rgba(255,116,0,.1));border:1px solid rgba(255,195,67,.42)}.bca-payment-minimum.is-ready{color:#9dffd0;background:linear-gradient(135deg,rgba(0,224,145,.16),rgba(0,174,255,.08));border-color:rgba(54,255,173,.42)}.bca-progress-copy{display:flex;align-items:center;gap:7px}.bca-progress-copy strong{flex:1;font-size:11px}.bca-progress-percent{font-size:11px;font-weight:950;color:#fff}.bca-progress-track{height:9px;margin-top:8px;border-radius:99px;overflow:hidden;background:rgba(255,255,255,.11);box-shadow:inset 0 1px 3px rgba(0,0,0,.5)}.bca-progress-fill{display:block;height:100%;width:0;border-radius:99px;background:linear-gradient(90deg,#ffb400,#fff03a);box-shadow:0 0 10px rgba(255,218,40,.62);transition:width .35s ease}.bca-payment-minimum.is-ready .bca-progress-fill{background:linear-gradient(90deg,#00dd85,#37ffbf);box-shadow:0 0 11px rgba(55,255,191,.68)}.bca-progress-help{display:block;margin-top:6px;color:#cbd6f2;font-size:10px;font-weight:700;text-align:center}.bca-product-payment-actions{width:100%;margin:0}.bca-product-payment-actions .bca-open-modal{margin-top:10px!important}' +
      '.bca-order-intel{margin:0 0 11px;padding:12px 13px;display:block;border-radius:12px;color:#fff;background:linear-gradient(135deg,rgba(255,171,0,.2),rgba(255,78,0,.14));border:2px solid rgba(255,205,60,.78);box-shadow:0 0 16px rgba(255,174,0,.2),inset 0 1px 0 rgba(255,255,255,.12);font-size:10px;line-height:1.45;text-align:center}.bca-order-intel>span:first-child{display:block;margin-bottom:4px;font-size:19px;line-height:1}.bca-order-intel strong{display:block;margin-bottom:4px;color:#fff36c;font-size:12px;letter-spacing:1px;text-transform:uppercase}.bca-order-intel small{display:block;color:#fff;font-size:11px;font-weight:850;line-height:1.45}.bca-order-intel em{display:block;margin-top:5px;color:#ffd36a;font-size:10px;font-style:normal;font-weight:950;text-transform:uppercase}' +
      '.bca-cart-only-cod-button{width:100%;min-height:62px;padding:12px 22px!important;background:linear-gradient(180deg,#55ff35,#0ee315,#00a90b)!important;color:#061006!important;border:2px solid #8cff77!important;border-radius:12px!important;display:flex!important;align-items:center!important;justify-content:center!important;text-align:center!important;text-decoration:none!important;font-weight:900!important;cursor:pointer!important;clip-path:polygon(0 0,94% 0,100% 28%,100% 100%,6% 100%,0 72%);box-shadow:0 0 15px rgba(38,255,58,.46),inset 0 0 8px rgba(255,255,255,.28);transition:transform .18s ease,filter .18s ease}.bca-cart-only-cod-button:hover{transform:translateY(-1px);filter:brightness(1.08)}' +
      '.bca-payment-eligibility{display:none!important}.bca-open-modal.is-payment-locked{filter:saturate(.62);opacity:.82}' +
      '.bca-addi-fee-note{margin:8px 1px 1px;padding:9px 11px;border-radius:10px;display:flex;align-items:center;gap:8px;color:#d9d2ff;background:rgba(111,82,255,.11);border:1px solid rgba(139,117,255,.35);font-size:11px;line-height:1.35}.bca-addi-fee-note strong{color:#fff}.bca-addi-fee-note small{display:block;font-size:11px;font-weight:700}' +
      '.bca-direct-payment-message{display:none;margin:14px 0 10px;padding:16px 14px;border-radius:14px;font-size:14px;font-weight:950;line-height:1.48;text-align:center}.bca-direct-payment-message.ok{display:block;background:rgba(0,255,170,.14);color:#8dffd0;border:1px solid rgba(0,255,170,.48)}.bca-direct-payment-message.error{display:block!important;background:linear-gradient(135deg,#ff1838 0%,#c90025 48%,#720015 100%)!important;color:#fff!important;border:3px solid #ffe145!important;box-shadow:0 0 0 4px rgba(255,38,70,.24),0 0 26px rgba(255,0,42,.85),inset 0 1px 0 rgba(255,255,255,.3)!important;text-shadow:0 2px 2px rgba(0,0,0,.65);letter-spacing:.2px;animation:bcaMissionAlert .45s ease both,bcaMissionPulse 1.8s ease-in-out infinite}.bca-direct-payment-message.error:before{content:"⚠ MISIÓN INCOMPLETA";display:block;margin-bottom:7px;color:#fff36c;font-size:15px;font-weight:1000;letter-spacing:1.2px;text-transform:uppercase}.bca-direct-payment-message.error:after{content:"OBJETIVO: AGREGA 1 CAMISETA O 1 COBIJA";display:block;margin-top:8px;padding:7px 9px;border-radius:8px;background:#fff36c;color:#260009;font-size:13px;font-weight:1000;letter-spacing:.45px;text-shadow:none;text-transform:uppercase}' +
      '.bca-open-native{margin-top:10px!important;background:linear-gradient(180deg,#00d9ff,#008ee8,#004fa8)!important;box-shadow:0 0 10px rgba(0,217,255,.52),inset 0 0 6px rgba(255,255,255,.22)!important}.bca-open-native:hover{background:linear-gradient(180deg,#fff700,#ffd000,#ffb800)!important;color:#000!important}' +
      '.bca-open-addi{margin-top:10px!important;background:linear-gradient(180deg,#7357ff,#5537e6,#331fae)!important;box-shadow:0 0 10px rgba(111,82,255,.55),inset 0 0 6px rgba(255,255,255,.2)!important}.bca-open-addi:hover{background:linear-gradient(180deg,#8d79ff,#6c50f5,#4b32ce)!important;color:#fff!important}' +
      '@media(max-width:749px){.bca-payment-console{padding:12px;border-radius:15px}.bca-open-modal,.bca-cart-only-cod-button{min-height:58px!important}.bca-open-modal strong{font-size:15px}.bca-open-modal small{font-size:11px}.bca-payment-console-head strong{font-size:14px}}' +
      '@keyframes bcaScan{0%{left:-120%}100%{left:120%}}@keyframes bcaMissionAlert{0%{transform:scale(.96);opacity:.25}65%{transform:scale(1.015)}100%{transform:scale(1);opacity:1}}@keyframes bcaMissionPulse{0%,100%{box-shadow:0 0 0 4px rgba(255,38,70,.2),0 0 22px rgba(255,0,42,.68),inset 0 1px 0 rgba(255,255,255,.3)}50%{box-shadow:0 0 0 6px rgba(255,225,69,.25),0 0 32px rgba(255,42,54,.96),inset 0 1px 0 rgba(255,255,255,.3)}}';

    document.head.appendChild(style);
  }

  function setModalCss() {
    if (state.modalCssLoaded || qs('#bca-cod-form-style')) {
      state.modalCssLoaded = true;
      return;
    }

    var style = document.createElement('style');
    style.id = 'bca-cod-form-style';

    style.textContent = `
      .bca-modal,
      .bca-exit,
      .bca-thanks {
        font-family: ${CONFIG.theme.fontFamily};
        color-scheme: light;
      }

      .bca-modal *,
      .bca-exit *,
      .bca-thanks * {
        box-sizing: border-box;
      }

      .bca-hidden {
        display: none !important;
      }

      .bca-modal {
        position: fixed !important;
        inset: 0 !important;
        z-index: 2147483647 !important;
        display: none;
        isolation: isolate;
      }

      .bca-modal.is-open {
        display: block !important;
      }

      .bca-backdrop {
        position: fixed !important;
        inset: 0 !important;
        background: ${CONFIG.modal.backdropColor};
        backdrop-filter: blur(${CONFIG.modal.backdropBlur});
        -webkit-backdrop-filter: blur(${CONFIG.modal.backdropBlur});
        z-index: 2147483646 !important;
      }

      .bca-panel {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        right: auto !important;
        bottom: auto !important;
        transform: translate(-50%, -50%) !important;
        width: min(${CONFIG.modal.width}, ${CONFIG.modal.maxWidth}) !important;
        max-width: ${CONFIG.modal.maxWidth} !important;
        max-height: ${CONFIG.modal.maxHeight} !important;
        height: auto !important;
        background: #fff;
        color: #111;
        border-radius: ${CONFIG.modal.borderRadius};
        box-shadow: 0 30px 90px rgba(0,0,0,.45);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        z-index: 2147483647 !important;
        margin: 0 !important;
      }

      .bca-head {
        min-height: 58px;
        border-bottom: 1px solid #e8e8ee;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 13px 18px;
        background: #fff;
        color: #0f172a;
        flex: 0 0 auto;
        position: sticky;
        top: 0;
        z-index: 2;
      }

      .bca-head-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
      }

      .bca-head-icon {
        font-size: 23px;
      }

      .bca-head-title {
        font-size: 20px;
        font-weight: 900;
        line-height: 1.05;
      }

      .bca-head-subtitle {
        font-size: 12px;
        opacity: .72;
        margin-top: 3px;
      }

      .bca-close {
        border: 0 !important;
        background: #fff !important;
        color: #111 !important;
        cursor: pointer;
        width: 42px !important;
        height: 42px !important;
        border-radius: 999px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 30px !important;
        line-height: 1 !important;
        padding: 0 !important;
        margin: 0 !important;
      }

      .bca-body {
        padding: 20px 22px 24px;
        overflow-y: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;
        max-height: calc(92vh - 58px);
      }

      .bca-banner,
      .bca-address-guide-img {
        width: 100%;
        display: block;
        object-fit: cover;
        border-radius: ${CONFIG.banner.borderRadius};
      }

      .bca-banner {
        margin-bottom: 14px;
        max-height: ${CONFIG.banner.maxHeight};
      }

      .bca-address-guide-img {
        border-radius: 12px;
      }

      .bca-section-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin: 0 0 10px;
      }

      .bca-section-title h3,
      .bca-form h3 {
        color: #0f172a !important;
        -webkit-text-fill-color: #0f172a !important;
        text-shadow: none !important;
      }

      .bca-section-title h3 {
        margin: 0;
        font-size: 17px !important;
        text-transform: uppercase;
        letter-spacing: .8px;
        font-weight: 900 !important;
      }

      .bca-update-cart {
        border: 0;
        background: transparent;
        color: #ef0000;
        font-size: 13px;
        font-weight: 900;
        cursor: pointer;
      }

      .bca-items {
        display: grid;
        gap: 10px;
        margin: 0 0 14px;
      }

      .bca-empty {
        padding: 14px;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        background: #fff7ed;
        color: #9a3412;
      }

      .bca-item {
        display: grid;
        grid-template-columns: 58px minmax(0,1fr) 34px;
        gap: 12px;
        align-items: center;
        padding: 12px;
        border: 1px solid #e6e6ec;
        border-radius: 12px;
        background: #fff;
        box-shadow: 0 2px 10px rgba(15,23,42,.07);
      }

      .bca-img-wrap {
        position: relative;
        width: 58px;
        height: 58px;
      }

      .bca-item img {
        width: 58px;
        height: 58px;
        object-fit: cover;
        border-radius: 10px;
        background: #eee;
        display: block;
      }

      .bca-badge {
        position: absolute;
        top: -8px;
        right: -8px;
        min-width: 18px;
        height: 18px;
        border-radius: 999px;
        background: #6b7280;
        color: #fff;
        font-size: 11px;
        font-weight: 900;
        display: grid;
        place-items: center;
        padding: 0 5px;
      }

      .bca-item-title {
        margin: 0;
        font-size: 14px;
        font-weight: 900;
        line-height: 1.2;
        word-break: break-word;
      }

      .bca-item-variant {
        margin: 2px 0 4px;
        font-size: 12px;
        color: #666;
        word-break: break-word;
        font-weight: 600;
      }

      .bca-item-price {
        font-size: 13px;
        font-weight: 900;
      }

      .bca-remove {
        border: 0;
        background: transparent;
        color: #111;
        font-size: 28px;
        line-height: 1;
        cursor: pointer;
        display: grid;
        place-items: center;
        width: 34px;
        height: 34px;
      }

      .bca-qty {
        display: flex;
        align-items: center;
        border: 1px solid #e5e7eb;
        border-radius: 5px;
        overflow: hidden;
        width: max-content;
        margin-top: 7px;
      }

      .bca-qty button {
        width: 30px;
        height: 28px;
        border: 0;
        background: #fff;
        cursor: pointer;
        font-weight: 900;
        font-size: 16px;
        color: #111;
      }

      .bca-qty span {
        width: 32px;
        height: 28px;
        display: grid;
        place-items: center;
        border-left: 1px solid #e5e7eb;
        border-right: 1px solid #e5e7eb;
        font-weight: 900;
        font-size: 13px;
      }

      .bca-summary {
        background: #ddd;
        color: #111;
        border-radius: 11px;
        padding: 18px 22px;
        display: grid;
        gap: 10px;
        margin-bottom: 14px;
      }

      .bca-row,
      .bca-total {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
      }

      .bca-row {
        font-size: 16px;
      }

      .bca-total {
        padding-top: 11px;
        font-size: 18px;
        font-weight: 900;
      }

      .bca-total strong {
        font-size: 22px;
      }

      .bca-small-title {
        margin: 2px 0 10px;
        color: #475569;
        font-size: 17px;
        font-weight: 800;
      }

      .bca-method-card {
        border: 1.5px solid #ff2b1f;
        border-radius: 9px;
        padding: 15px 16px;
        display: grid;
        grid-template-columns: auto minmax(0,1fr) auto;
        gap: 12px;
        align-items: center;
        margin-bottom: 14px;
        background: #fff;
        color: #111;
      }

      .bca-cod-minimum-notice {
        margin: -4px 0 16px;
        padding: 12px 14px;
        border-radius: 12px;
        font-size: 13px;
        line-height: 1.45;
        font-weight: 900;
        text-align: center;
      }

      .bca-cod-minimum-notice.is-missing {
        color: #fff;
        background: linear-gradient(135deg,#d80022,#8e001b);
        border: 2px solid #ffcf33;
        box-shadow: 0 0 0 3px rgba(255,38,70,.14),0 0 18px rgba(255,0,42,.42);
        text-shadow: 0 1px 1px rgba(0,0,0,.45);
      }

      .bca-cod-minimum-notice.is-missing:before {
        content: '⚠ MISIÓN INCOMPLETA';
        display: block;
        margin-bottom: 5px;
        color: #fff36c;
        font-size: 12px;
        font-weight: 1000;
        letter-spacing: 1px;
      }

      .bca-cod-minimum-notice.is-ready {
        color: #166534;
        background: #f0fdf4;
        border: 1px solid #bbf7d0;
      }

      .bca-form-achievement {
        display: none;
        position: relative;
        overflow: hidden;
        margin: 16px 0 14px;
        padding: 15px 14px;
        border: 2px solid #42ff72;
        border-radius: 14px;
        background: linear-gradient(135deg,#071b35 0%,#10184d 55%,#26105f 100%);
        color: #fff;
        text-align: center;
        box-shadow: 0 0 0 3px rgba(66,255,114,.14),0 0 22px rgba(66,255,114,.32),inset 0 1px 0 rgba(255,255,255,.14);
      }

      .bca-form-achievement.is-visible {
        display: block;
        animation: bcaAchievementUnlock .5s cubic-bezier(.2,.8,.2,1) both;
      }

      .bca-form-achievement:before {
        content: '';
        position: absolute;
        inset: 0;
        pointer-events: none;
        background: linear-gradient(105deg,transparent 20%,rgba(255,255,255,.14) 48%,transparent 70%);
        transform: translateX(-120%);
        animation: bcaAchievementShine 1.2s .2s ease-out 1;
      }

      .bca-achievement-kicker {
        display: block;
        color: #70ff91;
        font-size: 11px;
        font-weight: 1000;
        letter-spacing: 1.4px;
        text-transform: uppercase;
      }

      .bca-achievement-title {
        display: block;
        margin-top: 3px;
        color: #fff36c;
        font-size: 17px;
        font-weight: 1000;
        line-height: 1.15;
        text-shadow: 0 0 12px rgba(255,243,108,.38);
      }

      .bca-achievement-copy {
        display: block;
        margin-top: 5px;
        color: #dbeafe;
        font-size: 12px;
        font-weight: 800;
        line-height: 1.35;
      }

      @keyframes bcaAchievementUnlock {
        from { opacity: 0; transform: scale(.94) translateY(8px); }
        to { opacity: 1; transform: scale(1) translateY(0); }
      }

      @keyframes bcaAchievementShine {
        to { transform: translateX(120%); }
      }

      @media (prefers-reduced-motion: reduce) {
        .bca-form-achievement.is-visible,
        .bca-form-achievement:before { animation: none !important; }
      }

      .bca-radio-dot {
        width: 22px;
        height: 22px;
        border: 3px solid #39ff14;
        border-radius: 50%;
        display: inline-block;
        position: relative;
      }

      .bca-radio-dot:after {
        content: "";
        position: absolute;
        inset: 4px;
        background: #39ff14;
        border-radius: 50%;
      }

      .bca-form {
        display: grid;
        gap: 14px;
        padding-top: 4px;
      }

      .bca-form h3 {
        margin: 10px 0 14px !important;
        padding: 12px 14px !important;
        text-align: center;
        font-size: 18px !important;
        font-weight: 900 !important;
        line-height: 1.3 !important;
        letter-spacing: .3px;
        text-transform: uppercase;
        border: 1px solid #cbd5e1;
        border-radius: 12px;
        background: #f8fafc !important;
      }

      .bca-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 14px;
      }

      .bca-field {
        display: grid;
        gap: 5px;
        font-size: 13px;
        color: #111;
        font-weight: 500;
      }

      .bca-label-text {
        display: inline-flex !important;
        align-items: center !important;
        line-height: 1.2 !important;
      }

      .bca-required {
        color: #f00 !important;
        font-size: 15px !important;
        font-weight: 900 !important;
        margin-left: 1px !important;
      }

      .bca-input-wrap {
        position: relative;
      }

      .bca-input-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 15px;
        color: #111;
        z-index: 2;
        min-width: 17px;
        text-align: center;
        display: grid;
        place-items: center;
      }

      .bca-icon-img {
        width: ${CONFIG.icons.iconSize};
        height: ${CONFIG.icons.iconSize};
        object-fit: contain;
        display: block;
      }

      .bca-form input,
      .bca-form textarea {
        width: 100%;
        max-width: 100%;
        border: 1px solid #d5d8df;
        border-radius: 10px;
        background: #f7f8fb;
        padding: 0 14px 0 42px;
        font-size: 15px;
        box-shadow: 0 3px 8px rgba(0,0,0,.16);
        outline: none;
        color: #111;
        min-height: 46px;
        font-family: ${CONFIG.theme.fontFamily};
      }

      .bca-form input:focus {
        background: #fff;
        border-color: #111;
        box-shadow: 0 0 0 3px rgba(17,24,39,.10);
      }

      .bca-invalid {
        border-color: #ef0000 !important;
        background: #fff5f5 !important;
      }

      .bca-field-error {
        font-size: 11px;
        color: #ef0000;
        font-weight: 800;
        display: none;
      }

      .bca-field.has-error .bca-field-error {
        display: block;
      }

      .bca-select {
        position: relative;
      }

      .bca-select-btn {
        width: 100%;
        min-height: 46px;
        border: 1px solid #d5d8df;
        border-radius: 10px;
        background: #f7f8fb;
        box-shadow: 0 3px 8px rgba(0,0,0,.16);
        padding: 0 42px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 15px;
        color: #111 !important;
        -webkit-text-fill-color: #111 !important;
        cursor: pointer;
        text-align: left;
      }

      .bca-select-btn .ph {
        color: #8b8b92 !important;
        -webkit-text-fill-color: #8b8b92 !important;
      }

      .bca-select-btn:after {
        content: '▾';
        position: absolute;
        right: 14px;
        color: #111;
      }

      .bca-options {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 2147483647;
        background: #f7f8fb;
        border: 1px solid #9ca3af;
        box-shadow: 0 15px 28px rgba(0,0,0,.2);
        max-height: 270px;
        overflow: hidden;
        display: none;
        border-radius: 10px;
      }

      .bca-select.open .bca-options {
        display: block;
      }

      .bca-select[data-dir='up'] .bca-options {
        bottom: calc(100% + 4px);
      }

      .bca-select[data-dir='down'] .bca-options {
        top: calc(100% + 4px);
      }

      .bca-search-box {
        padding: 8px;
        background: #f7f8fb;
        position: sticky;
        top: 0;
        z-index: 2;
      }

      .bca-search-input {
        width: 100%;
        height: 36px !important;
        min-height: 36px !important;
        border: 1px solid #d5d8df !important;
        border-radius: 8px !important;
        background: #fff !important;
        box-shadow: none !important;
        padding: 0 10px !important;
        font-size: 14px !important;
        color: #111 !important;
        -webkit-text-fill-color: #111 !important;
        caret-color: #111 !important;
      }

      .bca-search-input::placeholder {
        color: #707780 !important;
        -webkit-text-fill-color: #707780 !important;
        opacity: 1 !important;
      }

      .bca-option-list {
        max-height: 220px;
        overflow: auto;
        background: #fff !important;
        color: #111 !important;
      }

      .bca-option {
        padding: 8px 14px;
        font-size: 14px;
        line-height: 1.2;
        font-weight: 700;
        cursor: pointer;
        color: #111 !important;
        -webkit-text-fill-color: #111 !important;
        background: #fff !important;
        opacity: 1 !important;
        visibility: visible !important;
        text-shadow: none !important;
      }

      .bca-option:hover,
      .bca-option.active {
        background: #0b74de !important;
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
      }

      .bca-option.bca-option-special {
        margin: 7px 8px;
        padding: 11px 12px;
        border-radius: 9px;
        background: #fff7ed !important;
        color: #9a3412 !important;
        -webkit-text-fill-color: #9a3412 !important;
        border: 1px solid #fdba74;
        font-weight: 900;
        line-height: 1.35;
      }

      .bca-option.bca-option-special:hover,
      .bca-option.bca-option-special:focus {
        background: #ffedd5 !important;
        color: #7c2d12 !important;
        -webkit-text-fill-color: #7c2d12 !important;
      }

      .bca-location-help {
        display: block;
        margin-top: 3px;
        padding: 9px 11px;
        border-radius: 10px;
        background: #eff6ff;
        color: #1d4ed8;
        border: 1px solid #bfdbfe;
        font-size: 12px;
        line-height: 1.42;
        font-weight: 850;
      }

      .bca-location-help.is-selected {
        background: #ecfdf5;
        color: #047857;
        border-color: #86efac;
      }

      .bca-no-results {
        padding: 10px 14px;
        color: #777;
        font-size: 13px;
      }

      .bca-select.is-disabled .bca-select-btn {
        opacity: .7;
        cursor: not-allowed;
      }

      .bca-select.is-invalid .bca-select-btn {
        border-color: #ef0000 !important;
        background: #fff5f5 !important;
      }

      .bca-warning {
        color: #dc2626;
        text-align: center;
        font-weight: 900;
        font-size: 15px;
        line-height: 1.5;
        margin-top: 4px;
      }

      .bca-note {
        margin: 0;
        color: #334155;
        font-size: 13px;
        line-height: 1.55;
        font-weight: 700;
      }

      .bca-promo-help {
        margin-top: -6px !important;
        padding: 10px 12px !important;
        border-radius: 12px !important;
        background: #f8fafc !important;
        border: 1px dashed #94a3b8 !important;
        color: #334155 !important;
        font-size: 12px !important;
        line-height: 1.45 !important;
        font-weight: 800 !important;
      }

      .bca-field[data-field="promo_code"] input {
        text-transform: uppercase !important;
        letter-spacing: .6px !important;
        font-weight: 900 !important;
      }

      .bca-promo-field .bca-input-wrap {
        display: grid !important;
        grid-template-columns: minmax(0,1fr) 106px !important;
        gap: 8px !important;
        align-items: stretch !important;
      }

      .bca-promo-field .bca-input-icon {
        left: 12px !important;
      }

      .bca-promo-field input {
        min-width: 0 !important;
      }

      .bca-promo-apply {
        border: 0 !important;
        border-radius: 10px !important;
        background: linear-gradient(180deg,#111827,#020617) !important;
        color: #fff !important;
        font-size: 13px !important;
        font-weight: 1000 !important;
        cursor: pointer !important;
        min-height: 46px !important;
        padding: 0 12px !important;
        box-shadow: 0 5px 14px rgba(15,23,42,.24) !important;
        text-transform: uppercase !important;
        letter-spacing: .4px !important;
      }

      .bca-promo-apply:disabled {
        opacity: .7 !important;
        cursor: not-allowed !important;
      }

      .bca-promo-status {
        display: none;
        margin-top: -6px !important;
        padding: 10px 12px !important;
        border-radius: 12px !important;
        font-size: 12px !important;
        line-height: 1.45 !important;
        font-weight: 900 !important;
      }

      .bca-promo-status.is-visible {
        display: block !important;
      }

      .bca-promo-status.is-ok {
        background: #ecfdf5 !important;
        color: #047857 !important;
        border: 1px solid #86efac !important;
      }

      .bca-promo-status.is-error {
        background: #fff1f2 !important;
        color: #be123c !important;
        border: 1px solid #fecdd3 !important;
      }

      .bca-promo-status.is-info {
        background: #eff6ff !important;
        color: #1d4ed8 !important;
        border: 1px solid #bfdbfe !important;
      }

      @media (max-width: 420px) {
        .bca-promo-field .bca-input-wrap {
          grid-template-columns: 1fr !important;
        }

        .bca-promo-apply {
          width: 100% !important;
        }
      }

      .bca-check {
        display: grid !important;
        grid-template-columns: 48px minmax(0,1fr) !important;
        align-items: center !important;
        gap: 12px !important;
        padding: 14px !important;
        border: 2px solid #d9e2f0 !important;
        border-radius: 16px !important;
        background: linear-gradient(180deg,#fff 0%,#f8fbff 100%) !important;
        box-shadow: 0 8px 22px rgba(15,23,42,.10) !important;
        cursor: pointer !important;
        min-height: 76px !important;
      }

      .bca-check.bca-check-danger {
        border-color: #fecaca !important;
        background: linear-gradient(180deg,#fff 0%,#fff7f7 100%) !important;
      }

      .bca-check input {
        appearance: none !important;
        -webkit-appearance: none !important;
        width: 44px !important;
        height: 44px !important;
        border-radius: 14px !important;
        border: 2px solid #94a3b8 !important;
        background: #fff !important;
        padding: 0 !important;
        margin: 0 !important;
        display: grid !important;
        place-items: center !important;
        cursor: pointer !important;
      }

      .bca-check input:before {
        content: '✓';
        font-size: 28px !important;
        line-height: 1 !important;
        font-weight: 1000 !important;
        color: #fff !important;
        transform: scale(.2) !important;
        opacity: 0 !important;
      }

      .bca-check input:checked {
        border-color: #16a34a !important;
        background: linear-gradient(180deg,#63ff78 0%,#22c55e 55%,#13a93f 100%) !important;
      }

      .bca-check input:checked:before {
        transform: scale(1) !important;
        opacity: 1 !important;
      }

      .bca-check span {
        display: block !important;
        font-size: 14px !important;
        font-weight: 800 !important;
        color: #111827 !important;
      }

      .bca-check-title {
        display: block !important;
        font-size: 14px !important;
        line-height: 1.28 !important;
      }

      .bca-check-hint {
        display: inline-flex !important;
        margin-top: 7px !important;
        padding: 4px 9px !important;
        border-radius: 999px !important;
        background: #ecfdf5 !important;
        color: #047857 !important;
        font-size: 11px !important;
        font-weight: 1000 !important;
        text-transform: uppercase !important;
      }

      .bca-submit,
      .bca-native,
      .bca-addi {
        position: relative !important;
        overflow: hidden !important;
        text-decoration: none !important;
        width: 100% !important;
        min-height: 74px !important;
        border: 0 !important;
        border-radius: 8px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: flex-start !important;
        gap: 14px !important;
        padding: 14px 16px !important;
        cursor: pointer !important;
        font-family: ${CONFIG.theme.fontFamily} !important;
        text-align: left !important;
        line-height: 1.1 !important;
        transition: transform .16s ease, filter .16s ease;
      }

      .bca-alt-payment-stack {
        display: grid;
        gap: 7px;
      }

      .bca-alt-payment-stack .bca-native,
      .bca-alt-payment-stack .bca-addi {
        margin: 0 !important;
      }

      .bca-submit {
        background: linear-gradient(180deg,#ff2b2b 0%,#ef1010 52%,#c40000 100%) !important;
        color: #fff !important;
        box-shadow: 0 10px 26px rgba(255,0,0,.28) !important;
      }

      .bca-form .is-payment-locked {
        filter: saturate(.6) brightness(.86) !important;
        opacity: .82 !important;
      }

      .bca-alt-payment-title {
        margin: 15px 0 8px;
        color: #475569;
        font-size: 12px;
        font-weight: 1000;
        letter-spacing: .7px;
        text-align: center;
        text-transform: uppercase;
      }

      .bca-native {
        background: linear-gradient(180deg,#3526ff 0%,#2718e8 52%,#14008d 100%) !important;
        color: #fff !important;
        box-shadow: 0 10px 26px rgba(46,29,255,.24) !important;
      }

      .bca-addi {
        background: linear-gradient(180deg,#7357ff 0%,#5537e6 55%,#331fae 100%) !important;
        color: #fff !important;
        box-shadow: 0 10px 26px rgba(85,55,230,.3) !important;
      }

      .bca-addi-info {
        margin: 8px 0 0 !important;
        padding: 12px 14px !important;
        border: 1px solid rgba(115,87,255,.45) !important;
        border-radius: 12px !important;
        background: rgba(115,87,255,.08) !important;
        color: #21175f !important;
        font-size: 13px !important;
        line-height: 1.42 !important;
      }

      .bca-addi-info strong { display:block !important; margin-bottom:4px !important; }
      .bca-addi-info span { font-weight:900 !important; }

      .bca-submit:hover,
      .bca-native:hover,
      .bca-addi:hover {
        transform: translateY(-1px);
        filter: brightness(1.02);
      }

      .bca-submit:disabled,
      .bca-addi.is-loading {
        opacity: .68 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
      }

      .bca-btn-ico {
        width: 34px !important;
        min-width: 34px !important;
        height: 34px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 24px !important;
      }

      .bca-btn-text {
        flex: 1 1 auto !important;
        min-width: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        text-align: center !important;
        gap: 4px !important;
      }

      .bca-btn-title {
        display: block !important;
        width: 100% !important;
        margin: 0 !important;
        font-size: 17px !important;
        font-weight: 900 !important;
        line-height: 1.1 !important;
        color: inherit !important;
      }

      .bca-btn-subtitle {
        display: block !important;
        width: 100% !important;
        margin: 0 !important;
        font-size: 13px !important;
        font-weight: 800 !important;
        line-height: 1.18 !important;
        color: inherit !important;
      }

      .bca-message {
        margin: 13px 0 10px;
        font-size: 14px;
        text-align: center;
        font-weight: 900;
        line-height: 1.45;
      }

      .bca-message.ok {
        color: #166534;
      }

      .bca-message.error {
        display: block;
        padding: 16px 13px;
        color: #fff;
        background: linear-gradient(135deg,#ff1838 0%,#c90025 48%,#720015 100%);
        border: 3px solid #ffe145;
        border-radius: 14px;
        box-shadow: 0 0 0 4px rgba(255,38,70,.18),0 0 24px rgba(255,0,42,.58),inset 0 1px 0 rgba(255,255,255,.3);
        text-shadow: 0 2px 2px rgba(0,0,0,.62);
        animation: bcaMissionAlert .45s ease both,bcaModalMissionPulse 1.8s ease-in-out infinite;
      }

      .bca-message.error:before {
        content: '⚠ MISIÓN INCOMPLETA';
        display: block;
        margin-bottom: 7px;
        color: #fff36c;
        font-size: 15px;
        font-weight: 1000;
        letter-spacing: 1px;
      }

      .bca-message.error.minimum-error:after {
        content: 'OBJETIVO: AGREGA 1 CAMISETA O 1 COBIJA';
        display: block;
        margin-top: 9px;
        padding: 8px 9px;
        border-radius: 8px;
        background: #fff36c;
        color: #260009;
        font-size: 13px;
        font-weight: 1000;
        letter-spacing: .35px;
        text-shadow: none;
      }

      @keyframes bcaModalMissionPulse {
        0%,100% { box-shadow:0 0 0 4px rgba(255,38,70,.18),0 0 21px rgba(255,0,42,.52),inset 0 1px 0 rgba(255,255,255,.3); }
        50% { box-shadow:0 0 0 6px rgba(255,225,69,.22),0 0 30px rgba(255,42,54,.82),inset 0 1px 0 rgba(255,255,255,.3); }
      }

      body.bca-modal-open {
        overflow: hidden !important;
      }

      body.bca-modal-open .shopify-section-header,
      body.bca-modal-open header,
      body.bca-modal-open sticky-header,
      body.bca-modal-open .header,
      body.bca-modal-open .site-header {
        z-index: 1 !important;
      }

      .bca-exit {
        position: fixed !important;
        inset: 0 !important;
        display: none !important;
        z-index: 2147483648 !important;
        background: rgba(0,0,0,.68);
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        place-items: center;
        padding: 18px;
      }

      .bca-exit.is-open {
        display: grid !important;
      }

      .bca-exit-card {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        overflow: hidden;
        width: min(390px, calc(100vw - 24px));
        background: linear-gradient(180deg,#081224 0%,#0b1f49 55%,#07101d 100%);
        color: #fff;
        border-radius: 22px;
        text-align: center;
        box-shadow: 0 25px 70px rgba(0,0,0,.42);
        border: 1px solid rgba(73,255,244,.22);
      }

      .bca-exit-top {
        padding: 18px 18px 12px;
      }

      .bca-exit-icon-wrap {
        width: 70px;
        height: 70px;
        border-radius: 999px;
        background: rgba(255,255,255,.10);
        display: grid;
        place-items: center;
        margin: 0 auto 10px;
        border: 1px solid rgba(73,255,244,.44);
        font-size: 34px;
      }

      .bca-exit-card h3 {
        margin: 0;
        font-size: 20px;
        line-height: 1.1;
        color: #5ffff6;
        font-weight: 900;
        text-transform: uppercase;
      }

      .bca-exit-body {
        padding: 16px 20px 20px;
      }

      .bca-exit-card p {
        margin: 0 0 12px;
        color: rgba(255,255,255,.92);
        line-height: 1.58;
        font-size: 15px;
        font-weight: 700;
      }

      .bca-exit-support {
        margin: 0 0 16px;
        color: #f8fafc;
        font-size: 13px;
        line-height: 1.55;
        font-weight: 800;
        background: rgba(255,255,255,.07);
        border: 1px solid rgba(148,163,184,.22);
        border-radius: 12px;
        padding: 12px 14px;
      }

      .bca-exit-actions {
        display: grid;
        gap: 10px;
      }

      .bca-exit-continue,
      .bca-exit-close {
        border: 0;
        border-radius: 12px;
        padding: 14px;
        font-weight: 900;
        cursor: pointer;
        font-size: 15px;
      }

      .bca-exit-continue {
        background: #ff1010;
        color: #fff;
      }

      .bca-exit-close {
        background: #e5e7eb;
        color: #111;
      }

      .bca-thanks {
        position: fixed !important;
        inset: 0 !important;
        z-index: 2147483647 !important;
        display: none !important;
        background: rgba(0,0,0,.76);
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
      }

      .bca-thanks.is-open {
        display: block !important;
      }

      .bca-thanks-card {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        width: min(560px, calc(100vw - 24px));
        max-height: 92vh;
        overflow: auto;
        background: linear-gradient(180deg,#fff 0%,#fbfbfd 100%);
        color: #111;
        border-radius: 24px;
        box-shadow: 0 30px 90px rgba(0,0,0,.45);
        border: 1px solid rgba(226,232,240,.95);
      }

      .bca-thanks-top {
        position: relative;
        overflow: hidden;
        padding: 26px 24px 20px;
        background: linear-gradient(135deg,#071a43 0%,#0b4a8f 48%,#050816 100%);
        color: #fff;
        text-align: center;
      }

      .bca-thanks-logo-wrap {
        width: 82px;
        height: 82px;
        border-radius: 999px;
        background: rgba(255,255,255,.12);
        display: grid;
        place-items: center;
        margin: 0 auto 12px;
        border: 1px solid rgba(73,255,244,.48);
      }

      .bca-thanks-logo {
        width: 68px;
        height: 68px;
        object-fit: contain;
        display: block;
      }

      .bca-thanks-card h3 {
        margin: 0 0 9px;
        font-size: 27px;
        font-weight: 900;
        line-height: 1.12;
        color: #5ffff6;
        text-align: center;
      }

      .bca-thanks-top p {
        margin: 0 auto;
        font-size: 14px;
        line-height: 1.55;
        color: rgba(255,255,255,.98);
        max-width: 455px;
        text-align: center;
        font-weight: 700;
      }

      .bca-thanks-content {
        padding: 20px;
      }

      .bca-thanks-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
        margin: 0 0 14px;
      }

      .bca-thanks-info-box {
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        background: #f8fafc;
        padding: 14px 15px;
        display: grid;
        gap: 5px;
      }

      .bca-thanks-info-box strong {
        font-size: 15px;
        color: #111;
        line-height: 1.25;
      }

      .bca-thanks-info-box span {
        font-size: 13px;
        color: #475569;
        line-height: 1.5;
      }

      .bca-thanks-summary {
        display: none;
        margin: 14px 0;
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        overflow: hidden;
        background: #fff;
      }

      .bca-thanks-summary.is-open {
        display: block;
      }

      .bca-thanks-summary h4 {
        margin: 0;
        padding: 13px 15px;
        background: #eef2f7;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: .8px;
        color: #111;
      }

      .bca-thanks-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding: 11px 15px;
        border-top: 1px solid #edf2f7;
        font-size: 13px;
      }

      .bca-thanks-row span {
        color: #555;
      }

      .bca-thanks-row strong {
        color: #111;
        text-align: right;
        word-break: break-word;
        max-width: 68%;
        line-height: 1.4;
      }

      .bca-thanks-actions {
        display: grid;
        gap: 10px;
        margin-top: 16px;
      }

      .bca-thanks-close,
      .bca-thanks-continue {
        border: 0;
        border-radius: 13px;
        padding: 15px 16px;
        font-weight: 900;
        cursor: pointer;
        text-decoration: none;
        display: block;
        text-align: center;
        font-size: 15px;
      }

      .bca-thanks-close {
        background: #ff1a1a;
        color: #fff;
      }

      .bca-thanks-continue {
        background: #eef2f7;
        color: #111;
      }

      @media (min-width: 680px) {
        .bca-thanks-grid {
          grid-template-columns: 1fr 1fr;
        }
      }

      @media (max-width: 620px) {
        .bca-panel {
          top: 50% !important;
          left: 50% !important;
          right: auto !important;
          bottom: auto !important;
          width: calc(100vw - 16px) !important;
          max-width: calc(100vw - 16px) !important;
          height: auto !important;
          max-height: calc(100dvh - 16px) !important;
          transform: translate(-50%, -50%) !important;
          border-radius: 18px !important;
        }

        .bca-head {
          min-height: 58px !important;
          padding: 10px 14px !important;
        }

        .bca-head-title {
          font-size: 19px !important;
        }

        .bca-head-subtitle {
          display: none !important;
        }

        .bca-body {
          height: auto !important;
          max-height: calc(100dvh - 90px) !important;
          padding: 18px 14px 24px !important;
        }

        .bca-banner {
          max-height: 190px !important;
          border-radius: 10px !important;
          margin-bottom: 14px !important;
        }

        .bca-item {
          grid-template-columns: 74px minmax(0,1fr) 34px !important;
          gap: 10px !important;
          padding: 13px 12px !important;
        }

        .bca-img-wrap,
        .bca-item img {
          width: 60px !important;
          height: 60px !important;
        }

        .bca-item-title {
          font-size: 16px !important;
        }

        .bca-submit,
        .bca-native,
        .bca-addi {
          min-height: 68px !important;
          padding: 12px 14px !important;
          gap: 12px !important;
        }

        .bca-btn-title {
          font-size: 15px !important;
        }

        .bca-btn-subtitle {
          font-size: 12px !important;
        }

        .bca-check {
          grid-template-columns: 46px minmax(0,1fr) !important;
          min-height: 74px !important;
          padding: 13px 12px !important;
        }

        .bca-check input {
          width: 42px !important;
          height: 42px !important;
        }

        .bca-thanks-card {
          width: calc(100vw - 16px) !important;
          max-width: calc(100vw - 16px) !important;
          max-height: calc(100dvh - 16px) !important;
          border-radius: 22px !important;
        }

        .bca-thanks-top {
          padding: 20px 16px 15px !important;
        }

        .bca-thanks-card h3 {
          font-size: 22px !important;
        }

        .bca-thanks-top p {
          font-size: 13px !important;
        }

        .bca-thanks-content {
          padding: 14px 14px 18px !important;
        }

        .bca-exit-card {
          width: calc(100vw - 16px) !important;
          max-width: calc(100vw - 16px) !important;
        }
      }
      /* v81-6: legibilidad gamer robusta en Chrome/PC/móvil */
      .bca-panel,.bca-body,.bca-form{color-scheme:light!important;}
      .bca-panel,.bca-body{background:#fff!important;color:#07111f!important;}
      .bca-field{color:#07111f!important;font-weight:800!important;letter-spacing:.18px!important;}
      .bca-label-text{color:#07111f!important;-webkit-text-fill-color:#07111f!important;font-weight:900!important;text-shadow:0 0 10px rgba(0,210,255,.14)!important;}
      .bca-form input,.bca-form textarea{background:#f7fbff!important;color:#07111f!important;-webkit-text-fill-color:#07111f!important;font-weight:650!important;border-color:#9fb6c7!important;}
      .bca-form input::placeholder,.bca-form textarea::placeholder{color:#66788a!important;-webkit-text-fill-color:#66788a!important;opacity:1!important;}
      .bca-form input:focus,.bca-form textarea:focus{background:#fff!important;border-color:#00cfe8!important;box-shadow:0 0 0 2px rgba(0,207,232,.22),0 0 15px rgba(0,207,232,.18)!important;}
      .bca-select-btn{background:#06111f!important;border:1px solid #18dff5!important;color:#e9fdff!important;-webkit-text-fill-color:#e9fdff!important;box-shadow:0 0 0 1px rgba(24,223,245,.12),0 4px 12px rgba(0,0,0,.22)!important;}
      .bca-select-btn span:not(.ph){color:#bff8ff!important;-webkit-text-fill-color:#bff8ff!important;font-weight:900!important;letter-spacing:.25px!important;text-shadow:0 0 8px rgba(24,223,245,.48)!important;}
      .bca-select-btn .ph{color:#aab9c9!important;-webkit-text-fill-color:#aab9c9!important;font-weight:700!important;}
      .bca-select-btn:after,.bca-select .bca-input-icon{color:#32efff!important;-webkit-text-fill-color:#32efff!important;text-shadow:0 0 7px rgba(50,239,255,.55)!important;}
      .bca-options,.bca-search-box,.bca-option-list{background:#071522!important;color:#effeff!important;border-color:#18dff5!important;}
      .bca-search-input{background:#0b1d2d!important;color:#f4feff!important;-webkit-text-fill-color:#f4feff!important;border-color:#28798a!important;}
      .bca-search-input::placeholder{color:#adc4d2!important;-webkit-text-fill-color:#adc4d2!important;opacity:1!important;}
      .bca-option{background:#071522!important;color:#eefeff!important;-webkit-text-fill-color:#eefeff!important;font-weight:800!important;border-bottom:1px solid rgba(50,239,255,.08)!important;}
      .bca-option:hover,.bca-option.active{background:#19e5f5!important;color:#001018!important;-webkit-text-fill-color:#001018!important;text-shadow:none!important;}
      .bca-option.bca-option-special{background:#0b2832!important;color:#9ff7ff!important;-webkit-text-fill-color:#9ff7ff!important;border-color:#20dff2!important;}

      /* v81-7: formulario gamer oscuro nativo + máxima legibilidad */
      .bca-panel,.bca-head,.bca-body,.bca-form{color-scheme:dark only!important;}
      .bca-panel,.bca-body{background:#07111d!important;color:#f3feff!important;}
      .bca-head{background:#050d18!important;color:#f7ffff!important;border-bottom:1px solid #176777!important;}
      .bca-head-title{color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;font-weight:950!important;letter-spacing:.35px!important;}
      .bca-head-subtitle{color:#b9d9e5!important;-webkit-text-fill-color:#b9d9e5!important;opacity:1!important;}
      .bca-close{background:#081522!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;border:1px solid #2ddff4!important;}
      .bca-body,.bca-form,.bca-field{color:#f3feff!important;-webkit-text-fill-color:#f3feff!important;}
      .bca-field{font-weight:850!important;letter-spacing:.18px!important;}
      .bca-label-text{color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;font-weight:950!important;text-shadow:0 0 9px rgba(46,231,255,.28)!important;}
      .bca-required{color:#ff315d!important;-webkit-text-fill-color:#ff315d!important;text-shadow:0 0 8px rgba(255,49,93,.42)!important;}
      .bca-form h3{background:linear-gradient(90deg,#0d2030,#17213a,#0d2030)!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;border-color:#8b5cf6!important;text-shadow:0 0 10px rgba(139,92,246,.38)!important;}
      .bca-form input,.bca-form textarea{background:#081827!important;color:#f7ffff!important;-webkit-text-fill-color:#f7ffff!important;caret-color:#35efff!important;font-weight:850!important;border:1px solid #36dff2!important;box-shadow:0 0 0 1px rgba(54,223,242,.12),0 4px 14px rgba(0,0,0,.28)!important;opacity:1!important;}
      .bca-form input::placeholder,.bca-form textarea::placeholder{color:#a8cad7!important;-webkit-text-fill-color:#a8cad7!important;opacity:1!important;font-weight:700!important;}
      .bca-form input:focus,.bca-form textarea:focus{background:#0a2030!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;border-color:#39f3ff!important;box-shadow:0 0 0 2px rgba(57,243,255,.28),0 0 18px rgba(57,243,255,.26)!important;}
      .bca-form input:-webkit-autofill,.bca-form input:-webkit-autofill:hover,.bca-form input:-webkit-autofill:focus{-webkit-text-fill-color:#f7ffff!important;caret-color:#35efff!important;-webkit-box-shadow:0 0 0 1000px #081827 inset!important;box-shadow:0 0 0 1000px #081827 inset!important;border:1px solid #36dff2!important;transition:background-color 9999s ease-out 0s!important;}
      .bca-input-icon{color:#54efff!important;-webkit-text-fill-color:#54efff!important;filter:drop-shadow(0 0 5px rgba(84,239,255,.35));}
      .bca-note,.bca-promo-help,.bca-check-title,.bca-check-hint,.bca-warning,.bca-promo-status{color:#e9fbff!important;-webkit-text-fill-color:#e9fbff!important;opacity:1!important;}
      .bca-promo-help{background:#0b1b2a!important;border-color:#4f7890!important;}
      .bca-field-error{color:#ff6685!important;-webkit-text-fill-color:#ff6685!important;font-weight:900!important;text-shadow:0 0 8px rgba(255,102,133,.3)!important;}
      .bca-location-help{background:#0a2231!important;color:#8defff!important;-webkit-text-fill-color:#8defff!important;border-color:#2ad7ea!important;font-weight:900!important;}
      .bca-location-help.is-selected{background:#082a24!important;color:#8bffd0!important;-webkit-text-fill-color:#8bffd0!important;border-color:#3fe6a9!important;}
      .bca-select-btn{background:#06111f!important;color:#e9fdff!important;-webkit-text-fill-color:#e9fdff!important;border-color:#18dff5!important;}
      .bca-select-btn span:not(.ph){color:#c9fbff!important;-webkit-text-fill-color:#c9fbff!important;font-weight:950!important;text-shadow:0 0 8px rgba(24,223,245,.48)!important;}
      .bca-select-btn .ph{color:#abc8d4!important;-webkit-text-fill-color:#abc8d4!important;font-weight:750!important;opacity:1!important;}
      .bca-options,.bca-search-box,.bca-option-list{background:#071522!important;color:#effeff!important;border-color:#18dff5!important;}
      .bca-search-input{background:#0a1c2b!important;color:#ffffff!important;-webkit-text-fill-color:#ffffff!important;border-color:#2ddff4!important;}
      .bca-search-input::placeholder{color:#a9c9d7!important;-webkit-text-fill-color:#a9c9d7!important;opacity:1!important;}
      .bca-option{background:#071522!important;color:#f2feff!important;-webkit-text-fill-color:#f2feff!important;font-weight:850!important;}
      .bca-option:hover,.bca-option.active{background:#28e6f4!important;color:#001018!important;-webkit-text-fill-color:#001018!important;}
      .bca-option.bca-option-special{background:#0b2a35!important;color:#a6fbff!important;-webkit-text-fill-color:#a6fbff!important;border-color:#27e6f5!important;}
      .bca-check{background:#0b1a29!important;color:#f3feff!important;border-color:#365c73!important;}
      .bca-check *{color:#f3feff!important;-webkit-text-fill-color:#f3feff!important;opacity:1!important;}
      .bca-check-danger{background:#28131a!important;border-color:#a83a57!important;}
      .bca-body p,.bca-body li,.bca-body small,.bca-body em,.bca-body strong{opacity:1!important;}

      /* v81-10: WhatsApp inline + texto máximo contraste */
      .bca-form,.bca-field,.bca-select-btn,.bca-form input,.bca-form textarea{font-family:Arial,"Helvetica Neue",sans-serif!important;text-rendering:optimizeLegibility!important;}
      .bca-form h3{font-family:"Arial Black",Arial,sans-serif!important;font-size:21px!important;letter-spacing:.65px!important;color:#fff!important;-webkit-text-fill-color:#fff!important;text-shadow:0 0 3px rgba(57,243,255,.22)!important;}
      .bca-label-text{font-family:Arial,"Helvetica Neue",sans-serif!important;font-size:15px!important;font-weight:900!important;color:#fff!important;-webkit-text-fill-color:#fff!important;text-shadow:none!important;}
      .bca-form input,.bca-form textarea{font-size:16px!important;font-weight:800!important;letter-spacing:.05px!important;color:#fff!important;-webkit-text-fill-color:#fff!important;text-shadow:none!important;}
      .bca-form input::placeholder,.bca-form textarea::placeholder{color:#c7dce5!important;-webkit-text-fill-color:#c7dce5!important;font-weight:700!important;opacity:1!important;text-shadow:none!important;}
      .bca-select-btn span:not(.ph){font-size:16px!important;font-weight:900!important;color:#e1fdff!important;-webkit-text-fill-color:#e1fdff!important;text-shadow:none!important;}
      .bca-note,.bca-promo-help,.bca-location-help,.bca-field-error,.bca-check-title,.bca-check-hint{font-family:Arial,"Helvetica Neue",sans-serif!important;text-shadow:none!important;}
      .bca-icon-svg{width:23px!important;height:23px!important;display:block!important;overflow:visible!important;flex:0 0 23px!important;}
      .bca-icon-whatsapp{filter:drop-shadow(0 0 2px rgba(37,211,102,.30))!important;}
      .bca-field[data-field="phone"] .bca-input-icon{width:24px!important;height:24px!important;min-width:24px!important;display:grid!important;place-items:center!important;filter:none!important;}
      @media(max-width:749px){.bca-form h3{font-size:19px!important;letter-spacing:.45px!important}.bca-label-text{font-size:15px!important}.bca-form input,.bca-form textarea,.bca-select-btn span:not(.ph){font-size:16px!important;}}

      /* v81-12: contraste total bloque pedido y envío */\n      .bca-section-title h3{color:#fff!important;-webkit-text-fill-color:#fff!important;font-family:"Arial Black",Arial,sans-serif!important;text-shadow:none!important;}\n      .bca-update-cart{color:#8df6ff!important;-webkit-text-fill-color:#8df6ff!important;font-weight:900!important;text-shadow:none!important;}\n      .bca-summary{background:#0b1a29!important;color:#fff!important;border:1px solid #315d73!important;box-shadow:none!important;}\n      .bca-summary .bca-row,.bca-summary .bca-total,.bca-summary span,.bca-summary strong{color:#fff!important;-webkit-text-fill-color:#fff!important;text-shadow:none!important;opacity:1!important;}\n      .bca-small-title{color:#fff!important;-webkit-text-fill-color:#fff!important;font-weight:900!important;text-shadow:none!important;}\n      .bca-method-card{background:#0b1a29!important;color:#fff!important;border:1.5px solid #35e5f5!important;box-shadow:0 0 0 1px rgba(53,229,245,.08)!important;}\n      .bca-method-card strong,.bca-method-card span{color:#fff!important;-webkit-text-fill-color:#fff!important;text-shadow:none!important;opacity:1!important;}\n      #bca-method-price{color:#dffcff!important;-webkit-text-fill-color:#dffcff!important;}\n\n      /* v81-8: cierre de contraste en confirmaciones + tipografía móvil */
      .bca-check.bca-check-danger{background:#28131a!important;background-image:none!important;border:1px solid #b94765!important;color:#f7ffff!important;-webkit-text-fill-color:#f7ffff!important;}
      .bca-check.bca-check-danger *{color:#f7ffff!important;-webkit-text-fill-color:#f7ffff!important;opacity:1!important;}
      .bca-check.bca-check-danger .bca-check-hint{background:#173326!important;color:#caffdf!important;-webkit-text-fill-color:#caffdf!important;}
      @media(max-width:749px){
        .bca-form input,.bca-form textarea,.bca-select-btn,.bca-search-input{font-size:16px!important;}
        .bca-label-text{font-size:14px!important;line-height:1.25!important;}
        .bca-note,.bca-promo-help,.bca-location-help,.bca-field-error{font-size:13px!important;line-height:1.45!important;}
      }

      /* v81-13: producto/carrito gamer, controles de cantidad visibles */
      .bca-items{gap:12px!important;}
      .bca-item{min-width:0!important;background:linear-gradient(135deg,#071522 0%,#08101e 100%)!important;color:#f7ffff!important;border:1px solid #1fe5f5!important;border-left:4px solid #39f3ff!important;border-radius:10px!important;box-shadow:inset 0 0 18px rgba(24,223,245,.045),0 5px 16px rgba(0,0,0,.22)!important;}
      .bca-item-title{color:#fff!important;-webkit-text-fill-color:#fff!important;font-weight:900!important;text-shadow:none!important;}
      .bca-item-variant{color:#cde7f2!important;-webkit-text-fill-color:#cde7f2!important;font-weight:750!important;text-shadow:none!important;}
      .bca-item-price{color:#9cf400!important;-webkit-text-fill-color:#9cf400!important;font-weight:950!important;text-shadow:none!important;}
      .bca-badge{background:#17283a!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border:1px solid #63efff!important;box-shadow:0 0 7px rgba(99,239,255,.25)!important;}
      .bca-remove{background:#25131d!important;color:#ff8da6!important;-webkit-text-fill-color:#ff8da6!important;border:1px solid #ff4d73!important;border-radius:8px!important;font-size:25px!important;font-weight:950!important;text-shadow:none!important;box-shadow:inset 0 0 10px rgba(255,77,115,.08)!important;}
      .bca-qty{display:inline-flex!important;align-items:center!important;width:max-content!important;min-height:36px!important;margin-top:8px!important;overflow:hidden!important;background:#030b15!important;border:1px solid #24dff2!important;border-radius:8px!important;box-shadow:0 0 0 1px rgba(36,223,242,.08),inset 0 0 12px rgba(36,223,242,.04)!important;}
      .bca-qty button{display:grid!important;place-items:center!important;width:38px!important;height:36px!important;min-width:38px!important;padding:0!important;border:0!important;font-family:Arial,"Helvetica Neue",sans-serif!important;font-size:23px!important;font-weight:950!important;line-height:1!important;opacity:1!important;text-shadow:none!important;cursor:pointer!important;}
      .bca-qty button[data-action="minus"]{background:#28131d!important;color:#ff7896!important;-webkit-text-fill-color:#ff7896!important;border-right:1px solid #24dff2!important;}
      .bca-qty button[data-action="plus"]{background:#102414!important;color:#b4ff58!important;-webkit-text-fill-color:#b4ff58!important;border-left:1px solid #24dff2!important;}
      .bca-qty button:hover,.bca-qty button:focus-visible{filter:brightness(1.22)!important;outline:2px solid #fff!important;outline-offset:-3px!important;}
      .bca-qty span{display:grid!important;place-items:center!important;width:40px!important;height:36px!important;background:#071522!important;color:#fff!important;-webkit-text-fill-color:#fff!important;border:0!important;font-family:Arial,"Helvetica Neue",sans-serif!important;font-size:16px!important;font-weight:950!important;line-height:1!important;opacity:1!important;text-shadow:none!important;}
      @media(max-width:749px){.bca-item{grid-template-columns:60px minmax(0,1fr) 38px!important;gap:10px!important;padding:11px 10px!important}.bca-qty button{width:40px!important;min-width:40px!important;height:38px!important;font-size:24px!important}.bca-qty span{width:42px!important;height:38px!important;font-size:17px!important}.bca-remove{width:38px!important;height:38px!important;}}

    `;

    document.head.appendChild(style);
    state.modalCssLoaded = true;
  }

  function renderInitialButton() {
    setBaseCss();

    var mounts = qsa('#bca-cod-mount');

    if (!mounts.length) {
      var buyButtons = document.querySelector([
        'product-info .product-form__buttons',
        '.product-form__buttons',
        'form[action*="/cart/add"] .product-form__buttons',
        'product-form',
        '.product__info-container',
        '.product-information',
        '.quick-add-modal__content-info product-info',
        '.quick-add-modal__content-info .product-form__buttons'
      ].join(','));

      if (buyButtons) {
        var fallback = document.createElement('div');
        fallback.id = 'bca-cod-mount';

        if (buyButtons.classList && buyButtons.classList.contains('product-form__buttons')) {
          buyButtons.insertAdjacentElement('afterend', fallback);
        } else {
          buyButtons.appendChild(fallback);
        }

        mounts = [fallback];
      }
    }

    if (!mounts.length) return;

    var oldRoot = qs('#bca-cod-root');

    if (oldRoot) {
      oldRoot.remove();
    }

    for (var i = 1; i < mounts.length; i++) {
      mounts[i].remove();
    }

    mounts[0].outerHTML =
      '<div id="bca-cod-root" class="bca-cod-root">' +
        '<button type="button" id="bca-open-modal" class="bca-open-modal bca-has-scan">' +
          '<span>🚚</span>' +
          '<span>' +
            '<strong>' + escapeHtml(CONFIG.texts.openButtonTitle) + '</strong>' +
            '<small>' + escapeHtml(CONFIG.texts.openButtonSubtitle) + '</small>' +
          '</span>' +
        '</button>' +
        (CONFIG.nativeCheckout.enabled ? '<button type="button" id="bca-open-native" class="bca-open-modal bca-open-native bca-has-scan is-payment-locked" disabled aria-disabled="true"><span>' + CONFIG.nativeCheckout.icon + '</span><span><strong>' + escapeHtml(CONFIG.nativeCheckout.openButtonText) + '</strong><small>' + escapeHtml(CONFIG.nativeCheckout.openButtonSubtitle) + '</small></span></button>' : '') +
        (CONFIG.addiCheckout.enabled ? '<button type="button" id="bca-open-addi" class="bca-open-modal bca-open-addi bca-has-scan is-payment-locked" disabled aria-disabled="true"><span>' + CONFIG.addiCheckout.icon + '</span><span><strong>' + escapeHtml(CONFIG.addiCheckout.openButtonText) + '</strong><small>' + escapeHtml(CONFIG.addiCheckout.openButtonSubtitle) + '</small></span></button>' : '') +
      '</div>';

    var openBtn = qs('#bca-open-modal');

    if (openBtn && !openBtn.dataset.bound) {
      openBtn.dataset.bound = 'true';
      openBtn.addEventListener('click', function (event) {
        state.preferredPaymentRoute = 'cod';
        openModal(event);
      }, true);
    }

    var openNativeBtn = qs('#bca-open-native');

    if (openNativeBtn && !openNativeBtn.dataset.bound) {
      openNativeBtn.dataset.bound = 'true';
      openNativeBtn.addEventListener('click', function (event) {
        state.preferredPaymentRoute = 'native';
        goNativeCheckout(event);
      }, true);
    }

    var openAddiBtn = qs('#bca-open-addi');

    if (openAddiBtn && !openAddiBtn.dataset.bound) {
      openAddiBtn.dataset.bound = 'true';
      openAddiBtn.addEventListener('click', function (event) {
        state.preferredPaymentRoute = 'addi';
        goAddiCheckout(event, { skipFormValidation: true });
      }, true);
    }

    var productCodButton = qs('[data-bca-product-cod-button], .bca-product-cod-button, .bca-cart-only-cod-button');

    if (productCodButton && !productCodButton.classList.contains('bca-cart-only-cod-button')) {
      var cleanCodButton = document.createElement('a');
      var cleanClasses = Array.prototype.filter.call(productCodButton.classList || [], function (className) {
        return className !== 'bca-product-cod-button';
      });

      cleanCodButton.href = '#';
      cleanCodButton.className = cleanClasses.join(' ') + ' bca-cart-only-cod-button';
      cleanCodButton.innerHTML = productCodButton.innerHTML;
      cleanCodButton.setAttribute('role', 'button');
      cleanCodButton.setAttribute('aria-label', 'Pagar contraentrega con los productos del carrito');
      productCodButton.replaceWith(cleanCodButton);
      productCodButton = cleanCodButton;
    }

    if (productCodButton && (openNativeBtn || openAddiBtn)) {
      var productActions = qs('#bca-product-payment-actions');

      if (!productActions) {
        productActions = document.createElement('div');
        productActions.id = 'bca-product-payment-actions';
        productActions.className = 'bca-product-payment-actions';
        productCodButton.insertAdjacentElement('afterend', productActions);
      }

      var paymentConsole = qs('#bca-payment-console');
      if (!paymentConsole) {
        paymentConsole = document.createElement('section');
        paymentConsole.id = 'bca-payment-console';
        paymentConsole.className = 'bca-payment-console';
        paymentConsole.setAttribute('aria-label', 'Opciones de pago');
        productCodButton.parentNode.insertBefore(paymentConsole, productCodButton);
        paymentConsole.innerHTML =
          '<div class="bca-payment-console-head">' +
            '<span class="bca-console-icon">🎮</span>' +
            '<span><strong>Elige cómo quieres pagar</strong><small>Compra segura · selecciona la opción que prefieras</small></span>' +
          '</div>' +
          '<div id="bca-payment-minimum" class="bca-payment-minimum" role="status"></div>' +
          '<div class="bca-order-intel"><span>⏳</span><span><strong>Antes de confirmar la misión</strong><small>Tu pedido se confirma el siguiente día hábil y la entrega estimada tarda de 3 a 7 días hábiles. Revisa cuidadosamente talla, material y datos antes de continuar.</small><em>Sábados, domingos y festivos no tenemos atención.</em></span></div>';
        paymentConsole.appendChild(productCodButton);
        paymentConsole.appendChild(productActions);
      }

      if (openNativeBtn) productActions.appendChild(openNativeBtn);
      if (openNativeBtn && !qs('#bca-prepaid-eligibility')) {
        var prepaidEligibility = document.createElement('div');
        prepaidEligibility.id = 'bca-prepaid-eligibility';
        prepaidEligibility.className = 'bca-payment-eligibility';
        prepaidEligibility.setAttribute('role', 'status');
        productActions.appendChild(prepaidEligibility);
      }
      if (openAddiBtn) productActions.appendChild(openAddiBtn);
      if (openAddiBtn && !qs('#bca-addi-eligibility')) {
        var addiEligibility = document.createElement('div');
        addiEligibility.id = 'bca-addi-eligibility';
        addiEligibility.className = 'bca-payment-eligibility';
        addiEligibility.setAttribute('role', 'status');
        productActions.appendChild(addiEligibility);
      }

      if (openAddiBtn && !qs('#bca-addi-fee-note')) {
        var addiFeeNote = document.createElement('div');
        addiFeeNote.id = 'bca-addi-fee-note';
        addiFeeNote.className = 'bca-addi-fee-note';
        addiFeeNote.innerHTML = '<span>💡</span><span><strong>Financiación con Addi</strong><small>Esta opción incluye un ajuste del 6,8%, informado antes de pagar.</small></span>';
        productActions.appendChild(addiFeeNote);
      }

      var directMessage = qs('#bca-direct-payment-message');
      if (!directMessage) {
        directMessage = document.createElement('p');
        directMessage.id = 'bca-direct-payment-message';
        directMessage.className = 'bca-direct-payment-message';
        directMessage.setAttribute('role', 'status');
        directMessage.setAttribute('aria-live', 'polite');
        productActions.appendChild(directMessage);
      }

      var globalRoot = qs('#bca-cod-root');
      if (globalRoot) globalRoot.style.display = 'none';

      lockPaymentControlsForCartRefresh('payment_controls_rendered');
      scheduleLiveCartProgressRefresh('payment_controls_rendered', 0);
    }

    if (productCodButton && !productCodButton.dataset.bcaCartOnlyBound) {
      productCodButton.dataset.bcaCartOnlyBound = 'true';
      productCodButton.addEventListener('click', openCodFromCartOnly, true);
    }
  }

  function labelHtml(name) {
    var f = CONFIG.fields[name];

    return '<span class="bca-label-text">' +
      escapeHtml(f.label) +
      (f.required ? '<span class="bca-required">*</span>' : '') +
    '</span>';
  }

  function inputField(name, type) {
    var f = CONFIG.fields[name];
    var attrs = '';

    if (name === 'phone') attrs += ' inputmode="numeric" autocomplete="tel" maxlength="10"';
    if (name === 'email') attrs += ' autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false"';
    if (name === 'promo_code') attrs += ' autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="40"';
    if (name === 'first_name') attrs += ' autocomplete="given-name"';
    if (name === 'last_name') attrs += ' autocomplete="family-name"';
    if (name === 'address1') attrs += ' autocomplete="address-line1"';
    if (name === 'address2') attrs += ' autocomplete="address-line2"';

    var error = name === 'phone'
      ? CONFIG.texts.phoneError
      : (name === 'email' ? CONFIG.texts.emailError : 'Este campo es obligatorio.');

    return '<label class="bca-field" data-field="' + name + '">' +
      labelHtml(name) +
      '<span class="bca-input-wrap">' +
        '<span class="bca-input-icon">' + iconHtml(f.iconKey) + '</span>' +
        '<input type="' + type + '" name="' + name + '" placeholder="' + escapeHtml(f.placeholder) + '"' + attrs + (f.required ? ' required' : '') + '>' +
      '</span>' +
      '<span class="bca-field-error">' + escapeHtml(error) + '</span>' +
    '</label>';
  }

  function promoFieldHtml() {
    var f = CONFIG.fields.promo_code;

    return '<label class="bca-field bca-promo-field" data-field="promo_code">' +
      labelHtml('promo_code') +
      '<span class="bca-input-wrap">' +
        '<span class="bca-input-icon">' + iconHtml(f.iconKey) + '</span>' +
        '<input type="text" name="promo_code" placeholder="' + escapeHtml(f.placeholder) + '" autocomplete="off" autocapitalize="characters" spellcheck="false" maxlength="40">' +
        '<button type="button" id="bca-apply-promo" class="bca-promo-apply">' + escapeHtml(CONFIG.texts.promoApplyButton) + '</button>' +
      '</span>' +
      '<span class="bca-field-error">' + escapeHtml(CONFIG.texts.promoInvalid) + '</span>' +
    '</label>';
  }

  function renderOptions(options) {
    return options && options.length
      ? options.map(function (o) {
          return '<div class="bca-option" data-value="' + escapeHtml(o) + '">' + escapeHtml(o) + '</div>';
        }).join('')
      : '<div class="bca-no-results">' + escapeHtml(CONFIG.texts.noResults) + '</div>';
  }

  function isCundinamarcaSelected() {
    var provinceInput = qs('[name="province"]');
    return normalizeLocationKey(provinceInput ? provinceInput.value : '') === 'cundinamarca';
  }

  function shouldShowBogotaSwitch(searchTerm) {
    var term = normalizeLocationKey(searchTerm || '');

    if (!isCundinamarcaSelected()) return false;
    if (!term) return true;

    return 'bogota'.indexOf(term) > -1 || term.indexOf('bogota') > -1;
  }

  function renderSelectOptions(name, options, searchTerm) {
    var special = '';

    if (name === 'city' && shouldShowBogotaSwitch(searchTerm)) {
      special = '<div class="bca-option bca-option-special" data-bca-switch-bogota="true" role="button" tabindex="0">' +
        escapeHtml(CONFIG.texts.bogotaCitySwitch) +
      '</div>';
    }

    if (options && options.length) {
      return special + renderOptions(options);
    }

    return special || '<div class="bca-no-results">' + escapeHtml(CONFIG.texts.noResults) + '</div>';
  }

  function setBogotaHelp(selected) {
    var help = qs('#bca-bogota-department-help');

    if (!help) return;

    help.textContent = selected ? CONFIG.texts.bogotaSelected : CONFIG.texts.bogotaDepartmentHelp;
    help.classList.toggle('is-selected', !!selected);
  }

  function switchToBogotaDc() {
    var provinceSelect = qs('.bca-select[data-select="province"]');
    var citySelect = qs('.bca-select[data-select="city"]');

    if (!provinceSelect || !citySelect) return;

    selectValue(provinceSelect, 'Bogotá D.C.');
    populateCities('Bogotá D.C.');
    selectValue(citySelect, 'Bogotá D.C.');
    setBogotaHelp(true);
    renderTotals();
  }

  function customSelectField(name, options, disabled) {
    var f = CONFIG.fields[name];
    var dir = f.dropdownDirection || 'down';
    var search = name === 'province' ? CONFIG.texts.searchDepartment : CONFIG.texts.searchCity;

    var locationHelp = name === 'province'
      ? '<span id="bca-bogota-department-help" class="bca-location-help">' + escapeHtml(CONFIG.texts.bogotaDepartmentHelp) + '</span>'
      : '';

    return '<label class="bca-field" data-field="' + name + '">' +
      labelHtml(name) +
      '<div class="bca-select ' + (disabled ? 'is-disabled' : '') + '" data-select="' + name + '" data-dir="' + dir + '">' +
        '<span class="bca-input-icon">' + iconHtml(f.iconKey) + '</span>' +
        '<button type="button" class="bca-select-btn" ' + (disabled ? 'disabled' : '') + '><span class="ph">' + escapeHtml(f.placeholder) + '</span></button>' +
        '<input type="hidden" name="' + name + '"' + (f.required ? ' required' : '') + '>' +
        '<div class="bca-options">' +
          '<div class="bca-search-box"><input type="text" class="bca-search-input" placeholder="' + escapeHtml(search) + '">' + '</div>' +
          '<div class="bca-option-list">' + renderSelectOptions(name, options || [], '') + '</div>' +
        '</div>' +
      '</div>' +
      locationHelp +
      '<span class="bca-field-error">Este campo es obligatorio.</span>' +
    '</label>';
  }

  function checkHtml(c, i) {
    return '<label class="bca-check' + (i === 1 ? ' bca-check-danger' : '') + '">' +
      '<input name="' + escapeHtml(c.name) + '" type="checkbox"' + (c.required ? ' required' : '') + '>' +
      '<span>' +
        '<strong class="bca-check-title">' + escapeHtml(c.text) + '</strong>' +
        '<em class="bca-check-hint">Toca el cuadro para marcar ✓</em>' +
      '</span>' +
    '</label>';
  }

  function ensureModalRendered() {
    setModalCss();

    var existingModal = qs('#bca-modal');
    var existingExit = qs('#bca-exit');
    var existingThanks = qs('#bca-thanks');

    if (existingModal && existingModal.parentNode !== document.body) {
      document.body.appendChild(existingModal);
    }

    if (existingExit && existingExit.parentNode !== document.body) {
      document.body.appendChild(existingExit);
    }

    if (existingThanks && existingThanks.parentNode !== document.body) {
      document.body.appendChild(existingThanks);
    }

    if (qs('#bca-modal') && qs('#bca-thanks') && qs('#bca-exit')) {
      state.modalRendered = true;
      bindEvents();
      return;
    }

    var fields =
      inputField('first_name', 'text') +
      inputField('last_name', 'text') +
      inputField('phone', 'tel') +
      inputField('address1', 'text');

    if (CONFIG.addressGuide.enabled) {
      fields += '<img class="bca-address-guide-img bca-lazy-media" src="" data-bca-src="' + escapeHtml(CONFIG.addressGuide.imageUrl) + '" alt="' + escapeHtml(CONFIG.addressGuide.imageAlt) + '" loading="lazy" decoding="async" style="display:none">';
    }

    fields +=
      inputField('address2', 'text') +
      customSelectField('province', CONFIG.locations.departments, false) +
      customSelectField('city', [], true) +
      inputField('email', 'email') +
      promoFieldHtml() +
      '<p id="bca-promo-status" class="bca-promo-status" role="status" aria-live="polite"></p>' +
      '<p class="bca-note bca-promo-help">' + escapeHtml(CONFIG.texts.promoHelp) + '</p>';

    var nativeBtn = CONFIG.nativeCheckout.enabled
      ? '<a id="bca-native-checkout" class="bca-native is-payment-locked" href="#" aria-disabled="true" tabindex="-1"><span class="bca-btn-ico">' + CONFIG.nativeCheckout.icon + '</span><span class="bca-btn-text"><strong class="bca-btn-title">' + escapeHtml(CONFIG.nativeCheckout.buttonText) + '</strong><small class="bca-btn-subtitle">' + escapeHtml(CONFIG.nativeCheckout.subtitle) + '</small></span></a>'
      : '';

    var addiBtn = CONFIG.addiCheckout.enabled
      ? '<a id="bca-addi-checkout" class="bca-addi is-payment-locked" href="#" aria-disabled="true" tabindex="-1"><span class="bca-btn-ico">' + CONFIG.addiCheckout.icon + '</span><span class="bca-btn-text"><strong class="bca-btn-title">' + escapeHtml(CONFIG.addiCheckout.buttonText) + '</strong><small class="bca-btn-subtitle">' + escapeHtml(CONFIG.addiCheckout.subtitle) + '</small></span></a><div class="bca-addi-info"><strong>Información de pago con Addi</strong>El precio financiado incluye un ajuste del ' + escapeHtml(CONFIG.addiCheckout.feeRateLabel) + ' por el servicio, calculado sobre productos y envío.<br>Cargo estimado: <span id="bca-addi-fee">$0</span> · Total financiado: <span id="bca-addi-total">$0</span></div>'
      : '';

    var checks = CONFIG.checks.map(checkHtml).join('');

    var modalHtml =
      '<div id="bca-modal" class="bca-modal" aria-hidden="true">' +
        '<div class="bca-backdrop" data-bca-close="true"></div>' +
        '<div class="bca-panel" role="dialog" aria-modal="true">' +
          '<div class="bca-head">' +
            '<div class="bca-head-left">' +
              '<span class="bca-head-icon">' + escapeHtml(CONFIG.modal.icon) + '</span>' +
              '<div>' +
                '<div class="bca-head-title">' + escapeHtml(CONFIG.modal.title) + '</div>' +
                '<div class="bca-head-subtitle">' + escapeHtml(CONFIG.modal.subtitle) + '</div>' +
              '</div>' +
            '</div>' +
            '<button type="button" class="bca-close" data-bca-close="true" aria-label="Cerrar"><span aria-hidden="true">×</span></button>' +
          '</div>' +
          '<div class="bca-body">' +
            '<img id="bca-banner" class="bca-banner bca-lazy-media" src="" data-bca-src="' + escapeHtml(CONFIG.banner.imageUrl) + '" alt="' + escapeHtml(CONFIG.banner.alt) + '" loading="lazy" decoding="async" style="display:none">' +
            '<div class="bca-section-title"><h3>' + escapeHtml(CONFIG.texts.orderTitle) + '</h3><button type="button" id="bca-refresh-cart" class="bca-update-cart">' + escapeHtml(CONFIG.texts.updateCart) + '</button></div>' +
            '<div id="bca-items" class="bca-items"></div>' +
            '<div class="bca-summary">' +
              '<div class="bca-row"><span>' + escapeHtml(CONFIG.texts.subtotal) + '</span><strong id="bca-subtotal">$0</strong></div>' +
              '<div class="bca-row" id="bca-discount-row"><span id="bca-discount-label">' + escapeHtml(CONFIG.texts.discount) + '</span><strong id="bca-discount">-$0</strong></div>' +
              '<div class="bca-row"><span>' + escapeHtml(CONFIG.texts.shipping) + '</span><strong id="bca-shipping">$0</strong></div>' +
              '<div class="bca-total"><span>' + escapeHtml(CONFIG.texts.total) + '</span><strong id="bca-total">$0</strong></div>' +
            '</div>' +
            '<p class="bca-small-title">' + escapeHtml(CONFIG.texts.methodTitle) + '</p>' +
            '<div class="bca-method-card"><span class="bca-radio-dot"></span><strong id="bca-method-name">' + escapeHtml(CONFIG.shipping.methodName) + '</strong><span id="bca-method-price">$0</span></div>' +
            '<div id="bca-cod-minimum-notice" class="bca-cod-minimum-notice" role="status" aria-live="polite"></div>' +
            '<div id="bca-form" class="bca-form" role="form">' +
              '<h3>' + escapeHtml(CONFIG.texts.formTitle) + '</h3>' +
              '<div class="bca-grid">' + fields + '</div>' +
              '<div class="bca-warning">' + escapeHtml(CONFIG.texts.whatsappWarning) + '</div>' +
              '<p class="bca-note">' + escapeHtml(CONFIG.texts.whatsappNote) + '</p>' +
              checks +
              '<div id="bca-form-achievement" class="bca-form-achievement" role="status" aria-live="polite" aria-hidden="true">' +
                '<span class="bca-achievement-kicker">🏆 LOGRO DESBLOQUEADO</span>' +
                '<strong class="bca-achievement-title">¡HAS COMPLETADO LA MISIÓN!</strong>' +
                '<span class="bca-achievement-copy">Tu compra contraentrega está habilitada. Completa el último paso para confirmar tu pedido.</span>' +
              '</div>' +
              '<button type="button" class="bca-submit is-payment-locked" disabled aria-disabled="true">' +
                '<span class="bca-btn-ico">🚚</span>' +
                '<span class="bca-btn-text">' +
                  '<strong id="bca-submit-main" class="bca-btn-title">' + escapeHtml(CONFIG.texts.submit) + '</strong>' +
                  '<small id="bca-submit-sub" class="bca-btn-subtitle">' + escapeHtml(CONFIG.texts.submitSub) + '</small>' +
                '</span>' +
              '</button>' +
              '<p id="bca-message" class="bca-message"></p>' +
              '<div class="bca-alt-payment-title">O elige otro método de pago</div>' +
              '<div class="bca-alt-payment-stack">' + nativeBtn + addiBtn + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var exitHtml =
      '<div id="bca-exit" class="bca-exit">' +
        '<div class="bca-exit-card">' +
          '<div class="bca-exit-top">' +
            '<div class="bca-exit-icon-wrap">' + escapeHtml(CONFIG.exitPopup.icon) + '</div>' +
            '<h3>' + escapeHtml(CONFIG.exitPopup.title) + '</h3>' +
          '</div>' +
          '<div class="bca-exit-body">' +
            '<p>' + escapeHtml(CONFIG.exitPopup.text) + '</p>' +
            '<div class="bca-exit-support">' + escapeHtml(CONFIG.exitPopup.supportText) + '</div>' +
            '<div class="bca-exit-actions">' +
              '<button type="button" class="bca-exit-continue">' + escapeHtml(CONFIG.exitPopup.continueText) + '</button>' +
              '<button type="button" class="bca-exit-close">' + escapeHtml(CONFIG.exitPopup.exitText) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    var thanksHtml =
      '<div id="bca-thanks" class="bca-thanks" aria-hidden="true">' +
        '<div class="bca-thanks-card" role="dialog" aria-modal="true">' +
          '<div class="bca-thanks-top">' +
            '<div class="bca-thanks-logo-wrap">' +
              '<img class="bca-thanks-logo bca-lazy-media" src="" data-bca-src="' + escapeHtml(CONFIG.thankYouPopup.logoUrl) + '" alt="' + escapeHtml(CONFIG.thankYouPopup.logoAlt) + '" loading="lazy" decoding="async">' +
            '</div>' +
            '<h3>' + escapeHtml(CONFIG.thankYouPopup.title) + '</h3>' +
            '<p>' + escapeHtml(CONFIG.thankYouPopup.text) + '</p>' +
          '</div>' +
          '<div class="bca-thanks-content">' +
            '<div class="bca-thanks-grid">' +
              '<div class="bca-thanks-info-box"><strong>' + escapeHtml(CONFIG.thankYouPopup.emailTitle) + '</strong><span>' + escapeHtml(CONFIG.thankYouPopup.emailText) + '</span></div>' +
              '<div class="bca-thanks-info-box"><strong>' + escapeHtml(CONFIG.thankYouPopup.validationTitle) + '</strong><span>' + escapeHtml(CONFIG.thankYouPopup.validationText) + '</span></div>' +
              '<div class="bca-thanks-info-box"><strong>' + escapeHtml(CONFIG.thankYouPopup.scheduleTitle) + '</strong><span>' + escapeHtml(CONFIG.thankYouPopup.scheduleText) + '</span></div>' +
            '</div>' +
            '<div id="bca-thanks-summary" class="bca-thanks-summary"><h4>' + escapeHtml(CONFIG.thankYouPopup.summaryTitle) + '</h4><div id="bca-thanks-summary-body"></div></div>' +
            '<div class="bca-thanks-actions">' +
              '<button type="button" class="bca-thanks-close">' + escapeHtml(CONFIG.thankYouPopup.closeText) + '</button>' +
              (CONFIG.thankYouPopup.showContinueShopping ? '<a class="bca-thanks-continue" href="' + escapeHtml(CONFIG.thankYouPopup.continueShoppingUrl) + '">' + escapeHtml(CONFIG.thankYouPopup.continueShoppingText) + '</a>' : '') +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';

    document.body.insertAdjacentHTML('beforeend', modalHtml + exitHtml + thanksHtml);

    state.modalRendered = true;
    bindEvents();

    // La precarga del modal no representa un cambio del carrito. Conservar el
    // resultado fresco ya validado y aplicar ese mismo estado solo a los nuevos
    // controles internos, sin volver a bloquear los botones visibles.
    if (state.cart && Array.isArray(state.cart.items)) {
      renderTotals();
    }
  }

  function loadLazyMedia(scope) {
    qsa('.bca-lazy-media[data-bca-src]', scope || document).forEach(function (img) {
      var src = img.getAttribute('data-bca-src');

      if (!img.getAttribute('src') && src) {
        img.setAttribute('src', src);
        img.style.display = '';
      }
    });
  }

  function getOptionsForSelect(name) {
    if (name === 'province') return CONFIG.locations.departments;

    var depInput = qs('[name="province"]');
    var dep = depInput ? depInput.value : '';

    return dep ? (CONFIG.locations.citiesByDepartment[dep] || []) : [];
  }

  function setupCustomSelects() {
    if (window.BCA_SELECTS_BOUND_V63) return;
    window.BCA_SELECTS_BOUND_V63 = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bca-select-btn');

      if (btn) {
        e.preventDefault();

        var sel = btn.closest('.bca-select');

        if (!sel || sel.classList.contains('is-disabled') || btn.disabled) return;

        qsa('.bca-select.open').forEach(function (x) {
          if (x !== sel) x.classList.remove('open');
        });

        sel.classList.toggle('open');

        var search = sel.querySelector('.bca-search-input');

        if (sel.classList.contains('open') && search) {
          setTimeout(function () {
            search.focus();
          }, 30);
        }

        return;
      }

      var opt = e.target.closest && e.target.closest('.bca-option');

      if (opt) {
        e.preventDefault();
        e.stopPropagation();

        if (opt.dataset.bcaSwitchBogota === 'true') {
          switchToBogotaDc();
          return;
        }

        var selected = opt.closest('.bca-select');

        selectValue(selected, opt.dataset.value);

        if (selected.dataset.select === 'province') {
          var isBogotaDc = normalizeLocationKey(opt.dataset.value) === 'bogota d c';
          populateCities(opt.dataset.value);
          if (isBogotaDc) {
            var citySelectAuto = qs('.bca-select[data-select="city"]');
            var bogotaCitiesAuto = CONFIG.locations.citiesByDepartment[opt.dataset.value] || [];
            if (bogotaCitiesAuto.length) selectValue(citySelectAuto, bogotaCitiesAuto[0]);
          }
          setBogotaHelp(isBogotaDc);
        }

        renderTotals();

        return;
      }

      if (!e.target.closest || !e.target.closest('.bca-select')) {
        qsa('.bca-select.open').forEach(function (x) {
          x.classList.remove('open');
        });
      }
    }, true);

    document.addEventListener('input', function (e) {
      if (!e.target.classList || !e.target.classList.contains('bca-search-input')) return;

      var sel = e.target.closest('.bca-select');
      var list = sel ? sel.querySelector('.bca-option-list') : null;
      var term = normalize(e.target.value);
      var filtered = getOptionsForSelect(sel.dataset.select).filter(function (x) {
        return normalize(x).indexOf(term) > -1;
      });

      if (list) {
        list.innerHTML = renderSelectOptions(sel.dataset.select, filtered, term);
      }
    });
  }

  function selectValue(sel, value) {
    if (!sel) return;

    var hidden = sel.querySelector('input[type="hidden"]');
    var btnText = sel.querySelector('.bca-select-btn span');
    var search = sel.querySelector('.bca-search-input');

    if (hidden) hidden.value = value;

    if (btnText) {
      btnText.textContent = value;
      btnText.classList.remove('ph');
    }

    if (search) search.value = '';

    sel.classList.remove('open', 'is-invalid');

    var wrap = sel.closest('.bca-field');

    if (wrap) wrap.classList.remove('has-error');

    setTimeout(function () {
      qsa('.bca-select.open').forEach(function (x) {
        x.classList.remove('open');
      });
    }, 20);
  }

  function populateCities(department) {
    var cities = CONFIG.locations.citiesByDepartment[department] || [];
    var sel = qs('.bca-select[data-select="city"]');

    if (!sel) return;

    var hidden = sel.querySelector('input[type="hidden"]');
    var btn = sel.querySelector('.bca-select-btn');
    var span = btn ? btn.querySelector('span') : null;
    var list = sel.querySelector('.bca-option-list');
    var search = sel.querySelector('.bca-search-input');

    if (hidden) hidden.value = '';
    if (btn) btn.disabled = false;

    if (span) {
      span.textContent = CONFIG.fields.city.placeholder;
      span.classList.add('ph');
    }

    sel.classList.remove('is-disabled', 'open', 'is-invalid');

    if (list) list.innerHTML = renderSelectOptions('city', cities, '');
    if (search) search.value = '';
  }

  function bindEvents() {
    if (state.eventsBound) return;
    state.eventsBound = true;

    setupCustomSelects();

    var refresh = qs('#bca-refresh-cart');

    if (refresh) {
      refresh.addEventListener('click', function () {
        loadCart('cart_refreshed');
      });
    }

    var native = qs('#bca-native-checkout');

    if (native) {
      native.addEventListener('click', goNativeCheckout, true);
    }

    var addi = qs('#bca-addi-checkout');

    if (addi) {
      addi.addEventListener('click', goAddiCheckout, true);
    }

    var form = qs('#bca-form');

    if (form) {
      var codBtn = qs('.bca-submit', form);

      if (codBtn) {
        codBtn.addEventListener('click', submitOrder, true);
      }

      form.addEventListener('input', handleFormActivity, true);
      form.addEventListener('change', handleFormActivity, true);

      var promoBtn = qs('#bca-apply-promo', form);
      var promoInput = qs('[name="promo_code"]', form);

      if (promoBtn && !promoBtn.dataset.bound) {
        promoBtn.dataset.bound = 'true';
        promoBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          applyPromoCode(false);
        }, true);
      }

      if (promoInput && !promoInput.dataset.bound) {
        promoInput.dataset.bound = 'true';
        promoInput.addEventListener('input', handlePromoInputChange, true);
        promoInput.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') {
            event.preventDefault();
            applyPromoCode(false);
          }
        }, true);
      }
    }

    var items = qs('#bca-items');

    if (items) {
      items.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('button[data-action]');

        if (!btn) return;

        var current = Number(btn.dataset.qty || 1);
        var next = current;

        if (btn.dataset.action === 'plus') next = current + 1;
        if (btn.dataset.action === 'minus') next = Math.max(current - 1, 0);
        if (btn.dataset.action === 'remove') next = 0;

        changeQuantity(btn.dataset.key, next);
      }, true);
    }

    qsa('[data-bca-close="true"]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.classList.contains('bca-backdrop') && !CONFIG.behavior.closeOnBackdrop) return;

        showExitConfirm();
      });
    });

    qsa('.bca-exit-continue').forEach(function (b) {
      b.addEventListener('click', hideExitConfirm);
    });

    qsa('.bca-exit-close').forEach(function (b) {
      b.addEventListener('click', forceCloseModal);
    });

    qsa('.bca-thanks-close').forEach(function (b) {
      b.addEventListener('click', hideThankYouPopup);
    });

    var continueBtn = qs('.bca-thanks-continue');

    if (continueBtn) {
      continueBtn.addEventListener('click', async function (e) {
        e.preventDefault();

        var href = continueBtn.getAttribute('href') || '/';

        await clearShopifyCartAfterOrder();

        window.location.href = href;
      }, true);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && CONFIG.behavior.closeOnEsc && isModalOpen()) {
        showExitConfirm();
      }
    });

    if (!window.BCA_COD_ABANDONMENT_LIFECYCLE_BOUND_V63) {
      window.BCA_COD_ABANDONMENT_LIFECYCLE_BOUND_V63 = true;

      window.addEventListener('pagehide', function () {
        sendAbandonmentFastBeacon('pagehide_exit');
      });

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          sendAbandonmentFastBeacon('visibility_hidden');
        }
      });
    }
  }


  var cloudQuoteTimer, cloudQuotePromise, cloudQuoteSequence = 0;
  function cloudQuoteKey() {
    var data = getFormData();
    return JSON.stringify({ items: ((state.cart && state.cart.items) || []).map(function (i) { return [i.variant_id, i.quantity, i.properties]; }), first_name: data.first_name, last_name: data.last_name, phone: data.phone, email: data.email, province: data.province, city: data.city, address1: data.address1, address2: data.address2, promo: data.promo_code, checks: [data.confirm_whatsapp, data.confirm_commitment] });
  }
  function scheduleCloudQuote() {
    if (!state || !state.cart || !state.cart.items.length || !isModalOpen() || state.cloudQuoteKey === cloudQuoteKey()) return;
    clearTimeout(cloudQuoteTimer);
    cloudQuoteTimer = setTimeout(function () { updateCloudQuote(false).catch(function (e) { if (e.code === 'QUOTE_SUPERSEDED') return; state.cloudQuoteError = true; showMessage('Estamos actualizando el total. Si tarda, toca Actualizar carrito. Tu pedido todavía no se ha enviado.', 'ok'); }); }, 500);
  }
  async function updateCloudQuote(force) {
    clearTimeout(cloudQuoteTimer);
    var key = cloudQuoteKey();
    if (!force && state.cloudQuote && state.cloudQuoteKey === key) return state.cloudQuote;
    var sequence = ++cloudQuoteSequence;
    var result = await window.BacanimeFormTransport.quote(buildPayload('quote'));
    if (sequence !== cloudQuoteSequence || key !== cloudQuoteKey()) { var changed = new Error('Actualizando los datos del pedido. Espera un momento.'); changed.code = 'QUOTE_SUPERSEDED'; throw changed; }
    result.qty = ((state.cart && state.cart.items) || []).reduce(function (sum, i) { return sum + (isCodEligibleProductItem(i) ? i.quantity : 0); }, 0);
    state.cloudQuote = result; state.cloudQuoteKey = key;
    if (state.cloudQuoteError) { state.cloudQuoteError = false; showMessage('', ''); }
    renderTotals(); return result;
  }

  function handleFormActivity() {
    state.hasUserInteractedWithForm = true;
    normalizeVisibleEmail();
    normalizeVisiblePromoCode();
    renderTotals();

    if (!state.inputEventSent) {
      state.inputEventSent = true;
      fireTracking(CONFIG.pixel.events.formInput, buildPayload('cod_form_input'));
    }

    resetIdleAbandonmentTimer();

    if (CONFIG.abandonedCart.enabled && CONFIG.abandonedCart.sendOnInputWhenQualified) {
      queueAbandonment('form_activity');
    }
  }

  function normalizeVisibleEmail() {
    var input = qs('[name="email"]');

    if (!input) return;

    var cleaned = cleanEmail(input.value);

    if (cleaned !== input.value && input.value.indexOf(' ') > -1) {
      input.value = cleaned;
    }
  }

  function normalizeVisiblePromoCode() {
    var input = qs('[name="promo_code"]');

    if (!input) return;

    var cleaned = cleanPromoCode(input.value);

    if (cleaned !== input.value) {
      input.value = cleaned;
    }
  }

  async function getCart() {
    var r = await fetch('/cart.js', { credentials: 'same-origin' });

    if (!r.ok) throw new Error('No se pudo leer el carrito.');

    return r.json();
  }

  async function loadCart(reason) {
    var requestVersion = ++state.cartRequestVersion;

    lockPaymentControlsForCartRefresh('load_cart:' + (reason || 'unknown'));

    try {
      var freshCart = await getCart();

      if (requestVersion !== state.cartRequestVersion) {
        return state.cart;
      }

      state.cart = freshCart;
      renderCart();
      renderTotals();
      syncThemeCartCounter(state.cart && state.cart.item_count ? state.cart.item_count : 0);

      if (reason === 'cart_quantity_changed' || reason === 'promo_removed' || reason === 'cod_modal_opened') {
        scheduleDawnThemeCartRefresh(reason, state.cart, 80);
      }

      return state.cart;
    } catch (e) {
      console.warn('[Bacanime] No se pudo verificar el carrito fresco:', e);
      state.cart = null;
      showMessage(e.message || 'Error cargando carrito.', 'error');

      return null;
    }
  }

  async function changeQuantity(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: quantity })
      });

      await loadCart('cart_quantity_changed');
      await refreshDawnThemeCart('cart_quantity_changed', state.cart);

      if (state.promoVisual && state.promoVisual.code) {
        await applyPromoCode(true);
      }

      queueAbandonment('cart_quantity_changed');
    } catch (e) {
      showMessage('No se pudo actualizar el carrito.', 'error');
    }
  }

  async function updateBacanimeCartDiscount(discountCode) {
    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: String(discountCode || '').trim() })
      });

      if (!response.ok) {
        throw new Error('Shopify no pudo actualizar el descuento.');
      }

      var cart = await response.json();

      state.cart = cart;
      renderCart();
      renderTotals();
      syncThemeCartCounter(cart.item_count || 0);
      scheduleDawnThemeCartRefresh('cart_discount_updated', cart, 120);

      return cart;
    } catch (e) {
      console.warn('Bacanime: descuento no actualizado.', e);

      return null;
    }
  }

  function getCodUnitPriceCents(item) {
    item = item || {};

    return Number(item.original_price || 0) ||
      Number(item.price || 0) ||
      Number(item.final_price || 0) ||
      0;
  }

  function getCodLinePriceCents(item) {
    item = item || {};

    var originalLine = Number(item.original_line_price || 0);

    if (originalLine > 0) return originalLine;

    return getCodUnitPriceCents(item) * Number(item.quantity || 0);
  }

  function getCodCartSubtotalPesos(cart) {
    return Math.round(((cart && cart.items) || []).reduce(function (sum, item) {
      return sum + getCodLinePriceCents(item);
    }, 0) / 100);
  }

  function getFormData() {
    var form = qs('#bca-form');

    if (!form) return {};

    var data = {};

    qsa('input, textarea, select', form).forEach(function (input) {
      if (!input.name) return;

      if (input.type === 'checkbox') {
        data[input.name] = !!input.checked;
      } else {
        data[input.name] = input.value;
      }
    });

    data.email_raw = String(data.email || '').trim();
    data.email = cleanEmail(data.email || '');
    data.promo_code_raw = String(data.promo_code || '').trim();
    data.promo_code = cleanPromoCode(data.promo_code || '');
    data.discount_code = data.promo_code || '';
    data.phone_clean = cleanPhone(data.phone || '');
    data.phone_e164 = validPhone(data.phone || '') || '';
    data.email_valid = validEmail(data.email || '');
    data.email_for_shopify = data.email_valid || '';
    data.contact_priority = 'WhatsApp';

    return data;
  }

  function calculateTotals(cart, formData) {
    if (state.cloudQuote && state.cloudQuoteKey === cloudQuoteKey()) return Object.assign({}, state.cloudQuote);
    formData = formData || {};

    var subtotal = getCodCartSubtotalPesos(cart);
    var qty = ((cart && cart.items) || []).reduce(function (s, i) {
      return s + (isCodEligibleProductItem(i) ? Number(i.quantity || 0) : 0);
    }, 0);

    var discount = 0;

    if (CONFIG.discounts.enabled) {
      discount += CONFIG.discounts.type === 'percentage'
        ? Math.round(subtotal * (Number(CONFIG.discounts.value || 0) / 100))
        : Number(CONFIG.discounts.value || 0);

      if (CONFIG.discounts.quantityDiscountsEnabled) {
        var rule = CONFIG.discounts.quantityRules.slice().reverse().find(function (r) {
          return qty >= r.minQuantity;
        });

        if (rule) {
          discount += rule.type === 'percentage'
            ? Math.round(subtotal * (rule.value / 100))
            : Number(rule.value || 0);
        }
      }
    }

    if (state.promoVisual && state.promoVisual.applied && state.promoVisual.discountAmount) {
      discount += Number(state.promoVisual.discountAmount || 0);
    }

    var shipping = CONFIG.shipping.enabled ? Number(CONFIG.shipping.defaultPrice || 0) : 0;
    var province = formData.province || '';
    var city = normalize(formData.city);

    if (
      CONFIG.shipping.enabled &&
      CONFIG.shipping.departmentRatesEnabled &&
      CONFIG.shipping.departmentRates[province] !== undefined
    ) {
      shipping = Number(CONFIG.shipping.departmentRates[province] || 0);
    }

    if (
      CONFIG.shipping.enabled &&
      CONFIG.shipping.cityRatesEnabled &&
      CONFIG.shipping.cityRates[city] !== undefined
    ) {
      shipping = Number(CONFIG.shipping.cityRates[city] || 0);
    }

    if (
      CONFIG.shipping.enabled &&
      CONFIG.shipping.freeShippingEnabled &&
      subtotal >= CONFIG.shipping.freeShippingFrom
    ) {
      shipping = 0;
    }

    if (state.promoVisual && state.promoVisual.applied && state.promoVisual.freeShipping) {
      shipping = 0;
    }

    if (qty <= 0) {
      shipping = 0;
    }

    discount = Math.min(discount, subtotal);

    return {
      subtotal: subtotal,
      discount: discount,
      shipping: shipping,
      total: Math.max(subtotal - discount + shipping, 0),
      qty: qty
    };
  }

  function renderCart() {
    var el = qs('#bca-items');

    if (!el) return;

    if (!state.cart || !state.cart.items || !state.cart.items.length) {
      el.innerHTML = '<div class="bca-empty">' + escapeHtml(CONFIG.texts.emptyCart) + '</div>';
      return;
    }

    el.innerHTML = state.cart.items.map(function (item) {
      return '<div class="bca-item">' +
        '<div class="bca-img-wrap">' +
          '<img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title || 'Producto') + '" loading="lazy" decoding="async">' +
          '<span class="bca-badge">' + Number(item.quantity || 0) + '</span>' +
        '</div>' +
        '<div>' +
          '<p class="bca-item-title">' + escapeHtml(item.product_title || item.title || 'Producto') + '</p>' +
          '<p class="bca-item-variant">' + escapeHtml(item.variant_title || '') + '</p>' +
          '<div class="bca-item-price">' + money(Math.round(getCodLinePriceCents(item) / 100)) + '</div>' +
          '<div class="bca-qty">' +
            '<button type="button" data-action="minus" data-key="' + escapeHtml(item.key) + '" data-qty="' + Number(item.quantity || 0) + '">−</button>' +
            '<span>' + Number(item.quantity || 0) + '</span>' +
            '<button type="button" data-action="plus" data-key="' + escapeHtml(item.key) + '" data-qty="' + Number(item.quantity || 0) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="bca-remove" data-action="remove" data-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(CONFIG.texts.removeItemLabel) + '">×</button>' +
      '</div>';
    }).join('');
  }

  function renderTotals() {
    scheduleCloudQuote();
    state.totals = calculateTotals(state.cart, getFormData());

    var map = {
      '#bca-subtotal': money(state.totals.subtotal),
      '#bca-discount': '-' + money(state.totals.discount),
      '#bca-shipping': money(state.totals.shipping),
      '#bca-total': money(state.totals.total),
      '#bca-method-price': money(state.totals.shipping)
    };

    Object.keys(map).forEach(function (s) {
      var el = qs(s);

      if (el) el.textContent = map[s];
    });

    var discountLabel = qs('#bca-discount-label');

    if (discountLabel) {
      discountLabel.textContent = (state.promoVisual && state.promoVisual.applied && state.promoVisual.code)
        ? ('Descuento ' + state.promoVisual.code)
        : (CONFIG.discounts.label || CONFIG.texts.discount);
    }

    renderPromoStatus();
    renderCodMinimumNotice();
    renderDirectPaymentEligibility();

    var methodName = qs('#bca-method-name');

    if (methodName) {
      methodName.textContent = CONFIG.shipping.methodName;
    }

    var addiBaseTotal = Math.max(getCodCartSubtotalPesos(state.cart) + Number(state.totals.shipping || 0), 0);
    var addiFinancedTotal = addiBaseTotal + Math.round(addiBaseTotal * 68 / 1000);
    var addiFee = Math.max(addiFinancedTotal - addiBaseTotal, 0);
    var addiFeeEl = qs('#bca-addi-fee');
    var addiTotalEl = qs('#bca-addi-total');

    if (addiFeeEl) addiFeeEl.textContent = money(addiFee);
    if (addiTotalEl) addiTotalEl.textContent = money(addiFinancedTotal);

    var discountRow = qs('#bca-discount-row');

    if (discountRow) {
      discountRow.style.display = state.totals.discount > 0 ? 'flex' : 'none';
    }

    var submitMain = qs('#bca-submit-main');

    if (submitMain) {
      submitMain.textContent = CONFIG.texts.submit + ' - ' + money(state.totals.total);
    }

    var submitSub = qs('#bca-submit-sub');

    if (submitSub) {
      submitSub.textContent = CONFIG.texts.submitSub;
    }
  }

  function syncThemeCartCounter(count) {
    count = Number(count || 0);

    try {
      document.querySelectorAll('.cart-count-bubble,.cart-count,[data-cart-count],[data-header-cart-count],[data-cart-count-bubble],.site-header__cart-count,.header__cart-count,.cart-link__bubble,.cart-item-count,.cart-count-bubble span,a[href="/cart"] .count,cart-icon-bubble span,#cart-icon-bubble span,.header__icon--cart .cart-count-bubble span').forEach(function (el) {
        if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', String(count));
        if (el.hasAttribute('data-header-cart-count')) el.setAttribute('data-header-cart-count', String(count));
        if (el.hasAttribute('data-cart-count-bubble')) el.setAttribute('data-cart-count-bubble', String(count));

        if (/^\s*\d+\s*$/.test(el.textContent || '')) {
          el.textContent = String(count);
        }

        if (el.style) {
          el.style.display = count === 0 && (
            el.classList.contains('cart-count-bubble') ||
            el.classList.contains('cart-count') ||
            el.classList.contains('cart-link__bubble')
          ) ? 'none' : '';
        }
      });
    } catch (e) {}
  }


  /* =========================================================
     SHOPIFY DAWN THEME SYNC
     - Refresca contador, cart drawer, cart notification y carrito.
     - Útil para Dawn cuando el formulario cambia cantidades, aplica descuentos o limpia el carrito.
     - No depende de apps externas y no rompe si el tema no tiene drawer.
  ========================================================= */

  function getDawnThemeSectionIds() {
    var sections = ['cart-icon-bubble'];

    if (qs('cart-drawer') || qs('#CartDrawer') || qs('.drawer__inner')) {
      sections.push('cart-drawer');
    }

    if (qs('cart-notification') || qs('#cart-notification')) {
      sections.push('cart-notification-product');
      sections.push('cart-notification-button');
    }

    if (qs('cart-items') || qs('#main-cart-items')) {
      sections.push('main-cart-items');
    }

    if (qs('#main-cart-footer') || qs('.cart__footer')) {
      sections.push('main-cart-footer');
    }

    return sections.filter(function (value, index, array) {
      return value && array.indexOf(value) === index;
    });
  }

  function getDawnSectionsUrl(sectionIds) {
    var path = '/cart';

    try {
      var url = new URL(path, window.location.origin);
      url.searchParams.set('sections', sectionIds.join(','));
      url.searchParams.set('sections_url', (window.location.pathname || '/') + (window.location.search || ''));
      return url.pathname + url.search;
    } catch (e) {
      return path + '?sections=' + encodeURIComponent(sectionIds.join(','));
    }
  }

  function parseHtmlDocument(html) {
    return new DOMParser().parseFromString(String(html || ''), 'text/html');
  }

  function replaceElementFromHtml(html, selectors) {
    if (!html) return false;

    var doc = parseHtmlDocument(html);
    var replaced = false;

    selectors.forEach(function (selector) {
      var source = doc.querySelector(selector);
      var targets = qsa(selector);

      if (!source || !targets.length) return;

      targets.forEach(function (target) {
        try {
          target.replaceWith(source.cloneNode(true));
          replaced = true;
        } catch (e) {
          try {
            target.innerHTML = source.innerHTML;
            replaced = true;
          } catch (e2) {}
        }
      });
    });

    return replaced;
  }

  function injectDawnSection(sectionId, html) {
    if (!html) return false;

    var sectionSelectors = {
      'cart-icon-bubble': [
        '#cart-icon-bubble',
        'cart-icon-bubble',
        '.header__icon--cart .cart-count-bubble',
        '.cart-count-bubble'
      ],
      'cart-drawer': [
        'cart-drawer',
        '#CartDrawer',
        '.cart-drawer',
        '.drawer__inner'
      ],
      'cart-notification-product': [
        '#cart-notification-product',
        '.cart-notification-product'
      ],
      'cart-notification-button': [
        '#cart-notification-button',
        '.cart-notification__links'
      ],
      'main-cart-items': [
        'cart-items',
        '#main-cart-items',
        '.cart-items'
      ],
      'main-cart-footer': [
        '#main-cart-footer',
        '.cart__footer'
      ]
    };

    var selectors = sectionSelectors[sectionId] || [];

    if (!selectors.length) return false;

    return replaceElementFromHtml(html, selectors);
  }

  function dispatchDawnCartEvents(reason, cart) {
    var detail = {
      cart: cart || state.cart || null,
      cartData: cart || state.cart || null,
      source: 'bacanime_cod_form',
      reason: reason || 'bacanime_cart_sync'
    };

    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
      window.dispatchEvent(new CustomEvent('bca:cart:refreshed', { detail: detail }));
    } catch (e) {}

    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'bacanime_cod_form',
          cartData: cart || state.cart || null,
          productVariantId: null
        });
      }
    } catch (e2) {}
  }

  async function refreshDawnThemeCart(reason, cartOverride) {
    var cart = cartOverride || state.cart || null;

    try {
      if (!cart || typeof cart.item_count === 'undefined') {
        cart = await getCart();
      }
    } catch (e) {}

    if (cart) {
      state.cart = cart;
      syncThemeCartCounter(cart.item_count || 0);
    }

    var sectionIds = getDawnThemeSectionIds();

    if (!sectionIds.length) {
      dispatchDawnCartEvents(reason, cart);
      return cart;
    }

    try {
      var response = await fetch(getDawnSectionsUrl(sectionIds), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        var sections = await response.json();

        sectionIds.forEach(function (sectionId) {
          if (sections && sections[sectionId]) {
            injectDawnSection(sectionId, sections[sectionId]);
          }
        });
      }
    } catch (e2) {
      console.warn('Bacanime: no se pudo refrescar el carrito Dawn.', e2);
    }

    if (cart) {
      syncThemeCartCounter(cart.item_count || 0);
    }

    dispatchDawnCartEvents(reason, cart);

    return cart;
  }

  function scheduleDawnThemeCartRefresh(reason, cartOverride, delay) {
    try {
      clearTimeout(state.dawnRefreshTimer);

      state.dawnRefreshTimer = setTimeout(function () {
        refreshDawnThemeCart(reason || 'scheduled_dawn_refresh', cartOverride || state.cart);
      }, typeof delay === 'number' ? delay : 120);
    } catch (e) {}
  }

  function setupDawnThemeObserver() {
    if (state.dawnObserverStarted) return;
    state.dawnObserverStarted = true;

    try {
      document.addEventListener('shopify:section:load', function () {
        setTimeout(function () {
          // En la vista previa Shopify puede emitir este evento varias veces.
          // No reconstruir controles ya válidos: hacerlo los regresaba al estado
          // inicial bloqueado aunque el carrito no hubiera cambiado.
          if (!qs('#bca-cod-root')) {
            renderInitialButton();
          }
        }, 80);
      });

      document.addEventListener('shopify:section:select', function () {
        setTimeout(function () {
          if (!qs('#bca-cod-root')) renderInitialButton();
        }, 80);
      });
    } catch (e) {}

    try {
      var target = qs('main') || document.body;
      var observer = new MutationObserver(function () {
        if (!qs('#bca-cod-root') && (qs('.product-form__buttons') || qs('product-form') || qs('product-info'))) {
          renderInitialButton();
        }
      });

      observer.observe(target, { childList: true, subtree: true });
    } catch (e2) {}
  }

  function scheduleLiveCartProgressRefresh(reason, delay) {
    try {
      lockPaymentControlsForCartRefresh('schedule:' + (reason || 'live_cart_progress'));

      // No reiniciar el temporizador con cada evento del tema. Algunos carritos
      // emiten eventos de actualización en ráfaga y un debounce reiniciable puede
      // posponer indefinidamente la lectura fresca, dejando la compra bloqueada en
      // "Verificando...". La primera solicitud queda programada y las siguientes
      // se consolidan sin permitir que un estado anterior vuelva a habilitar pagos.
      if (state.liveCartProgressTimer) return;

      state.liveCartProgressTimer = setTimeout(function () {
        state.liveCartProgressTimer = null;
        loadCart(reason || 'live_cart_progress');
      }, typeof delay === 'number' ? delay : 160);
    } catch (e) {}
  }

  function setupLiveCartProgress() {
    if (state.liveCartProgressBound) return;
    state.liveCartProgressBound = true;

    var refreshFromEvent = function (event) {
      // Los eventos que emite esta misma integración solo sincronizan la UI de
      // Dawn. Volver a escucharlos aquí crea un ciclo que bloquea de nuevo los
      // botones después de haber verificado correctamente el carrito.
      if (event && event.detail && event.detail.source === 'bacanime_cod_form') {
        return;
      }

      scheduleLiveCartProgressRefresh('shopify_cart_event', 100);
    };

    ['cart:updated', 'cart:change', 'cart:refresh', 'bca:cart:refreshed'].forEach(function (eventName) {
      try {
        document.addEventListener(eventName, refreshFromEvent);
        window.addEventListener(eventName, refreshFromEvent);
      } catch (e) {}
    });

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('form[action*="/cart/add"] button[type="submit"],button[name="add"],.product-form__submit,[data-add-to-cart]')
        : null;

      if (!target) return;

      lockPaymentControlsForCartRefresh('add_to_cart_click');

      setTimeout(function () {
        scheduleLiveCartProgressRefresh('add_to_cart_click_fallback', 60);
      }, 700);
    }, true);

    scheduleLiveCartProgressRefresh('initial_payment_goal', 40);
  }

  function isAffirmative(value) {
    var v = normalize(value);
    return value === true || v === 'si' || v === 'sí' || v === 'true' || v === '1' || v === 'yes';
  }

  function setPromoButtonLoading(isLoading) {
    var btn = qs('#bca-apply-promo');

    if (!btn) return;

    btn.disabled = !!isLoading;
    btn.textContent = isLoading ? '...' : (state.promoVisual && state.promoVisual.applied ? CONFIG.texts.promoRemoveButton : CONFIG.texts.promoApplyButton);
  }

  function setPromoStatus(status, message) {
    state.promoVisual.status = status || 'idle';
    state.promoVisual.message = message || '';
    renderPromoStatus();
  }

  function renderPromoStatus() {
    var el = qs('#bca-promo-status');
    var btn = qs('#bca-apply-promo');

    if (btn) {
      btn.textContent = state.promoVisual && state.promoVisual.applied ? CONFIG.texts.promoRemoveButton : CONFIG.texts.promoApplyButton;
    }

    if (!el) return;

    var status = state.promoVisual ? state.promoVisual.status : 'idle';
    var message = state.promoVisual ? state.promoVisual.message : '';

    el.classList.remove('is-visible', 'is-ok', 'is-error', 'is-info');

    if (!message) {
      el.textContent = '';
      return;
    }

    el.textContent = message;
    el.classList.add('is-visible');

    if (status === 'applied') el.classList.add('is-ok');
    else if (status === 'invalid' || status === 'error') el.classList.add('is-error');
    else el.classList.add('is-info');
  }

  function resetPromoVisual(message) {
    state.promoVisual = {
      code: '',
      status: message ? 'info' : 'idle',
      applied: false,
      discountType: '',
      discountValue: 0,
      shopifyDiscountValueType: '',
      shopifyDiscountValue: 0,
      shopifyDiscountTitle: '',
      shopifyDiscountApplicationType: '',
      discountAmount: 0,
      discountAmountCents: 0,
      freeShipping: false,
      source: '',
      shopifyCartApplied: false,
      shopifyCartOriginalTotal: 0,
      shopifyCartTotalAfterDiscount: 0,
      shopifyCartOriginalTotalCents: 0,
      shopifyCartTotalAfterDiscountCents: 0,
      message: message || ''
    };

    renderPromoStatus();
    renderTotals();
  }

  function handlePromoInputChange(e) {
    var input = e && e.target ? e.target : qs('[name="promo_code"]');

    if (!input) return;

    var cleaned = cleanPromoCode(input.value || '');

    if (input.value !== cleaned) {
      input.value = cleaned;
    }

    if (state.promoVisual && state.promoVisual.applied && cleaned !== state.promoVisual.code) {
      resetPromoVisual(cleaned ? CONFIG.texts.promoChanged : '');
    } else if (!cleaned && state.promoVisual && state.promoVisual.code) {
      resetPromoVisual('');
    } else if (cleaned && (!state.promoVisual || !state.promoVisual.applied)) {
      setPromoStatus('info', CONFIG.texts.promoChanged);
    }
  }

  function getCartTotalPricePesos(cart) {
    return Math.round(Number(cart && cart.total_price ? cart.total_price : 0) / 100);
  }

  function getCartOriginalTotalPricePesos(cart) {
    return Math.round(Number(cart && cart.original_total_price ? cart.original_total_price : 0) / 100);
  }

  function getCartDiscountPesos(cart) {
    return Math.round(Number(cart && cart.total_discount ? cart.total_discount : 0) / 100);
  }

  async function updateBacanimeCartAttributes(attributes) {
    if (!CONFIG.shopifyNativeDiscounts || !CONFIG.shopifyNativeDiscounts.saveCartAttributes) return null;

    try {
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: attributes || {} })
      });

      if (!response.ok) return null;

      return response.json();
    } catch (e) {
      return null;
    }
  }

  async function clearShopifyNativeDiscount() {
    var cart = await updateBacanimeCartDiscount('');

    if (cart) {
      await updateBacanimeCartAttributes({
        bacanime_discount_code: '',
        bacanime_discount_source: '',
        bacanime_discount_amount: '',
        bacanime_discount_amount_cents: '',
        bacanime_discount_cart_total: '',
        bacanime_discount_cart_total_cents: ''
      });
    }

    return cart;
  }

  function normalizeShopifyDiscountValueType(valueType) {
    var value = String(valueType || '').toLowerCase().trim();

    if (!value) return '';
    if (value.indexOf('percent') > -1 || value.indexOf('porcentaje') > -1 || value === 'percentage') return 'percentage';
    if (value.indexOf('fixed') > -1 || value.indexOf('amount') > -1 || value.indexOf('monto') > -1 || value.indexOf('fijo') > -1) return 'fixed_amount';
    if (value.indexOf('shipping') > -1 || value.indexOf('envio') > -1 || value.indexOf('envío') > -1) return 'shipping';

    return value;
  }

  function getShopifyDiscountApplication(cart, code) {
    var cleanedCode = cleanPromoCode(code || '');
    var applications = [];

    function addApplication(app) {
      if (!app || typeof app !== 'object') return;
      applications.push(app);
    }

    function addList(list) {
      if (!list || !list.length) return;
      list.forEach(addApplication);
    }

    addList(cart && cart.cart_level_discount_applications);
    addList(cart && cart.discount_applications);

    if (cart && cart.items && cart.items.length) {
      cart.items.forEach(function (item) {
        addList(item.line_level_discount_allocations);
        addList(item.discount_allocations);
        addList(item.discounts);
      });
    }

    var matched = null;

    applications.some(function (app) {
      var candidates = [
        app.code,
        app.title,
        app.key,
        app.discount_application && app.discount_application.code,
        app.discount_application && app.discount_application.title,
        app.discount_application && app.discount_application.key
      ];

      var found = candidates.some(function (candidate) {
        return cleanPromoCode(candidate || '') === cleanedCode;
      });

      if (found) {
        matched = app.discount_application || app;
        return true;
      }

      return false;
    });

    if (!matched && applications.length) {
      matched = applications[0].discount_application || applications[0];
    }

    if (!matched) {
      return {
        title: cleanedCode,
        applicationType: '',
        valueType: '',
        value: 0
      };
    }

    var rawValueType = matched.value_type || matched.valueType || matched.type || '';
    var normalizedValueType = normalizeShopifyDiscountValueType(rawValueType);
    var rawValue = matched.value || matched.discount_value || matched.amount || matched.total_allocated_amount || 0;
    var value = Number(String(rawValue).replace(',', '.')) || 0;

    return {
      title: matched.title || matched.code || matched.key || cleanedCode,
      applicationType: matched.type || matched.application_type || '',
      valueType: normalizedValueType,
      value: value
    };
  }

  async function validatePromoWithShopifyCart(code) {
    if (!CONFIG.shopifyNativeDiscounts || !CONFIG.shopifyNativeDiscounts.enabled) {
      return { applied: false, message: CONFIG.texts.promoValidationUnavailable };
    }

    var cleanedCode = cleanPromoCode(code || '');

    if (!cleanedCode) {
      return { applied: false, message: CONFIG.texts.promoEmpty };
    }

    var baselineCart = state.cart || await getCart();

    if (CONFIG.shopifyNativeDiscounts.clearDiscountBeforeApplying) {
      baselineCart = await clearShopifyNativeDiscount();
    }

    baselineCart = baselineCart || await getCart();

    var beforeTotalCents = Number(baselineCart.total_price || 0);
    var beforeDiscountCents = Number(baselineCart.total_discount || 0);

    var afterCart = await updateBacanimeCartDiscount(cleanedCode);

    if (!afterCart) {
      return { applied: false, message: CONFIG.texts.promoValidationUnavailable };
    }

    var afterTotalCents = Number(afterCart.total_price || 0);
    var afterDiscountCents = Number(afterCart.total_discount || 0);
    var discountAmountCents = 0;

    if (beforeTotalCents > afterTotalCents) {
      discountAmountCents = beforeTotalCents - afterTotalCents;
    } else if (afterDiscountCents > beforeDiscountCents) {
      discountAmountCents = afterDiscountCents - beforeDiscountCents;
    }

    if (discountAmountCents <= 0) {
      await clearShopifyNativeDiscount();

      return {
        applied: false,
        found: false,
        message: CONFIG.texts.promoInvalid
      };
    }

    var discountAmount = Math.round(discountAmountCents / 100);
    var totalAfterDiscount = Math.round(afterTotalCents / 100);
    var originalTotal = Math.round(Number(afterCart.original_total_price || beforeTotalCents || 0) / 100);
    var discountApplication = getShopifyDiscountApplication(afterCart, cleanedCode);

    await updateBacanimeCartAttributes({
      bacanime_discount_code: cleanedCode,
      bacanime_discount_source: 'shopify_native_cart',
      bacanime_discount_amount: String(discountAmount),
      bacanime_discount_amount_cents: String(discountAmountCents),
      bacanime_discount_value_type: String(discountApplication.valueType || ''),
      bacanime_discount_value: String(discountApplication.value || ''),
      bacanime_discount_title: String(discountApplication.title || cleanedCode),
      bacanime_discount_cart_total: String(totalAfterDiscount),
      bacanime_discount_cart_total_cents: String(afterTotalCents)
    });

    state.cart = afterCart;
    syncThemeCartCounter(afterCart.item_count || 0);

    return {
      applied: true,
      found: true,
      type: 'shopify_native',
      value: discountAmount,
      shopifyDiscountValueType: discountApplication.valueType || '',
      shopifyDiscountValue: discountApplication.value || 0,
      shopifyDiscountTitle: discountApplication.title || cleanedCode,
      shopifyDiscountApplicationType: discountApplication.applicationType || '',
      discountAmount: discountAmount,
      discountAmountCents: discountAmountCents,
      freeShipping: false,
      source: 'shopify_native_cart',
      shopifyCartApplied: true,
      shopifyCartOriginalTotal: originalTotal,
      shopifyCartTotalAfterDiscount: totalAfterDiscount,
      shopifyCartOriginalTotalCents: Number(afterCart.original_total_price || beforeTotalCents || 0),
      shopifyCartTotalAfterDiscountCents: afterTotalCents,
      message: CONFIG.texts.promoApplied
    };
  }

  async function applyPromoCode(silent) {
    try { await updateCloudQuote(true); if (!silent) showMessage('Total actualizado con Shopify.', 'ok'); return true; }
    catch (error) { showMessage(error.message, 'error'); return false; }
  }

  function markField(name, valid, message) {
    var input = qs('[name="' + name + '"]');
    var wrap = input ? input.closest('.bca-field') : null;

    if (!input || !wrap) return;

    var sel = wrap.querySelector('.bca-select');
    var err = wrap.querySelector('.bca-field-error');

    if (!valid) {
      input.classList.add('bca-invalid');
      wrap.classList.add('has-error');

      if (sel) sel.classList.add('is-invalid');
      if (err && message) err.textContent = message;
    } else {
      input.classList.remove('bca-invalid');
      wrap.classList.remove('has-error');

      if (sel) sel.classList.remove('is-invalid');
    }
  }

  function validateRequired() {
    var ok = true;
    var data = getFormData();

    ['first_name','last_name','phone','address1','address2','province','city'].forEach(function (name) {
      var valid = !!String(data[name] || '').trim();

      if (name === 'phone') {
        valid = !!validPhone(data.phone);
      }

      if (!valid) ok = false;

      markField(name, valid, name === 'phone' ? CONFIG.texts.phoneError : 'Este campo es obligatorio.');
    });

    if (data.email && !validEmail(data.email)) {
      markField('email', true, CONFIG.texts.emailError);
    } else {
      markField('email', true, '');
    }

    CONFIG.checks.forEach(function (c) {
      var input = qs('[name="' + c.name + '"]');

      if (!input || !input.checked) {
        ok = false;

        if (input) input.classList.add('bca-invalid');
      } else {
        input.classList.remove('bca-invalid');
      }
    });

    return ok;
  }

  function getCookie(name) {
    try {
      var m = document.cookie.match(new RegExp('(^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));

      return m ? decodeURIComponent(m[2]) : '';
    } catch (e) {
      return '';
    }
  }

  function setCookie(name, value, days) {
    try {
      var max = days ? '; max-age=' + (days * 24 * 60 * 60) : '';
      document.cookie = name + '=' + encodeURIComponent(value) + max + '; path=/; SameSite=Lax';
    } catch (e) {}
  }

  function getUrlParam(name) {
    try {
      return new URL(window.location.href).searchParams.get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function compactObject(obj) {
    var out = {};

    Object.keys(obj || {}).forEach(function (k) {
      var v = obj[k];

      if (v !== null && v !== undefined && String(v).trim() !== '') {
        out[k] = v;
      }
    });

    return out;
  }

  function buildMetaFbcFromFbclid(fbclid) {
    return fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : '';
  }


  /* =========================================================
     CONTEXTO UNIVERSAL DE LANDINGS BACANIME
     - Permite usar el mismo formulario en tienda normal y landings.
     - Cada landing solo debe declarar data-* en #bca-cod-mount.
     - No duplica Pixel ni cambia el flujo principal: solo agrega datos extra al payload.
  ========================================================= */

  function slugifyForTag(value) {
    return normalize(value || '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40);
  }

  function cleanLandingTitle(value) {
    var title = String(value || '').trim();

    if (!title) return '';

    title = title
      .replace(/\s+[—|-]\s+Bacanime.*$/i, '')
      .replace(/\s+[—|-]\s+BACANIME.*$/i, '')
      .replace(/\s+[—|-]\s+.*$/i, '')
      .replace(/\s+/g, ' ')
      .trim();

    return title;
  }

  function titleFromHandle(handle) {
    return String(handle || '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function getCurrentPathParts() {
    var path = '';

    try {
      path = decodeURIComponent(location.pathname || '');
    } catch (e) {
      path = location.pathname || '';
    }

    return path
      .split('/')
      .map(function (part) { return String(part || '').trim(); })
      .filter(Boolean);
  }

  function isExcludedLandingHandle(handle) {
    var excluded = (CONFIG.landingAutoDetect && CONFIG.landingAutoDetect.excludedPageHandles) || [];
    var normalizedHandle = slugifyForTag(handle || '');

    return excluded.some(function (item) {
      return slugifyForTag(item || '') === normalizedHandle;
    });
  }

  function inferCampaignGroupFromHandle(handle) {
    var h = normalize(handle || '');

    if (h.indexOf('combo') > -1) return 'combos';
    if (h.indexOf('camiseta') > -1 || h.indexOf('camisa') > -1) return 'camisetas';
    if (h.indexOf('cobija') > -1 || h.indexOf('manta') > -1) return 'cobijas';
    if (h.indexOf('media') > -1 || h.indexOf('medias') > -1) return 'medias';
    if (h.indexOf('pijama') > -1 || h.indexOf('pijamas') > -1) return 'pijamas';
    if (h.indexOf('oferta') > -1 || h.indexOf('descuento') > -1 || h.indexOf('promo') > -1 || h.indexOf('bodegazo') > -1) return 'promociones';
    if (h.indexOf('anime') > -1) return 'anime';
    if (h.indexOf('rock') > -1 || h.indexOf('metal') > -1 || h.indexOf('banda') > -1) return 'rock';

    return (CONFIG.landingAutoDetect && CONFIG.landingAutoDetect.defaultCampaignGroup) || 'landing';
  }

  function inferProductFocusFromHandle(handle) {
    var h = normalize(handle || '');
    var focus = [];

    if (h.indexOf('camiseta') > -1 || h.indexOf('camisa') > -1) focus.push('camisetas');
    if (h.indexOf('cobija') > -1 || h.indexOf('manta') > -1) focus.push('cobijas');
    if (h.indexOf('media') > -1 || h.indexOf('medias') > -1) focus.push('medias');
    if (h.indexOf('pijama') > -1 || h.indexOf('pijamas') > -1) focus.push('pijamas');
    if (h.indexOf('anime') > -1) focus.push('anime');
    if (h.indexOf('rock') > -1 || h.indexOf('metal') > -1 || h.indexOf('banda') > -1) focus.push('rock');
    if (h.indexOf('geek') > -1 || h.indexOf('gamer') > -1 || h.indexOf('videojuego') > -1) focus.push('geek');
    if (h.indexOf('marvel') > -1) focus.push('marvel');
    if (h.indexOf('dc') > -1) focus.push('dc');

    if (!focus.length && CONFIG.landingAutoDetect && CONFIG.landingAutoDetect.defaultProductFocus) {
      focus.push(CONFIG.landingAutoDetect.defaultProductFocus);
    }

    return focus.join(' ');
  }

  function getAutomaticLandingContextFromUrl() {
    var autoConfig = CONFIG.landingAutoDetect || {};

    if (autoConfig.enabled === false) {
      return {};
    }

    var parts = getCurrentPathParts();
    var path = location.pathname || '';
    var handle = '';
    var isLanding = false;

    if (autoConfig.treatShopifyPagesAsLandings !== false && parts[0] === 'pages' && parts[1]) {
      handle = parts[1];
      isLanding = true;
    }

    if (!isLanding && Array.isArray(autoConfig.landingPathPrefixes)) {
      autoConfig.landingPathPrefixes.forEach(function (prefix) {
        if (isLanding) return;

        prefix = String(prefix || '').trim();

        if (!prefix) return;

        if (path.indexOf(prefix) === 0) {
          var cleanPrefix = prefix.replace(/^\/+|\/+$/g, '');
          var prefixParts = cleanPrefix ? cleanPrefix.split('/') : [];
          handle = parts[prefixParts.length] || parts[parts.length - 1] || '';
          isLanding = !!handle;
        }
      });
    }

    if (!isLanding || !handle || isExcludedLandingHandle(handle)) {
      return {};
    }

    var title = cleanLandingTitle(document.title) || titleFromHandle(handle);
    var landingId = slugifyForTag(handle);

    return {
      source_type: 'landing',
      is_landing: true,
      landing_id: landingId,
      landing_name: title,
      offer_name: title,
      page_type: 'landing',
      campaign_group: inferCampaignGroupFromHandle(handle),
      product_focus: inferProductFocusFromHandle(handle),
      auto_detected: true,
      auto_detected_from: 'url_path',
      original_handle: handle
    };
  }

  function getDatasetFromMount() {
    var mount = qs('#bca-cod-mount') || qs('#bca-cod-root') || null;
    var data = mount && mount.dataset ? mount.dataset : {};

    return {
      source_type: data.sourceType || data.bcaSourceType || '',
      landing_id: data.landingId || data.bcaLandingId || '',
      landing_name: data.landingName || data.bcaLandingName || '',
      offer_name: data.offerName || data.bcaOfferName || '',
      page_type: data.pageType || data.bcaPageType || '',
      campaign_group: data.campaignGroup || data.bcaCampaignGroup || '',
      product_focus: data.productFocus || data.bcaProductFocus || ''
    };
  }

  function getUrlTrackingContext() {
    return {
      utm_source: getUrlParam('utm_source'),
      utm_medium: getUrlParam('utm_medium'),
      utm_campaign: getUrlParam('utm_campaign'),
      utm_content: getUrlParam('utm_content'),
      utm_term: getUrlParam('utm_term'),
      utm_id: getUrlParam('utm_id'),
      fbclid: getUrlParam('fbclid'),
      gclid: getUrlParam('gclid'),
      ttclid: getUrlParam('ttclid'),
      msclkid: getUrlParam('msclkid'),
      campaign_id: getUrlParam('campaign_id') || getUrlParam('utm_campaign_id'),
      adset_id: getUrlParam('adset_id') || getUrlParam('utm_adset_id'),
      ad_id: getUrlParam('ad_id') || getUrlParam('utm_ad_id'),
      campaign_name: getUrlParam('campaign_name'),
      adset_name: getUrlParam('adset_name'),
      ad_name: getUrlParam('ad_name'),
      placement: getUrlParam('placement'),
      site_source_name: getUrlParam('site_source_name')
    };
  }

  function getBcaLandingContext() {
    var dataset = getDatasetFromMount();
    var existing = window.BCA_LANDING_CONTEXT || {};
    var automatic = getAutomaticLandingContextFromUrl();
    var urlTracking = getUrlTrackingContext();

    var landingId = dataset.landing_id || existing.landing_id || automatic.landing_id || '';
    var landingName = dataset.landing_name || existing.landing_name || automatic.landing_name || '';
    var offerName = dataset.offer_name || existing.offer_name || automatic.offer_name || landingName || '';
    var campaignGroup = dataset.campaign_group || existing.campaign_group || automatic.campaign_group || '';
    var productFocus = dataset.product_focus || existing.product_focus || automatic.product_focus || '';

    var sourceType = dataset.source_type || existing.source_type || automatic.source_type || '';
    var pageType = dataset.page_type || existing.page_type || automatic.page_type || '';

    if (!sourceType) {
      sourceType = (landingId || landingName || offerName) ? 'landing' : 'normal_store';
    }

    if (!pageType) {
      pageType = sourceType === 'landing' ? 'landing' : 'store';
    }

    return {
      source_type: sourceType,
      is_landing: sourceType === 'landing' || pageType === 'landing',
      landing_id: landingId,
      landing_name: landingName,
      offer_name: offerName,
      page_type: pageType,
      campaign_group: campaignGroup,
      product_focus: productFocus,
      auto_detected: !!automatic.auto_detected && !dataset.landing_id,
      auto_detected_from: automatic.auto_detected_from || '',
      original_handle: automatic.original_handle || '',

      page_url: window.location.href,
      page_path: location.pathname || '',
      page_title: document.title || '',
      referrer: document.referrer || '',

      utm_source: urlTracking.utm_source || existing.utm_source || '',
      utm_medium: urlTracking.utm_medium || existing.utm_medium || '',
      utm_campaign: urlTracking.utm_campaign || existing.utm_campaign || '',
      utm_content: urlTracking.utm_content || existing.utm_content || '',
      utm_term: urlTracking.utm_term || existing.utm_term || '',
      utm_id: urlTracking.utm_id || existing.utm_id || '',

      fbclid: urlTracking.fbclid || existing.fbclid || '',
      gclid: urlTracking.gclid || existing.gclid || '',
      ttclid: urlTracking.ttclid || existing.ttclid || '',
      msclkid: urlTracking.msclkid || existing.msclkid || '',

      campaign_id: urlTracking.campaign_id || existing.campaign_id || '',
      adset_id: urlTracking.adset_id || existing.adset_id || '',
      ad_id: urlTracking.ad_id || existing.ad_id || '',
      campaign_name: urlTracking.campaign_name || existing.campaign_name || '',
      adset_name: urlTracking.adset_name || existing.adset_name || '',
      ad_name: urlTracking.ad_name || existing.ad_name || '',
      placement: urlTracking.placement || existing.placement || '',
      site_source_name: urlTracking.site_source_name || existing.site_source_name || '',

      captured_at: nowIso()
    };
  }

  function initLandingContext() {
    var context = getBcaLandingContext();

    window.BCA_LANDING_CONTEXT = context;

    if (window.BCA_LANDING_CONTEXT_READY_SENT) return context;
    window.BCA_LANDING_CONTEXT_READY_SENT = true;

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'bca_landing_context_ready',
        bca_source_type: context.source_type,
        bca_is_landing: context.is_landing,
        bca_landing_id: context.landing_id,
        bca_landing_name: context.landing_name,
        bca_offer_name: context.offer_name,
        bca_page_type: context.page_type,
        bca_campaign_group: context.campaign_group,
        bca_product_focus: context.product_focus,
        bca_landing_auto_detected: context.auto_detected,
        bca_landing_auto_detected_from: context.auto_detected_from,
        page_url: context.page_url,
        utm_source: context.utm_source,
        utm_medium: context.utm_medium,
        utm_campaign: context.utm_campaign,
        utm_content: context.utm_content,
        utm_term: context.utm_term
      });
    } catch (e) {}

    return context;
  }



  /* =========================================================
     ATRIBUCIÓN PRO BACANIME FIRST TOUCH / LAST TOUCH
     - Guarda primera fuente y última fuente por 30 días.
     - Evita perder ventas asistidas por Meta.
     - Mantiene compatibilidad con bca_attribution_v3.
  ========================================================= */

  function getReferrerInfo() {
    var ref = document.referrer || '';
    var currentHost = location.hostname || '';
    var refHost = '';

    try {
      refHost = ref ? new URL(ref).hostname : '';
    } catch (e) {
      refHost = '';
    }

    return {
      referrer: ref,
      referrer_host: refHost,
      is_internal: !!(refHost && currentHost && refHost.replace(/^www\./, '') === currentHost.replace(/^www\./, ''))
    };
  }

  function hasAttributionSignal(params) {
    params = params || {};

    return !!(
      params.utm_source ||
      params.utm_medium ||
      params.utm_campaign ||
      params.utm_content ||
      params.utm_term ||
      params.utm_id ||
      params.utm_campaign_id ||
      params.utm_adset_id ||
      params.utm_ad_id ||
      params.campaign_id ||
      params.adset_id ||
      params.ad_id ||
      params.fbclid ||
      params.gclid ||
      params.ttclid ||
      params.msclkid ||
      params.gbraid ||
      params.wbraid ||
      params.srsltid
    );
  }

  function detectTouchSource(params, refInfo) {
    params = params || {};
    refInfo = refInfo || getReferrerInfo();

    var source = params.utm_source || params.source || '';
    var medium = params.utm_medium || params.medium || '';

    if (!source && (params.fbclid || params.campaign_id || params.adset_id || params.ad_id || params.utm_campaign_id || params.utm_adset_id || params.utm_ad_id || params.site_source_name === 'fb' || params.site_source_name === 'ig')) {
      source = 'meta';
    }

    if (!medium && (params.fbclid || params.campaign_id || params.adset_id || params.ad_id || params.utm_campaign_id || params.utm_adset_id || params.utm_ad_id)) {
      medium = 'paid_social';
    }

    if (!source && (params.gclid || params.gbraid || params.wbraid)) {
      source = 'google';
    }

    if (!medium && (params.gclid || params.gbraid || params.wbraid)) {
      medium = 'paid_search';
    }

    if (!source && params.ttclid) {
      source = 'tiktok';
    }

    if (!medium && params.ttclid) {
      medium = 'paid_social';
    }

    if (!source && params.msclkid) {
      source = 'microsoft';
    }

    if (!medium && params.msclkid) {
      medium = 'paid_search';
    }

    if (!source && params.srsltid) {
      source = 'google';
    }

    if (!medium && params.srsltid) {
      medium = 'organic_or_merchant';
    }

    if (!source && refInfo.referrer && !refInfo.is_internal) {
      source = refInfo.referrer_host || refInfo.referrer;
      medium = 'referral';
    }

    if (!source) source = 'direct';
    if (!medium) medium = 'none';

    return {
      source: source,
      medium: medium
    };
  }

  function isMetaTouch(touch) {
    var d = touch && touch.data ? touch.data : touch || {};
    var source = String(d.source || '').toLowerCase();
    var medium = String(d.medium || '').toLowerCase();

    return !!(
      d.fbclid ||
      d.fbc ||
      d.campaign_id ||
      d.adset_id ||
      d.ad_id ||
      source === 'meta' ||
      source.indexOf('facebook') > -1 ||
      source.indexOf('instagram') > -1 ||
      d.site_source_name === 'fb' ||
      d.site_source_name === 'ig' ||
      (source === 'meta' && medium.indexOf('paid') > -1)
    );
  }

  function isPaidTouch(touch) {
    var d = touch && touch.data ? touch.data : touch || {};
    var medium = String(d.medium || '').toLowerCase();

    return !!(
      isMetaTouch(touch) ||
      d.gclid ||
      d.ttclid ||
      d.msclkid ||
      d.gbraid ||
      d.wbraid ||
      medium.indexOf('paid') > -1 ||
      medium.indexOf('cpc') > -1 ||
      medium.indexOf('ppc') > -1 ||
      medium.indexOf('ads') > -1
    );
  }

  function isWeakDirectTouch(touch) {
    var d = touch && touch.data ? touch.data : touch || {};
    var source = String(d.source || '').toLowerCase();
    var medium = String(d.medium || '').toLowerCase();

    return (!hasAttributionSignal(d) && (source === 'direct' || source === '') && (medium === 'none' || medium === ''));
  }

  function buildAttributionTouch(type, params, landingPage, referrerOverride) {
    params = params || {};

    var refInfo = getReferrerInfo();

    if (typeof referrerOverride === 'string') {
      refInfo.referrer = referrerOverride;
    }

    var detected = detectTouchSource(params, refInfo);
    var fbclid = params.fbclid || '';
    var fbc = getCookie('_fbc') || (fbclid ? buildMetaFbcFromFbclid(fbclid) : '');

    if (fbclid && !getCookie('_fbc')) {
      setCookie('_fbc', fbc, 90);
    }

    var createdAt = nowIso();

    return {
      type: type || 'touch',
      data: {
        source: detected.source,
        medium: detected.medium,

        campaign: params.utm_campaign || params.campaign_name || params.campaign || '',
        content: params.utm_content || params.ad_name || params.content || '',
        term: params.utm_term || params.adset_name || params.term || '',
        utm_id: params.utm_id || params.utm_campaign_id || params.campaign_id || '',

        campaign_id: params.utm_campaign_id || params.campaign_id || '',
        adset_id: params.utm_adset_id || params.adset_id || '',
        ad_id: params.utm_ad_id || params.ad_id || '',
        placement: params.placement || '',
        site_source_name: params.site_source_name || '',

        fbclid: fbclid,
        gclid: params.gclid || '',
        ttclid: params.ttclid || '',
        msclkid: params.msclkid || '',
        gbraid: params.gbraid || '',
        wbraid: params.wbraid || '',
        srsltid: params.srsltid || '',

        fbp: getCookie('_fbp') || '',
        fbc: fbc || '',

        landing_page: landingPage || window.location.href,
        referrer: refInfo.referrer || '',
        referrer_host: refInfo.referrer_host || '',
        is_internal_referrer: !!refInfo.is_internal,

        page_url: window.location.href,
        page_path: location.pathname || '',
        page_title: document.title || '',
        created_at: createdAt
      }
    };
  }

  function getAttributionPro() {
    var key = 'bca_attribution_pro_v1';
    var stored = safeJsonParse(safeStorageGet(localStorage, key), {});

    return {
      version: 'bca_attribution_pro_v1',
      first_touch: stored.first_touch || null,
      last_touch: stored.last_touch || null,
      first_paid_touch: stored.first_paid_touch || null,
      first_meta_touch: stored.first_meta_touch || null,
      last_paid_touch: stored.last_paid_touch || null,
      last_meta_touch: stored.last_meta_touch || null,
      updated_at: stored.updated_at || '',
      expires_at: stored.expires_at || ''
    };
  }

  function collectUrlTrackingParams() {
    var names = [
      'utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id',
      'utm_source_platform','utm_creative_format','utm_marketing_tactic',
      'fbclid','gclid','ttclid','msclkid','gbraid','wbraid','srsltid',
      'utm_campaign_id','utm_adset_id','utm_ad_id',
      'campaign_id','adset_id','ad_id','campaign_name','adset_name','ad_name',
      'placement','site_source_name','source','medium','campaign','content','term'
    ];

    var out = {};

    names.forEach(function (n) {
      out[n] = getUrlParam(n);
    });

    return compactObject(out);
  }

  function detectDeviceInfo() {
    var ua = String(navigator.userAgent || '');
    var platform = String(navigator.platform || '');
    var lower = platform.toLowerCase();
    var maxTouch = Number(navigator.maxTouchPoints || 0);
    var width = Number(window.innerWidth || (window.screen && window.screen.width) || 0);

    var os = 'Desconocido';

    if (/android/i.test(ua)) os = 'Android';
    else if (/iphone|ipad|ipod/i.test(ua) || (lower === 'macintel' && maxTouch > 1)) os = 'iOS / iPadOS';
    else if (/windows nt/i.test(ua)) os = 'Windows';
    else if (/mac os x|macintosh/i.test(ua)) os = 'macOS';
    else if (/linux/i.test(ua)) os = 'Linux';

    var browser = 'Desconocido';

    if (/edg\//i.test(ua)) browser = 'Microsoft Edge';
    else if (/opr\//i.test(ua) || /opera/i.test(ua)) browser = 'Opera';
    else if (/firefox\//i.test(ua)) browser = 'Firefox';
    else if (/crios\//i.test(ua)) browser = 'Chrome iOS';
    else if (/samsungbrowser\//i.test(ua)) browser = 'Samsung Internet';
    else if (/chrome\//i.test(ua) && /safari\//i.test(ua)) browser = 'Chrome';
    else if (/safari\//i.test(ua) && !/chrome\//i.test(ua)) browser = 'Safari';

    var deviceType = 'Desktop';

    if (/ipad|tablet/i.test(ua) || (lower === 'macintel' && maxTouch > 1)) {
      deviceType = 'Tablet';
    } else if (/mobi|iphone|ipod|android.*mobile|windows phone/i.test(ua) || width <= 767) {
      deviceType = 'Móvil';
    }

    return {
      detected_os: os,
      detected_browser: browser,
      detected_device_type: deviceType,
      is_mobile: deviceType !== 'Desktop',
      is_ios: os === 'iOS / iPadOS',
      is_android: os === 'Android',
      platform: platform,
      vendor: navigator.vendor || '',
      max_touch_points: maxTouch,
      user_agent: ua
    };
  }


  function getNetworkConnectionInfo() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;

    if (!connection) {
      return {
        effective_type: '',
        downlink: '',
        rtt: '',
        save_data: false
      };
    }

    return {
      effective_type: connection.effectiveType || '',
      downlink: connection.downlink || '',
      rtt: connection.rtt || '',
      save_data: !!connection.saveData
    };
  }

  function getDefaultClientIpInfo(status, source, message) {
    return {
      client_ip_address: '',
      client_ip_source: source || 'not_available_frontend',
      client_ip_status: status || 'empty',
      client_ip_message: message || 'Con proxy, JavaScript no necesita leer la IP. Cloudflare Worker captura la IP real server-side y la inyecta en Make/meta_capi_ready.',
      client_ip_captured_at: '',
      client_ip_provider: '',
      client_ip_attempts: []
    };
  }

  function getClientIpInfo() {
    return state.clientIpInfo || getDefaultClientIpInfo('pending_or_unavailable', 'frontend_memory_empty', 'La IP la debe inyectar Cloudflare Worker al recibir el POST. En frontend puede aparecer vacía y eso está bien.');
  }

  function isValidPublicIpValue(value) {
    var ip = String(value || '').trim();

    if (!ip) return false;

    return /^\d{1,3}(\.\d{1,3}){3}$/.test(ip) || /^[a-f0-9:]{6,}$/i.test(ip);
  }

  function fetchJsonWithTimeout(url, timeoutMs) {
    timeoutMs = Number(timeoutMs || 1000);

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = null;

    if (controller) {
      timer = setTimeout(function () {
        try { controller.abort(); } catch (e) {}
      }, timeoutMs);
    }

    return fetch(url, {
      method: 'GET',
      credentials: 'omit',
      cache: 'no-store',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (timer) clearTimeout(timer);
      if (!response.ok) throw new Error('IP lookup HTTP ' + response.status);
      return response.json();
    }).catch(function (error) {
      if (timer) clearTimeout(timer);
      throw error;
    });
  }

  async function ensureClientIpCaptured(force) {
    var cfg = CONFIG.trackingPro || {};

    if (!cfg.enabled || !cfg.clientIpLookupEnabled) {
      state.clientIpInfo = state.clientIpInfo || getDefaultClientIpInfo('disabled', 'config_disabled', 'IP lookup frontend desactivado: Cloudflare Worker captura la IP server-side.');
      return state.clientIpInfo;
    }

    if (!force && state.clientIpInfo && state.clientIpInfo.client_ip_status === 'ok' && state.clientIpInfo.client_ip_address) {
      return state.clientIpInfo;
    }

    if (!force && state.clientIpLookupPromise) {
      return state.clientIpLookupPromise;
    }

    var providers = Array.isArray(cfg.clientIpProviders) ? cfg.clientIpProviders.slice() : [];
    var timeoutMs = Number(cfg.clientIpLookupTimeoutMs || 1000);

    if (!providers.length) {
      state.clientIpInfo = getDefaultClientIpInfo('no_provider', 'config_empty', 'No hay proveedores de IP configurados.');
      return state.clientIpInfo;
    }

    state.clientIpLookupStartedAt = Date.now();
    var attempts = [];

    state.clientIpLookupPromise = (async function () {
      for (var i = 0; i < providers.length; i++) {
        var provider = providers[i];

        try {
          var data = await fetchJsonWithTimeout(provider, timeoutMs);
          attempts.push({ provider: provider, ok: true, at: nowIso() });
          var ip = data && (data.ip || data.query || data.address || data.client_ip || data.ipAddress || '');

          if (isValidPublicIpValue(ip)) {
            state.clientIpInfo = {
              client_ip_address: String(ip).trim(),
              client_ip_source: 'frontend_public_ip_lookup',
              client_ip_status: 'ok',
              client_ip_message: 'IP pública capturada como fallback frontend, aunque el proxy debe reemplazar/enriquecer server-side.',
              client_ip_captured_at: nowIso(),
              client_ip_provider: provider,
              client_ip_attempts: attempts
            };

            try {
              safeStorageSet(sessionStorage, 'bca_client_ip_info', JSON.stringify(state.clientIpInfo));
            } catch (storageError) {}

            return state.clientIpInfo;
          }
        } catch (e) {
          attempts.push({ provider: provider, ok: false, error: e && e.message ? e.message : 'lookup_failed', at: nowIso() });
        }
      }

      var cached = safeJsonParse(safeStorageGet(sessionStorage, 'bca_client_ip_info'), null);

      if (cached && cached.client_ip_address) {
        state.clientIpInfo = cached;
        return state.clientIpInfo;
      }

      state.clientIpInfo = getDefaultClientIpInfo('failed', 'frontend_public_ip_lookup_failed', 'No se capturó IP desde frontend. El pedido se envía igual: Cloudflare Worker debe inyectar la IP real server-side.');
      state.clientIpInfo.client_ip_attempts = attempts;
      return state.clientIpInfo;
    })();

    try {
      return await state.clientIpLookupPromise;
    } finally {
      state.clientIpLookupPromise = null;
    }
  }

  function getMetaPlatformFromSignals(data) {
    data = data || {};

    var siteSource = String(data.site_source_name || '').toLowerCase().trim();
    var placement = String(data.placement || '').toLowerCase().trim();
    var source = normalize(data.utm_source || data.source || '');
    var pageRef = normalize(data.referrer_host || data.referrer || '');

    var out = {
      is_meta: false,
      meta_platform: '',
      meta_platform_label: '',
      meta_source_exact: '',
      meta_source_reason: '',
      placement: data.placement || '',
      site_source_name: data.site_source_name || ''
    };

    function setMeta(platform, label, reason) {
      out.is_meta = true;
      out.meta_platform = platform;
      out.meta_platform_label = label;
      out.meta_source_exact = platform;
      out.meta_source_reason = reason || '';
    }

    if (siteSource === 'ig') setMeta('instagram', 'Instagram', 'site_source_name_ig');
    else if (siteSource === 'fb') setMeta('facebook', 'Facebook', 'site_source_name_fb');
    else if (siteSource === 'msg' || siteSource === 'messenger') setMeta('messenger', 'Messenger', 'site_source_name_msg');
    else if (siteSource === 'an' || siteSource === 'audience_network') setMeta('audience_network', 'Audience Network', 'site_source_name_an');
    else if (placement.indexOf('instagram') > -1 || placement.indexOf('ig_') > -1) setMeta('instagram', 'Instagram', 'placement_instagram');
    else if (placement.indexOf('facebook') > -1 || placement.indexOf('fb_') > -1) setMeta('facebook', 'Facebook', 'placement_facebook');
    else if (placement.indexOf('messenger') > -1) setMeta('messenger', 'Messenger', 'placement_messenger');
    else if (placement.indexOf('audience') > -1) setMeta('audience_network', 'Audience Network', 'placement_audience_network');
    else if (source === 'instagram' || source === 'ig') setMeta('instagram', 'Instagram', 'utm_source_instagram');
    else if (source === 'facebook' || source === 'fb') setMeta('facebook', 'Facebook', 'utm_source_facebook');
    else if (source === 'meta' || data.fbclid || data.fbc || data._fbc || data.campaign_id || data.adset_id || data.ad_id) setMeta('meta', 'Meta', 'meta_signal_generic');
    else if (pageRef.indexOf('instagram') > -1) setMeta('instagram', 'Instagram', 'referrer_instagram');
    else if (pageRef.indexOf('facebook') > -1 || pageRef.indexOf('fb.') > -1) setMeta('facebook', 'Facebook', 'referrer_facebook');

    return out;
  }

  function getPlacementBucket(placement) {
    var p = normalize(placement || '');

    if (!p) return '';
    if (p.indexOf('reels') > -1 || p.indexOf('reel') > -1) return 'reels';
    if (p.indexOf('stor') > -1) return 'stories';
    if (p.indexOf('feed') > -1) return 'feed';
    if (p.indexOf('search') > -1) return 'search';
    if (p.indexOf('marketplace') > -1) return 'marketplace';
    if (p.indexOf('video') > -1 || p.indexOf('watch') > -1) return 'video';
    if (p.indexOf('explore') > -1) return 'explore';

    return p.slice(0, 60);
  }

  function getPaidChannelFromSignals(data, metaPlatformInfo) {
    data = data || {};
    metaPlatformInfo = metaPlatformInfo || getMetaPlatformFromSignals(data);

    var medium = normalize(data.utm_medium || data.medium || '');

    if (metaPlatformInfo.is_meta) return 'meta_paid_social';
    if (data.ttclid) return 'tiktok_paid_social';
    if (data.gclid || data.gbraid || data.wbraid) return 'google_paid';
    if (data.msclkid) return 'microsoft_paid';
    if (medium.indexOf('paid') > -1 || medium.indexOf('cpc') > -1 || medium.indexOf('ppc') > -1) return 'paid_other';

    return medium || 'none';
  }

  function repairAttributionMergedForMetaSignals(merged, stored, fbc) {
    var out = {};
    var repaired = false;
    var reasons = [];

    Object.keys(merged || {}).forEach(function (k) {
      out[k] = merged[k];
    });

    var source = normalize(out.utm_source || out.source || '');
    var medium = normalize(out.utm_medium || out.medium || '');
    var siteSource = String(out.site_source_name || '').toLowerCase();

    var hasMetaSignal = !!(
      out.fbclid ||
      out.fbc ||
      out._fbc ||
      fbc ||
      stored.fbclid ||
      stored.fbc ||
      out.campaign_id ||
      out.adset_id ||
      out.ad_id ||
      out.utm_campaign_id ||
      out.utm_adset_id ||
      out.utm_ad_id ||
      siteSource === 'fb' ||
      siteSource === 'ig'
    );

    if (hasMetaSignal && (!source || source === 'direct' || source === 'none' || source === '(direct)')) {
      out.utm_source = siteSource === 'ig' ? 'instagram' : (siteSource === 'fb' ? 'facebook' : 'meta');
      out.source = out.utm_source;
      repaired = true;
      reasons.push('utm_source_reparado_por_senales_meta');
    }

    if (hasMetaSignal && (!medium || medium === 'none' || medium === 'direct' || medium === '(none)')) {
      out.utm_medium = 'paid_social';
      out.medium = 'paid_social';
      repaired = true;
      reasons.push('utm_medium_reparado_por_senales_meta');
    }

    return {
      merged: out,
      repaired: repaired,
      reason: reasons.join(' | '),
      has_meta_signal: hasMetaSignal
    };
  }

  function initAttribution() {
    var legacyKey = 'bca_attribution_v3';
    var proKey = 'bca_attribution_pro_v1';
    var stored = safeJsonParse(safeStorageGet(localStorage, proKey), {});
    var legacy = safeJsonParse(safeStorageGet(localStorage, legacyKey), {});
    var sessionKey = 'bca_landing_page';
    var daysToKeep = 30;
    var expiresAt = Date.now() + (daysToKeep * 24 * 60 * 60 * 1000);

    if (stored.expires_at && Number(stored.expires_at) < Date.now()) {
      stored = {};
    }

    if (!safeStorageGet(sessionStorage, sessionKey)) {
      safeStorageSet(sessionStorage, sessionKey, window.location.href);
    }

    var urlParams = collectUrlTrackingParams();
    var hasSignal = hasAttributionSignal(urlParams);
    var currentTouch = buildAttributionTouch('last_touch', urlParams, window.location.href, document.referrer || '');

    if (!stored.first_touch) {
      stored.first_touch = buildAttributionTouch('first_touch', urlParams, window.location.href, document.referrer || '');
    } else if (isWeakDirectTouch(stored.first_touch) && hasSignal) {
      stored.first_touch = buildAttributionTouch('first_touch', urlParams, window.location.href, document.referrer || '');
    }

    if (isPaidTouch(currentTouch) && !stored.first_paid_touch) {
      stored.first_paid_touch = {
        type: 'first_paid_touch',
        data: currentTouch.data
      };
    }

    if (isPaidTouch(currentTouch)) {
      stored.last_paid_touch = {
        type: 'last_paid_touch',
        data: currentTouch.data
      };
    }

    if (isMetaTouch(currentTouch) && !stored.first_meta_touch) {
      stored.first_meta_touch = {
        type: 'first_meta_touch',
        data: currentTouch.data
      };
    }

    if (isMetaTouch(currentTouch)) {
      stored.last_meta_touch = {
        type: 'last_meta_touch',
        data: currentTouch.data
      };
    }

    if (isMetaTouch(currentTouch) && isWeakDirectTouch(stored.first_touch)) {
      stored.first_touch = {
        type: 'first_touch',
        data: currentTouch.data
      };
    }

    stored.last_touch = currentTouch;
    stored.browser_id = getBrowserId();
    stored.updated_at = nowIso();
    stored.expires_at = expiresAt;

    if (urlParams.fbclid) {
      stored.fbclid = urlParams.fbclid;
      stored.fbc = currentTouch.data.fbc || buildMetaFbcFromFbclid(urlParams.fbclid);
    }

    ['gclid','ttclid','msclkid','gbraid','wbraid','srsltid'].forEach(function (k) {
      if (urlParams[k]) stored[k] = urlParams[k];
    });

    safeStorageSet(localStorage, proKey, JSON.stringify(stored));

    legacy.first_touch = legacy.first_touch || {
      captured_at: stored.first_touch && stored.first_touch.data ? stored.first_touch.data.created_at : nowIso(),
      landing_page: stored.first_touch && stored.first_touch.data ? stored.first_touch.data.landing_page : window.location.href,
      referrer: stored.first_touch && stored.first_touch.data ? stored.first_touch.data.referrer : document.referrer || '',
      params: urlParams
    };

    legacy.last_touch = {
      captured_at: stored.last_touch && stored.last_touch.data ? stored.last_touch.data.created_at : nowIso(),
      landing_page: stored.last_touch && stored.last_touch.data ? stored.last_touch.data.landing_page : window.location.href,
      referrer: stored.last_touch && stored.last_touch.data ? stored.last_touch.data.referrer : document.referrer || '',
      params: urlParams
    };

    legacy.browser_id = stored.browser_id;
    legacy.updated_at = stored.updated_at;
    legacy.fbclid = stored.fbclid || legacy.fbclid || '';
    legacy.fbc = stored.fbc || legacy.fbc || '';

    safeStorageSet(localStorage, legacyKey, JSON.stringify(legacy));

    window.BCA_ATTRIBUTION = {
      get: function () {
        return getAttributionPro();
      }
    };

    return stored;
  }

  function readAttribution() {
    var stored = initAttribution();
    var pro = getAttributionPro();

    var firstData = (pro.first_touch && pro.first_touch.data) || {};
    var lastData = (pro.last_touch && pro.last_touch.data) || {};
    var firstPaidData = (pro.first_paid_touch && pro.first_paid_touch.data) || {};
    var firstMetaData = (pro.first_meta_touch && pro.first_meta_touch.data) || {};
    var lastPaidData = (pro.last_paid_touch && pro.last_paid_touch.data) || {};
    var lastMetaData = (pro.last_meta_touch && pro.last_meta_touch.data) || {};
    var current = collectUrlTrackingParams();

    var merged = {};

    [firstData, firstPaidData, firstMetaData, lastData, lastPaidData, lastMetaData, current].forEach(function (src) {
      Object.keys(src || {}).forEach(function (k) {
        if (src[k]) merged[k] = src[k];
      });
    });

    var device = detectDeviceInfo();
    var fbp = getCookie('_fbp') || merged.fbp || '';
    var fbc = getCookie('_fbc') || merged.fbc || stored.fbc || buildMetaFbcFromFbclid(merged.fbclid || stored.fbclid || '');
    var repair = CONFIG.trackingPro && CONFIG.trackingPro.repairMetaDirectAttribution
      ? repairAttributionMergedForMetaSignals(merged, stored, fbc)
      : { merged: merged, repaired: false, reason: '', has_meta_signal: false };

    merged = repair.merged || merged;

    var metaPlatformInfo = getMetaPlatformFromSignals(merged);
    var paidChannel = getPaidChannelFromSignals(merged, metaPlatformInfo);
    var placementBucket = getPlacementBucket(merged.placement || '');

    var result = {
      attribution_version: 'bca_attribution_v80_1_landing_stable_worker_proxy_cors_safe',
      attribution_repair_applied: !!repair.repaired,
      attribution_repair_reason: repair.reason || '',
      attribution_has_meta_signal: !!repair.has_meta_signal,
      paid_channel: paidChannel,
      traffic_source_exact: metaPlatformInfo.meta_source_exact || (merged.utm_source || merged.source || ''),
      traffic_platform: metaPlatformInfo.is_meta ? 'meta' : (paidChannel.indexOf('google') === 0 ? 'google' : (paidChannel.indexOf('tiktok') === 0 ? 'tiktok' : '')),
      meta_platform: metaPlatformInfo.meta_platform || '',
      meta_platform_label: metaPlatformInfo.meta_platform_label || '',
      meta_source_exact: metaPlatformInfo.meta_source_exact || '',
      meta_source_reason: metaPlatformInfo.meta_source_reason || '',
      meta_placement_bucket: placementBucket,
      is_meta_traffic: !!metaPlatformInfo.is_meta,
      is_instagram_traffic: metaPlatformInfo.meta_platform === 'instagram',
      is_facebook_traffic: metaPlatformInfo.meta_platform === 'facebook',
      browser_id: stored.browser_id || getBrowserId(),
      session_id: state.sessionId,

      utm_source: merged.utm_source || merged.source || '',
      utm_medium: merged.utm_medium || merged.medium || '',
      utm_campaign: merged.utm_campaign || merged.campaign || '',
      utm_content: merged.utm_content || merged.content || '',
      utm_term: merged.utm_term || merged.term || '',
      utm_id: merged.utm_id || merged.utm_campaign_id || merged.campaign_id || '',

      campaign_id: merged.campaign_id || '',
      adset_id: merged.adset_id || '',
      ad_id: merged.ad_id || '',
      campaign_name: merged.campaign_name || merged.utm_campaign || merged.campaign || '',
      adset_name: merged.adset_name || merged.utm_term || merged.term || '',
      ad_name: merged.ad_name || merged.utm_content || merged.content || '',
      placement: merged.placement || '',
      site_source_name: merged.site_source_name || '',

      fbclid: merged.fbclid || stored.fbclid || '',
      gclid: merged.gclid || stored.gclid || '',
      ttclid: merged.ttclid || stored.ttclid || '',
      msclkid: merged.msclkid || stored.msclkid || '',
      gbraid: merged.gbraid || stored.gbraid || '',
      wbraid: merged.wbraid || stored.wbraid || '',
      srsltid: merged.srsltid || stored.srsltid || '',
      fbp: fbp,
      _fbp: fbp,
      fbc: fbc,
      _fbc: fbc,

      landing_page: firstData.landing_page || safeStorageGet(sessionStorage, 'bca_landing_page') || window.location.href,
      first_referrer: firstData.referrer || '',
      last_landing_page: lastData.landing_page || '',
      last_referrer: lastData.referrer || '',
      referrer: document.referrer || lastData.referrer || '',

      first_touch_source: firstData.source || '',
      first_touch_medium: firstData.medium || '',
      first_touch_campaign: firstData.campaign || '',
      first_touch_fbclid: firstData.fbclid || '',
      first_touch_fbc: firstData.fbc || '',
      last_touch_source: lastData.source || '',
      last_touch_medium: lastData.medium || '',
      last_touch_campaign: lastData.campaign || '',
      last_touch_fbclid: lastData.fbclid || '',
      last_touch_fbc: lastData.fbc || '',
      first_paid_touch_source: firstPaidData.source || '',
      first_paid_touch_medium: firstPaidData.medium || '',
      first_paid_touch_campaign: firstPaidData.campaign || '',
      first_meta_touch_source: firstMetaData.source || '',
      first_meta_touch_medium: firstMetaData.medium || '',
      first_meta_touch_campaign: firstMetaData.campaign || '',
      first_meta_touch_site_source_name: firstMetaData.site_source_name || '',
      last_paid_touch_source: lastPaidData.source || '',
      last_paid_touch_medium: lastPaidData.medium || '',
      last_paid_touch_campaign: lastPaidData.campaign || '',
      last_meta_touch_source: lastMetaData.source || '',
      last_meta_touch_medium: lastMetaData.medium || '',
      last_meta_touch_campaign: lastMetaData.campaign || '',
      last_meta_touch_site_source_name: lastMetaData.site_source_name || '',

      page_url: window.location.href,
      page_path: location.pathname || '',
      page_title: document.title || '',
      user_agent: device.user_agent || '',
      language: navigator.language || '',
      languages: (navigator.languages || []).join(','),
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone || ''),
      screen_width: (window.screen && window.screen.width) || '',
      screen_height: (window.screen && window.screen.height) || '',
      viewport_width: window.innerWidth || '',
      viewport_height: window.innerHeight || '',
      device_pixel_ratio: window.devicePixelRatio || '',
      platform: device.platform || '',
      vendor: device.vendor || '',
      max_touch_points: device.max_touch_points || 0,
      touch_support: ('ontouchstart' in window) || navigator.maxTouchPoints > 0,

      detected_os: device.detected_os,
      detected_browser: device.detected_browser,
      detected_device_type: device.detected_device_type,
      is_mobile: device.is_mobile,
      is_ios: device.is_ios,
      is_android: device.is_android,
      cookies_enabled: navigator.cookieEnabled !== false,
      do_not_track: navigator.doNotTrack || window.doNotTrack || navigator.msDoNotTrack || '',
      hardware_concurrency: navigator.hardwareConcurrency || '',
      device_memory: navigator.deviceMemory || '',
      network_info: getNetworkConnectionInfo(),
      captured_at: nowIso()
    };
    // Campaign fields come from ONE timestamped visit, never a merged legacy record.
    var campaign = window.BCA_CAMPAIGN_ATTRIBUTION.read();
    Object.assign(result,campaign);
    result.attribution_version='bca_campaign_touch_v2';
    result.attribution_repair_applied=false;result.attribution_repair_reason='';
    return result;
  }

  function generateEventId(eventType) {
    var type = String(eventType || 'event').replace(/[^a-zA-Z0-9_\-]/g, '_');
    var cart = state.cart && state.cart.token ? String(state.cart.token).slice(-12) : 'no_cart';

    return type + '_' + state.sessionId + '_' + cart + '_' + Date.now() + '_' + Math.random().toString(16).slice(2, 10);
  }

  function getEventId(eventType, forceNew) {
    var key = String(eventType || 'event');

    if (forceNew || !state.eventIds[key]) {
      state.eventIds[key] = generateEventId(key);
    }

    return state.eventIds[key];
  }

  function createOrderAttemptId() {
    return 'bca_order_attempt_' + Date.now() + '_' + Math.random().toString(16).slice(2, 10) + '_' + Math.random().toString(16).slice(2, 10);
  }

  function getCartFingerprint(cart) {
    var items = ((cart && cart.items) || []).map(function (item) {
      return [
        item.variant_id || '',
        item.quantity || 0,
        Math.round(getCodLinePriceCents(item) / 100),
        item.key || ''
      ].join(':');
    }).sort().join('|');

    return [
      (cart && cart.token) || 'no_cart',
      items || 'empty',
      (cart && cart.item_count) || 0,
      Math.round(((cart && cart.total_price) || 0) / 100)
    ].join('||');
  }

  function getCartItemsSignature(cart) {
    return ((cart && cart.items) || []).map(function (item) {
      return [
        item.variant_id || '',
        Number(item.quantity || 0),
        Math.round(getCodLinePriceCents(item) / 100)
      ].join(':');
    }).sort().join('|') || 'empty';
  }

  function getAbandonmentKey(formData) {
    var phone = validPhone(formData.phone);
    var email = validEmail(formData.email);
    var cartToken = state.cart && state.cart.token ? String(state.cart.token).split('?')[0] : '';

    if (phone) return 'ABN_PHONE_' + phone.replace(/[^0-9]/g, '');
    if (email) return 'ABN_EMAIL_' + email.replace(/[^a-z0-9]/g, '');
    if (cartToken) return 'ABN_CART_' + cartToken.slice(-24);

    return 'ABN_SESSION_' + state.sessionId;
  }

  function getAbandonmentSignature(formData) {
    return [getAbandonmentKey(formData), getCartItemsSignature(state.cart)].join('||');
  }

  function buildNoteAttributes(formData, attribution, landingContext) {
    landingContext = landingContext || getBcaLandingContext();
    var clientIpInfo = getClientIpInfo();
    var networkInfo = getNetworkConnectionInfo();
    var attrs = [
      ['Nombre', formData.first_name],
      ['Apellido', formData.last_name],
      ['Teléfono (WhatsApp)', formData.phone],
      ['Teléfono E164', validPhone(formData.phone)],
      ['Dirección', formData.address1],
      ['Barrio', formData.address2],
      ['Departamento', formData.province],
      ['Ciudad', formData.city],
      ['País', 'Colombia'],
      ['Correo escrito por cliente', formData.email_raw || formData.email],
      ['Correo válido para Shopify', validEmail(formData.email)],
      ['Código de descuento escrito', formData.promo_code],
      ['Código de descuento raw', formData.promo_code_raw],
      ['Descuento validado por', formData.promo_code ? 'Sistema de descuentos Bacanime' : 'Sin código escrito'],
      ['Promo visual aplicada', (state.promoVisual && state.promoVisual.applied) ? 'Sí' : 'No'],
      ['Promo visual descuento', (state.promoVisual && state.promoVisual.discountAmount) ? money(state.promoVisual.discountAmount) : ''],
      ['Promo visual estado', state.promoVisual ? state.promoVisual.status : ''],
      ['Promo validada por Shopify', (state.promoVisual && state.promoVisual.shopifyCartApplied) ? 'Sí' : 'No'],
      ['Correo omitido por inválido', (formData.email && !validEmail(formData.email)) ? 'Sí' : 'No'],
      ['Prioridad de contacto', 'WhatsApp'],
      ['Confirma WhatsApp', formData.confirm_whatsapp ? 'on' : ''],
      ['Compromiso de recibir pedido', formData.confirm_commitment ? 'on' : ''],

      ['Tipo de origen Bacanime', landingContext.source_type],
      ['Es landing Bacanime', landingContext.is_landing ? 'Sí' : 'No'],
      ['Landing ID', landingContext.landing_id],
      ['Landing nombre', landingContext.landing_name],
      ['Oferta landing', landingContext.offer_name],
      ['Tipo de página Bacanime', landingContext.page_type],
      ['Grupo de campaña landing', landingContext.campaign_group],
      ['Producto foco landing', landingContext.product_focus],
      ['Landing detectada automáticamente', landingContext.auto_detected ? 'Sí' : 'No'],
      ['Landing detectada desde', landingContext.auto_detected_from],
      ['Handle landing detectado', landingContext.original_handle],

      ['Traffic platform', attribution.traffic_platform],
      ['Traffic source exacto', attribution.traffic_source_exact],
      ['Paid channel', attribution.paid_channel],
      ['Meta platform', attribution.meta_platform],
      ['Meta platform label', attribution.meta_platform_label],
      ['Meta source reason', attribution.meta_source_reason],
      ['Meta placement bucket', attribution.meta_placement_bucket],
      ['Es tráfico Meta', attribution.is_meta_traffic ? 'Sí' : 'No'],
      ['Es Instagram', attribution.is_instagram_traffic ? 'Sí' : 'No'],
      ['Es Facebook', attribution.is_facebook_traffic ? 'Sí' : 'No'],

      ['UTM source', attribution.utm_source],
      ['UTM medium', attribution.utm_medium],
      ['UTM campaign', attribution.utm_campaign],
      ['UTM content / anuncio', attribution.utm_content],
      ['UTM term / conjunto', attribution.utm_term],
      ['UTM ID', attribution.utm_id],
      ['Meta campaign_id', attribution.campaign_id],
      ['Meta adset_id', attribution.adset_id],
      ['Meta ad_id', attribution.ad_id],
      ['Meta campaign_name', attribution.campaign_name],
      ['Meta adset_name', attribution.adset_name],
      ['Meta ad_name', attribution.ad_name],
      ['Placement', attribution.placement],
      ['Site source name', attribution.site_source_name],

      ['FBCLID', attribution.fbclid],
      ['GCLID', attribution.gclid],
      ['TTCLID', attribution.ttclid],
      ['MSCLKID', attribution.msclkid],
      ['GBRAID', attribution.gbraid],
      ['WBRAID', attribution.wbraid],
      ['SRSLTID', attribution.srsltid],
      ['First touch source', attribution.first_touch_source],
      ['First touch medium', attribution.first_touch_medium],
      ['First touch campaign', attribution.first_touch_campaign],
      ['Last touch source', attribution.last_touch_source],
      ['Last touch medium', attribution.last_touch_medium],
      ['Last touch campaign', attribution.last_touch_campaign],
      ['Facebook _fbp', attribution.fbp],
      ['Facebook _fbc', attribution.fbc],
      ['Client IP address', clientIpInfo.client_ip_address],
      ['Client IP source', clientIpInfo.client_ip_source],
      ['Client IP status', clientIpInfo.client_ip_status],
      ['Client IP provider', clientIpInfo.client_ip_provider],
      ['Client IP captured at', clientIpInfo.client_ip_captured_at],
      ['Network effective type', networkInfo.effective_type],
      ['Network downlink', networkInfo.downlink],
      ['Network RTT', networkInfo.rtt],
      ['Do Not Track', attribution.do_not_track],
      ['Cookies enabled', attribution.cookies_enabled ? 'Sí' : 'No'],

      ['Landing page inicial', attribution.landing_page],
      ['Landing page último clic', attribution.last_landing_page],
      ['Referrer inicial', attribution.first_referrer],
      ['Referrer actual', attribution.referrer],
      ['Página del pedido', attribution.page_url],
      ['Título página', attribution.page_title],

      ['Sistema operativo detectado', attribution.detected_os],
      ['Navegador detectado', attribution.detected_browser],
      ['Tipo de dispositivo detectado', attribution.detected_device_type],
      ['Navegador / User Agent', attribution.user_agent],
      ['Idioma', attribution.language],
      ['Zona horaria', attribution.timezone],
      ['Pantalla', (attribution.screen_width || '') + 'x' + (attribution.screen_height || '')],
      ['Viewport', (attribution.viewport_width || '') + 'x' + (attribution.viewport_height || '')],
      ['Browser ID', attribution.browser_id],
      ['Session ID', state.sessionId],
      ['Cart token', state.cart && state.cart.token ? state.cart.token : ''],
      ['Formulario usado', 'Formulario propio Bacanime COD v80.1 Landing Stable + Cloudflare Worker Proxy + Attribution Max + Server IP + CORS Safe + Dawn Sync'],
      ['Regla contraentrega', (CONFIG.codRules && CONFIG.codRules.enabled) ? 'Bloquear únicamente 1 camiseta' : 'Desactivada'],
      ['Resultado regla contraentrega', getCodMinimumStatus().blocked ? 'Bloqueado: una sola camiseta' : 'Permitido'],
      ['Fuente municipios formulario', state.locationsSource || 'fallback_config']
    ];

    return attrs.filter(function (a) {
      return a[1] !== null && a[1] !== undefined && String(a[1]).trim() !== '';
    }).map(function (a) {
      return { name: a[0], value: String(a[1]) };
    });
  }


  function getRealDiscountSnapshot(formData, totals, promoCodeOverride) {
    formData = formData || getFormData();
    totals = totals || calculateTotals(state.cart, formData);

    var promoCodeReal = cleanPromoCode(
      promoCodeOverride ||
      formData.promo_code ||
      ''
    );

    var subtotal = Number(totals && totals.subtotal ? totals.subtotal : 0);
    var shipping = Number(totals && totals.shipping ? totals.shipping : 0);

    var promoWasReallyAppliedByForm = !!(
      promoCodeReal &&
      state.promoVisual &&
      state.promoVisual.applied === true &&
      cleanPromoCode(state.promoVisual.code || '') === promoCodeReal &&
      Number(state.promoVisual.discountAmount || 0) > 0
    );

    var shopifyCartDiscountDebug = Math.round(
      Number(state.cart && state.cart.total_discount ? state.cart.total_discount : 0) / 100
    );

    if (!promoWasReallyAppliedByForm) {
      return {
        code: '',
        amount: 0,
        amount_cents: 0,
        has_discount: false,
        subtotal_before_discount: subtotal,
        shipping: shipping,
        total_without_discount: subtotal + shipping,
        total_with_discount: subtotal + shipping,

        discount_from_totals: 0,
        discount_from_promo_visual: 0,
        discount_from_shopify_cart: shopifyCartDiscountDebug,
        discount_by_math: 0,

        promo_visual_applied: !!(state.promoVisual && state.promoVisual.applied),
        promo_visual_code: state.promoVisual ? state.promoVisual.code : '',
        promo_visual_status: state.promoVisual ? state.promoVisual.status : '',
        promo_visual_source: state.promoVisual ? state.promoVisual.source : '',

        shopify_cart_applied: !!(state.promoVisual && state.promoVisual.shopifyCartApplied),
        shopify_cart_original_total: state.promoVisual ? state.promoVisual.shopifyCartOriginalTotal : 0,
        shopify_cart_total_after_discount: state.promoVisual ? state.promoVisual.shopifyCartTotalAfterDiscount : 0,
        shopify_cart_original_total_cents: state.promoVisual ? state.promoVisual.shopifyCartOriginalTotalCents : 0,
        shopify_cart_total_after_discount_cents: state.promoVisual ? state.promoVisual.shopifyCartTotalAfterDiscountCents : 0
      };
    }

    var discountAmountReal = Number(state.promoVisual.discountAmount || 0);
    var discountAmountRealCents = Number(
      state.promoVisual.discountAmountCents || Math.round(discountAmountReal * 100)
    );

    var totalWithDiscount = Math.max(subtotal - discountAmountReal + shipping, 0);

    return {
      code: promoCodeReal,
      amount: discountAmountReal,
      amount_cents: discountAmountRealCents,
      has_discount: true,
      subtotal_before_discount: subtotal,
      shipping: shipping,
      total_without_discount: subtotal + shipping,
      total_with_discount: totalWithDiscount,

      discount_from_totals: discountAmountReal,
      discount_from_promo_visual: discountAmountReal,
      discount_from_shopify_cart: shopifyCartDiscountDebug,
      discount_by_math: discountAmountReal,

      promo_visual_applied: true,
      promo_visual_code: state.promoVisual.code || '',
      promo_visual_status: state.promoVisual.status || '',
      promo_visual_source: state.promoVisual.source || '',

      shopify_cart_applied: !!state.promoVisual.shopifyCartApplied,
      shopify_cart_original_total: state.promoVisual.shopifyCartOriginalTotal || 0,
      shopify_cart_total_after_discount: state.promoVisual.shopifyCartTotalAfterDiscount || 0,
      shopify_cart_original_total_cents: state.promoVisual.shopifyCartOriginalTotalCents || 0,
      shopify_cart_total_after_discount_cents: state.promoVisual.shopifyCartTotalAfterDiscountCents || 0
    };
  }

  function buildPayload(eventType) {
    var formData = getFormData();
    var totals = calculateTotals(state.cart, formData);
    var attribution = readAttribution();
    var attributionPro = getAttributionPro();
    var landingContext = getBcaLandingContext();
    var clientIpInfo = getClientIpInfo();
    var networkInfo = getNetworkConnectionInfo();
    var cleanCustomerEmail = validEmail(formData.email);
    var cleanPhoneE164 = validPhone(formData.phone);
    var provinceCode = getProvinceCodeByDepartment(formData.province);
    var promoCode = cleanPromoCode(formData.promo_code || '');
    var discountSnapshot = getRealDiscountSnapshot(formData, totals, promoCode);

    formData.province_code = provinceCode;
    formData.department_code = provinceCode;
    formData.client_ip_address = clientIpInfo.client_ip_address || '';
    formData.client_user_agent = attribution.user_agent || navigator.userAgent || '';
    formData.client_ip_source = clientIpInfo.client_ip_source || '';
    formData.client_ip_status = clientIpInfo.client_ip_status || '';

    var isNativeCheckout = eventType === 'native_checkout_redirect';
    var isAbandonment = eventType === 'cod_form_abandoned' || eventType === 'page_exit_possible_abandonment';
    var isOrderSubmit = eventType === 'cod_order_submit';
    var eventId = getEventId(eventType, isOrderSubmit);

    var paymentMethod = isNativeCheckout
      ? 'Pago anticipado / Mercado Pago / Shopify Checkout'
      : 'Pago contraentrega';

    var tags = isNativeCheckout
      ? ['bacanime_native_checkout','pago_anticipado_intento','formulario_personalizado',CONFIG.brand]
      : ['bacanime_cod_form','pago_contraentrega','formulario_personalizado','COD',CONFIG.brand];

    if (landingContext && landingContext.is_landing) {
      tags.push('landing_bacanime');

      if (landingContext.landing_id) {
        tags.push('landing_' + slugifyForTag(landingContext.landing_id));
      }

      if (landingContext.offer_name) {
        tags.push('oferta_' + slugifyForTag(landingContext.offer_name));
      }
    } else {
      tags.push('tienda_normal');
    }

    if (promoCode) {
      tags.push('descuento_solicitado');
      tags.push('promo_' + slugifyForTag(promoCode));

      if (discountSnapshot && discountSnapshot.has_discount) {
        tags.push('descuento_real_validado_shopify');
      } else {
        tags.push('descuento_solicitado_sin_monto_real');
      }

      if (isPrepaidOnlyCode(promoCode)) {
        tags.push('promo_exclusiva_pago_anticipado');
        tags.push('promo_bloqueada_cod');
      }
    }

    var items = ((state.cart && state.cart.items) || []).map(function (item) {
      return {
        product_id: item.product_id,
        variant_id: item.variant_id,
        product_gid: item.product_id ? 'gid://shopify/Product/' + item.product_id : '',
        variant_gid: item.variant_id ? 'gid://shopify/ProductVariant/' + item.variant_id : '',
        sku: item.sku || '',
        title: item.product_title || item.title || '',
        variant_title: item.variant_title || '',
        quantity: Number(item.quantity || 0),
        unit_price: Math.round(getCodUnitPriceCents(item) / 100),
        line_price: Math.round(getCodLinePriceCents(item) / 100),
        image: item.image || '',
        url: item.url || '',
        vendor: item.vendor || '',
        product_type: item.product_type || '',
        handle: item.handle || '',
        properties: item.properties || {}
      };
    });

    var productsSummary = items.map(function (i) {
      return [
        i.title,
        (i.variant_title && i.variant_title !== 'Default Title' ? '(' + i.variant_title + ')' : ''),
        'x' + i.quantity
      ].filter(Boolean).join(' ');
    }).join(' | ');

    var productsDetail = items.map(function (i) {
      return 'Producto: ' + (i.title || '') +
        ' | Variante: ' + (i.variant_title || '') +
        ' | SKU: ' + (i.sku || '') +
        ' | Variant ID: ' + (i.variant_id || '') +
        ' | Cant: ' + (i.quantity || 0) +
        ' | Unit: ' + (i.unit_price || 0) +
        ' | Total item: ' + (i.line_price || 0);
    }).join(' || ');

    var productsSkus = items.map(function (i) {
      return i.sku || '';
    }).filter(Boolean).join(' | ');

    var productsVariantIds = items.map(function (i) {
      return String(i.variant_id || '');
    }).filter(Boolean).join(' | ');

    var productsQty = items.map(function (i) {
      return String(i.quantity || 0);
    }).join(' | ');

    var abandonmentKey = isAbandonment ? getAbandonmentKey(formData) : '';
    var abandonmentSignature = isAbandonment ? getAbandonmentSignature(formData) : '';
    var cartFingerprint = getCartFingerprint(state.cart);

    return {
      event_type: eventType,
      brand: CONFIG.brand,
      event_id: eventId,
      order_attempt_id: isOrderSubmit ? (state.currentOrderAttemptId || eventId) : '',
      event_time: nowUnix(),
      event_source_url: location.href,
      action_source: 'website',
      proxy_expected: true,
      proxy_provider: 'cloudflare_workers',
      proxy_endpoint: CONFIG.makeWebhookUrl,
      server_ip_capture_expected: true,
      session_id: state.sessionId,
      browser_id: attribution.browser_id || getBrowserId(),
      occurred_at: nowIso(),
      page_url: location.href,
      client_ip_address: clientIpInfo.client_ip_address || '',
      client_user_agent: attribution.user_agent || navigator.userAgent || '',
      client_ip_source: clientIpInfo.client_ip_source || '',
      client_ip_status: clientIpInfo.client_ip_status || '',
      traffic_platform: attribution.traffic_platform || '',
      traffic_source_exact: attribution.traffic_source_exact || '',
      paid_channel: attribution.paid_channel || '',
      meta_platform: attribution.meta_platform || '',
      meta_platform_label: attribution.meta_platform_label || '',
      meta_source_exact: attribution.meta_source_exact || '',
      meta_source_reason: attribution.meta_source_reason || '',
      meta_placement_bucket: attribution.meta_placement_bucket || '',
      is_meta_traffic: !!attribution.is_meta_traffic,
      is_instagram_traffic: !!attribution.is_instagram_traffic,
      is_facebook_traffic: !!attribution.is_facebook_traffic,

      source_type: landingContext.source_type,
      is_landing: landingContext.is_landing,
      landing_id: landingContext.landing_id,
      landing_name: landingContext.landing_name,
      offer_name: landingContext.offer_name,
      page_type: landingContext.page_type,
      campaign_group: landingContext.campaign_group,
      product_focus: landingContext.product_focus,
      landing_auto_detected: landingContext.auto_detected,
      landing_auto_detected_from: landingContext.auto_detected_from,
      landing_original_handle: landingContext.original_handle,

      cart_token: state.cart && state.cart.token ? state.cart.token : null,
      cart_fingerprint: cartFingerprint,
      currency: CONFIG.pixel.currency || 'COP',
      payment_method: paymentMethod,
      promo_code: promoCode,
      discount_code: promoCode,

      discount_code_real: discountSnapshot.code,
      discount_amount_real: discountSnapshot.amount,
      discount_amount_real_cents: discountSnapshot.amount_cents,
      discount_has_real_discount: discountSnapshot.has_discount,
      subtotal_before_discount_real: discountSnapshot.subtotal_before_discount,
      shipping_amount_real: discountSnapshot.shipping,
      total_without_discount_real: discountSnapshot.total_without_discount,
      total_with_discount_real: discountSnapshot.total_with_discount,
      discount_debug: {
        discount_from_totals: discountSnapshot.discount_from_totals,
        discount_from_promo_visual: discountSnapshot.discount_from_promo_visual,
        discount_from_shopify_cart: discountSnapshot.discount_from_shopify_cart,
        discount_by_math: discountSnapshot.discount_by_math,
        promo_visual_applied: discountSnapshot.promo_visual_applied,
        promo_visual_code: discountSnapshot.promo_visual_code,
        promo_visual_status: discountSnapshot.promo_visual_status,
        promo_visual_source: discountSnapshot.promo_visual_source,
        shopify_cart_applied: discountSnapshot.shopify_cart_applied,
        shopify_cart_original_total: discountSnapshot.shopify_cart_original_total,
        shopify_cart_total_after_discount: discountSnapshot.shopify_cart_total_after_discount,
        shopify_cart_original_total_cents: discountSnapshot.shopify_cart_original_total_cents,
        shopify_cart_total_after_discount_cents: discountSnapshot.shopify_cart_total_after_discount_cents
      },

      discount_type_hint: state.promoVisual ? state.promoVisual.shopifyDiscountValueType : '',
      discount_value_hint: state.promoVisual ? state.promoVisual.shopifyDiscountValue : 0,
      promo: {
        code: promoCode,
        code_real: discountSnapshot.code,
        code_raw: formData.promo_code_raw || '',
        requested: !!promoCode,
        real_discount_sent_to_make: discountSnapshot.has_discount,
        real_discount_amount: discountSnapshot.amount,
        real_discount_amount_cents: discountSnapshot.amount_cents,
        total_without_discount: discountSnapshot.total_without_discount,
        total_with_discount: discountSnapshot.total_with_discount,
        source: promoCode ? 'manual_form_field' : 'none',
        validation_owner: 'Sistema de descuentos Bacanime',
        frontend_validated: !!(state.promoVisual && state.promoVisual.code === promoCode && state.promoVisual.status),
        frontend_applied: !!(state.promoVisual && state.promoVisual.code === promoCode && state.promoVisual.applied),
        frontend_status: state.promoVisual ? state.promoVisual.status : '',
        frontend_discount_type: state.promoVisual ? state.promoVisual.discountType : '',
        frontend_discount_value: state.promoVisual ? state.promoVisual.discountValue : 0,
        shopify_cart_discount_value_type: state.promoVisual ? state.promoVisual.shopifyDiscountValueType : '',
        shopify_cart_discount_value: state.promoVisual ? state.promoVisual.shopifyDiscountValue : 0,
        shopify_cart_discount_title: state.promoVisual ? state.promoVisual.shopifyDiscountTitle : '',
        shopify_cart_discount_application_type: state.promoVisual ? state.promoVisual.shopifyDiscountApplicationType : '',
        frontend_discount_amount: state.promoVisual ? state.promoVisual.discountAmount : 0,
        frontend_discount_amount_cents: state.promoVisual ? state.promoVisual.discountAmountCents : 0,
        frontend_free_shipping: !!(state.promoVisual && state.promoVisual.freeShipping),
        frontend_message: state.promoVisual ? state.promoVisual.message : '',
        source: state.promoVisual ? state.promoVisual.source : '',
        shopify_cart_applied: !!(state.promoVisual && state.promoVisual.shopifyCartApplied),
        prepaid_only_blocked: !!(promoCode && isPrepaidOnlyCode(promoCode)),
        shopify_cart_discount_amount: state.promoVisual ? state.promoVisual.discountAmount : 0,
        shopify_cart_discount_amount_cents: state.promoVisual ? state.promoVisual.discountAmountCents : 0,
        shopify_cart_original_total: state.promoVisual ? state.promoVisual.shopifyCartOriginalTotal : 0,
        shopify_cart_total_after_discount: state.promoVisual ? state.promoVisual.shopifyCartTotalAfterDiscount : 0,
        shopify_cart_original_total_cents: state.promoVisual ? state.promoVisual.shopifyCartOriginalTotalCents : 0,
        shopify_cart_total_after_discount_cents: state.promoVisual ? state.promoVisual.shopifyCartTotalAfterDiscountCents : 0,
        note: 'El formulario muestra el descuento aplicado y el sistema lo confirma al crear el pedido.'
      },
      server_enrichment: {
        mode: 'cloudflare_worker_proxy',
        proxy_expected: true,
        proxy_provider: 'cloudflare_workers',
        proxy_endpoint: CONFIG.makeWebhookUrl,
        client_ip_capture_owner: 'cloudflare_worker',
        worker_should_inject_ip: true,
        client_ip_address: clientIpInfo.client_ip_address || '',
        client_ip_source: clientIpInfo.client_ip_source || '',
        client_ip_status: clientIpInfo.client_ip_status || '',
        client_ip_message: clientIpInfo.client_ip_message || '',
        client_ip_provider: clientIpInfo.client_ip_provider || '',
        client_ip_captured_at: clientIpInfo.client_ip_captured_at || '',
        client_ip_attempts: clientIpInfo.client_ip_attempts || [],
        client_user_agent: attribution.user_agent || navigator.userAgent || '',
        network_info: networkInfo,
        make_headers_note: 'Cloudflare Worker captura la IP real server-side y la inyecta en server_enrichment.client_ip_address y meta_capi_ready.user_data.client_ip_address antes de reenviar a Make.'
      },

      sale_context: {
        source_type: landingContext.source_type,
        is_landing: !!landingContext.is_landing,
        landing_id: landingContext.landing_id || '',
        landing_name: landingContext.landing_name || '',
        offer_name: landingContext.offer_name || '',
        page_type: landingContext.page_type || '',
        page_url: location.href
      },
      cart_items_count: items.length,
      products_summary: productsSummary,
      products_detail: productsDetail,
      products_skus: productsSkus,
      products_variant_ids: productsVariantIds,
      products_quantities: productsQty,

      validation: {
        email_is_valid: !!cleanCustomerEmail,
        email_raw_present: !!formData.email,
        email_omitted_for_shopify: !!(formData.email && !cleanCustomerEmail),
        phone_is_valid: !!cleanPhoneE164,
        cod_minimum_quantity: getCodMinimumStatus().minimum,
        cod_minimum_met: getCodMinimumStatus().valid,
        cod_rule_type: getCodMinimumStatus().rule_type,
        cod_single_shirt_blocked: getCodMinimumStatus().blocked,
        cod_single_item_is_shirt: getCodMinimumStatus().single_item_is_shirt,
        locations_source: state.locationsSource || 'fallback_config',
        frontend_version: 'v80_1_landing_stable_worker_proxy_cors_safe_server_ip_dawn_sync'
      },

      abandonment: {
        abandonment_key: abandonmentKey,
        abandonment_signature: abandonmentSignature,
        cart_items_signature: getCartItemsSignature(state.cart),
        reason: '',
        frontend_dedup: 'enabled',
        dedup_rule: 'same abandonment_key + same cart items signature = no duplicate'
      },

      customer: {
        first_name: formData.first_name || '',
        last_name: formData.last_name || '',
        full_name: ((formData.first_name || '') + ' ' + (formData.last_name || '')).trim(),
        phone_raw: formData.phone || '',
        phone_clean: cleanPhone(formData.phone),
        phone_e164: cleanPhoneE164 || '',
        email: cleanCustomerEmail || ''
      },

      shipping_address: {
        first_name: formData.first_name || '',
        last_name: formData.last_name || '',
        phone: cleanPhoneE164 || formData.phone || '',
        address1: formData.address1 || '',
        address2: formData.address2 || '',
        city: formData.city || '',
        province: formData.province || '',
        province_code: provinceCode || '',
        country: 'Colombia',
        country_code: 'CO',
        zip: ''
      },

      form_data: formData,

      landing_context: landingContext,
      tracking_context: landingContext,

      confirmations: CONFIG.checks.reduce(function (acc, c) {
        acc[c.name] = !!formData[c.name];
        return acc;
      }, {}),

      items: items,
      totals_frontend_only: totals,
      totals_make_ready: {
        currency: CONFIG.pixel.currency || 'COP',
        subtotal: discountSnapshot.subtotal_before_discount,
        discount: discountSnapshot.amount,
        shipping: discountSnapshot.shipping,
        total_without_discount: discountSnapshot.total_without_discount,
        total: discountSnapshot.total_with_discount,
        discount_code: discountSnapshot.code,
        discount_has_real_discount: discountSnapshot.has_discount
      },

      shipping_line: {
        title: CONFIG.shipping.methodName || 'Envío al nivel nacional',
        price: totals.shipping || 0,
        code: 'envio_nacional'
      },

      native_checkout_discount: {
        enabled: CONFIG.nativeCheckout.enabled,
        code: CONFIG.nativeCheckout.discountCode || '',
        note: 'Este descuento solo aplica al checkout nativo/Mercado Pago, no a contraentrega.'
      },

      tags: tags,
      tags_string: tags.join(', '),

      attribution: attribution,
      attribution_first_touch: attributionPro.first_touch || null,
      attribution_last_touch: attributionPro.last_touch || null,
      attribution_first_paid_touch: attributionPro.first_paid_touch || null,
      attribution_first_meta_touch: attributionPro.first_meta_touch || null,
      attribution_last_paid_touch: attributionPro.last_paid_touch || null,
      attribution_last_meta_touch: attributionPro.last_meta_touch || null,
      first_touch: attributionPro.first_touch || null,
      last_touch: attributionPro.last_touch || null,
      attribution_pro: attributionPro,

      note_attributes: buildNoteAttributes(formData, attribution, landingContext).concat([
        { name: 'Código descuento real Make', value: String(discountSnapshot.code || '') },
        { name: 'Descuento real Make', value: String(discountSnapshot.amount || 0) },
        { name: 'Descuento real centavos Make', value: String(discountSnapshot.amount_cents || 0) },
        { name: 'Tiene descuento real Make', value: discountSnapshot.has_discount ? 'Sí' : 'No' },
        { name: 'Total sin descuento Make', value: String(discountSnapshot.total_without_discount || 0) },
        { name: 'Total con descuento Make', value: String(discountSnapshot.total_with_discount || 0) }
      ]),

      meta_capi_ready: {
        event_name: isOrderSubmit
          ? CONFIG.pixel.events.codSubmit
          : (isNativeCheckout ? CONFIG.pixel.events.nativeCheckout : (isAbandonment ? CONFIG.pixel.events.abandoned : CONFIG.pixel.events.formInput)),
        event_id: eventId,
        event_time: nowUnix(),
        action_source: 'website',
        event_source_url: location.href,
        user_data: {
          em: cleanCustomerEmail || '',
          ph: cleanPhoneE164 || '',
          fn: formData.first_name || '',
          ln: formData.last_name || '',
          ct: formData.city || '',
          st: formData.province || '',
          country: 'co',
          client_ip_address: clientIpInfo.client_ip_address || '',
          client_user_agent: attribution.user_agent || navigator.userAgent || '',
          fbp: attribution.fbp || '',
          fbc: attribution.fbc || '',
          external_id: attribution.browser_id || state.sessionId || ''
        },
        custom_data: {
          currency: CONFIG.pixel.currency || 'COP',
          value: discountSnapshot.total_with_discount || totals.total || 0,
          discount_code: discountSnapshot.code || promoCode || '',
          discount_amount: discountSnapshot.amount || 0,
          total_without_discount: discountSnapshot.total_without_discount || 0,
          total_with_discount: discountSnapshot.total_with_discount || totals.total || 0,
          order_type: isOrderSubmit ? 'cod_order_submit' : eventType,
          payment_method: paymentMethod,
          attribution_source: attribution.utm_source || '',
          attribution_medium: attribution.utm_medium || '',
          attribution_campaign: attribution.utm_campaign || '',
          attribution_repair_applied: !!attribution.attribution_repair_applied,
          traffic_platform: attribution.traffic_platform || '',
          traffic_source_exact: attribution.traffic_source_exact || '',
          paid_channel: attribution.paid_channel || '',
          meta_platform: attribution.meta_platform || '',
          meta_platform_label: attribution.meta_platform_label || '',
          meta_source_reason: attribution.meta_source_reason || '',
          meta_placement_bucket: attribution.meta_placement_bucket || '',
          is_meta_traffic: !!attribution.is_meta_traffic,
          is_instagram_traffic: !!attribution.is_instagram_traffic,
          is_facebook_traffic: !!attribution.is_facebook_traffic,
          content_type: 'product',
          content_ids: items.map(function (i) {
            return String(i.variant_id || i.product_id || i.sku || '');
          }).filter(Boolean),
          contents: items.map(function (i) {
            return {
              id: String(i.variant_id || i.product_id || i.sku || ''),
              quantity: i.quantity,
              item_price: i.unit_price
            };
          }),
          source_type: landingContext.source_type,
          landing_id: landingContext.landing_id,
          landing_name: landingContext.landing_name,
          offer_name: landingContext.offer_name,
          page_type: landingContext.page_type,
          landing_auto_detected: landingContext.auto_detected,
          landing_auto_detected_from: landingContext.auto_detected_from
        }
      },

      deduplication: {
        idempotency_key: [
          eventType,
          isOrderSubmit ? (state.currentOrderAttemptId || eventId) : state.sessionId,
          (state.cart && state.cart.token) || '',
          cartFingerprint,
          cleanPhoneE164 || '',
          cleanCustomerEmail || ''
        ].join('|'),
        event_id: eventId,
        order_attempt_id: isOrderSubmit ? (state.currentOrderAttemptId || eventId) : '',
        cart_fingerprint: cartFingerprint,
        abandonment_key: abandonmentKey,
        abandonment_signature: abandonmentSignature,
        recommended_make_duplicate_keys: ['order_attempt_id','event_id','customer.phone_e164','customer.email','deduplication.cart_fingerprint']
      },

      make_help: {
        shopify_line_items_map: 'items[].variant_id -> line_items.variant_id / items[].quantity -> line_items.quantity',
        important_email_fix: 'customer.email llega vacío si no es válido o si viene vacío; el pedido NO se bloquea por correo. Validar antes de asociar email al cliente.',
        shopify_customer_warning: 'No asociar email al cliente si no validas el correo primero.',
        meta_capi_warning: 'No enviar token CAPI desde frontend. Make debe hashear em/ph/fn/ln/ct/st/country si envía CAPI y usar event_id para deduplicar. client_ip_address lo inyecta Cloudflare Worker en server_enrichment.client_ip_address y meta_capi_ready.user_data.client_ip_address.'
      }
    };
  }

  function fireTracking(eventName, payload) {
    if (!CONFIG.pixel.enabled || !eventName) return;

    var totals = payload && payload.totals_frontend_only ? payload.totals_frontend_only : state.totals;
    var items = payload && payload.items ? payload.items : [];
    var attribution = (payload && payload.attribution) || readAttribution();
    var landingContext = (payload && payload.landing_context) || getBcaLandingContext();
    var eventId = (payload && payload.event_id) || getEventId(eventName, false);

    var pixelPayload = {
      value: totals ? totals.total : 0,
      currency: CONFIG.pixel.currency || 'COP',
      content_ids: items.map(function (i) {
        return String(i.variant_id || i.product_id || i.sku || '');
      }).filter(Boolean),
      content_type: 'product',
      contents: items.map(function (i) {
        return {
          id: String(i.variant_id || i.product_id || i.sku || ''),
          quantity: i.quantity,
          item_price: i.unit_price
        };
      }),
      event_source_url: location.href,
      source_type: landingContext.source_type,
      landing_id: landingContext.landing_id,
      landing_name: landingContext.landing_name,
      offer_name: landingContext.offer_name,
      page_type: landingContext.page_type
    };

    try {
      if (CONFIG.pixel.useMetaPixel && typeof window.fbq === 'function') {
        window.fbq('track', eventName, pixelPayload, { eventID: eventId });
      }
    } catch (e) {}

    try {
      if (CONFIG.pixel.useDataLayer) {
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({ ecommerce: null });

        window.dataLayer.push({
          event: CONFIG.pixel.dataLayerPrefix + eventName,
          bca_event_name: eventName,
          bca_event_id: eventId,
          event_id: eventId,
          event_time: nowUnix(),
          event_source_url: location.href,
          bca_source_type: landingContext.source_type,
          bca_is_landing: landingContext.is_landing,
          bca_landing_id: landingContext.landing_id,
          bca_landing_name: landingContext.landing_name,
          bca_offer_name: landingContext.offer_name,
          bca_page_type: landingContext.page_type,
          bca_landing_auto_detected: landingContext.auto_detected,
          bca_landing_auto_detected_from: landingContext.auto_detected_from,
          ecommerce: {
            currency: pixelPayload.currency,
            value: pixelPayload.value,
            items: items.map(function (i) {
              return {
                item_id: String(i.variant_id || i.product_id || i.sku || ''),
                item_name: i.title || '',
                item_variant: i.variant_title || '',
                price: i.unit_price || 0,
                quantity: i.quantity || 0,
                item_brand: CONFIG.brand
              };
            })
          },
          bca_attribution: attribution,
          bca_landing_context: landingContext,
          bca_payload: CONFIG.pixel.sendFullPayloadToDataLayer
            ? (payload || null)
            : {
                event_type: payload && payload.event_type,
                session_id: state.sessionId,
                cart_token: payload && payload.cart_token,
                customer_email_valid: payload && payload.validation && payload.validation.email_is_valid,
                customer_email_omitted_for_shopify: payload && payload.validation && payload.validation.email_omitted_for_shopify,
                phone_valid: payload && payload.validation && payload.validation.phone_is_valid,
                source_type: landingContext.source_type,
                landing_id: landingContext.landing_id,
                landing_name: landingContext.landing_name,
                offer_name: landingContext.offer_name,
                whatsapp_first: true
              }
        });
      }
    } catch (e) {}
  }

  function isValidAbandonmentCandidate(data) {
    return !!(CONFIG.abandonedCart.enabled && !state.codSubmitClicked && !state.orderSubmitted && state.cart && state.cart.items && state.cart.items.length && String(data.first_name || '').trim() && (validPhone(data.phone) || validEmail(data.email)));
  }

  function abandonmentStorageKey(key) {
    return 'bca_abandonment_sent_' + String(key || '').replace(/[^a-zA-Z0-9_\-]/g, '_');
  }

  function shouldSendAbandonment(payload) {
    if (!payload || !payload.abandonment || !payload.abandonment.abandonment_key) return false;

    var signature = payload.abandonment.abandonment_signature || '';
    var key = payload.abandonment.abandonment_key || '';

    if (CONFIG.abandonedCart.preventDuplicateSameSignature && signature && state.lastAbandonmentSignature === signature) {
      return false;
    }

    if (CONFIG.abandonedCart.useLocalStorageLock && key) {
      var stored = safeJsonParse(safeStorageGet(localStorage, abandonmentStorageKey(key)), null);
      var resendMinutes = Number(CONFIG.abandonedCart.resendAfterMinutes || 0);
      var resendMs = resendMinutes > 0 ? resendMinutes * 60 * 1000 : 0;

      if (stored && stored.signature === signature) {
        if (!resendMs || (Date.now() - Number(stored.last_sent_at || 0)) < resendMs) {
          return false;
        }
      }
    }

    var minSeconds = Number(CONFIG.abandonedCart.minSecondsBetweenSends || 0);

    if (minSeconds > 0 && state.lastAbandonmentAt && (Date.now() - state.lastAbandonmentAt) < (minSeconds * 1000)) {
      return false;
    }

    var maxPerOpen = Number(CONFIG.abandonedCart.maxSendsPerModalOpen || 0);

    if (maxPerOpen > 0 && state.abandonmentSendsThisModal >= maxPerOpen) return false;

    return true;
  }

  function rememberAbandonment(payload, reason) {
    if (!payload || !payload.abandonment || !payload.abandonment.abandonment_key) return;

    state.lastAbandonmentAt = Date.now();
    state.lastAbandonmentSignature = payload.abandonment.abandonment_signature || '';
    state.abandonmentSendsThisModal = Number(state.abandonmentSendsThisModal || 0) + 1;

    if (!CONFIG.abandonedCart.useLocalStorageLock) return;

    safeStorageSet(localStorage, abandonmentStorageKey(payload.abandonment.abandonment_key), JSON.stringify({
      signature: payload.abandonment.abandonment_signature,
      last_sent_at: Date.now(),
      last_sent_iso: nowIso(),
      reason: reason || '',
      total: payload.totals_frontend_only && payload.totals_frontend_only.total
    }));
  }

  function startAbandonmentHeartbeat() {
    stopAbandonmentHeartbeat();

    if (!CONFIG.abandonedCart.enabled || !CONFIG.abandonedCart.heartbeatMs) return;

    state.abandonmentHeartbeatTimer = setInterval(function () {
      if (!isModalOpen()) return;
      if (state.codSubmitClicked || state.orderSubmitted || state.nativeCheckoutClicked) return;

      var formData = getFormData();

      if (!isValidAbandonmentCandidate(formData)) return;

      sendCapture('cod_form_abandoned', false, 'qualified_heartbeat_' + CONFIG.abandonedCart.heartbeatMs + 'ms');
    }, Number(CONFIG.abandonedCart.heartbeatMs || 18000));
  }

  function stopAbandonmentHeartbeat() {
    if (state.abandonmentHeartbeatTimer) {
      clearInterval(state.abandonmentHeartbeatTimer);
      state.abandonmentHeartbeatTimer = null;
    }
  }

  function sendAbandonmentFastBeacon(reason) {
    sendCapture('cod_form_abandoned', false, reason || 'page_exit').catch(function () {});
  }

  function queueAbandonment(reason) {
    if (!CONFIG.abandonedCart.enabled) return;
    if (state.codSubmitClicked || state.orderSubmitted || state.nativeCheckoutClicked) return;

    clearTimeout(state.pendingAbandonmentTimer);

    state.pendingAbandonmentTimer = setTimeout(function () {
      var formData = getFormData();

      if (!isValidAbandonmentCandidate(formData)) return;

      sendCapture('cod_form_abandoned', false, reason || 'qualified_form_activity').catch(function () {});
    }, 400);
  }

  function resetIdleAbandonmentTimer() {
    clearTimeout(state.idleTimer);

    if (!CONFIG.abandonedCart.enabled || !CONFIG.abandonedCart.idleMs) return;

    state.idleTimer = setTimeout(function () {
      var formData = getFormData();

      if (!isValidAbandonmentCandidate(formData)) return;

      sendCapture('cod_form_abandoned', false, 'idle_' + CONFIG.abandonedCart.idleMs + 'ms');
    }, Number(CONFIG.abandonedCart.idleMs));
  }

  async function sendCapture(eventType, useBeacon, reason) {
    var transport = window.BacanimeFormTransport;
    if (!transport) throw new Error('No se pudo cargar el servicio de pedidos. Recarga la página.');
    if (eventType === 'native_checkout_redirect') return { ok: true, native: true };
    if (state.orderSubmitted) return null;
    var payload = buildPayload(eventType);
    if (eventType !== 'cod_order_submit') {
      if (!isValidAbandonmentCandidate(getFormData())) return null;
      var saved = await transport.capture(payload, { interaction: !/heartbeat|idle/.test(reason || '') });
      return { ok: saved.status === 'saved', payload: payload };
    }
    var receipt = await transport.submit(payload);
    if (receipt.status === 'not_received') receipt = await transport.retryUnreceived(payload);
    for (var checks = 0; receipt.status === 'pending' && checks < 18; checks++) {
      showMessage('Estamos confirmando tu pedido en Shopify. No necesitas enviarlo otra vez.', 'ok');
      await new Promise(function (resolve) { setTimeout(resolve, 2500); });
      receipt = await transport.submit(payload);
    }
    if (receipt.status !== 'confirmed') throw new Error(receipt.message || 'Tu pedido sigue en comprobación. Conservamos el mismo intento; vuelve a consultar en unos segundos.');
    payload.order_id = receipt.order.id;
    payload.order_name = receipt.order.name;
    payload.event_id = 'bacanime_purchase_' + receipt.order.id.split('/').pop();
    return { ok: true, payload: payload, order: receipt.order };
  }

  async function goAddiCheckout(e, options) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    if (state.addiCheckoutClicked) return;

    var skipFormValidation = !!(options && options.skipFormValidation);

    if (skipFormValidation) {
      showDirectPaymentMessage('Preparando tu checkout seguro con Addi...', 'ok');
    }

    setAddiCheckoutLoadingState(true);
    showMessage('Preparando tu pago financiado con Addi...', 'ok');

    try {
      await loadCart('before_addi_checkout');

      if (!state.cart || !state.cart.items || !state.cart.items.length) {
        throw new Error(CONFIG.texts.emptyCart);
      }

      var addiProductStatus = getCodMinimumStatus();

      if (!addiProductStatus.valid) {
        throw new Error('¡Ya casi completas el logro! Te falta ' + addiProductStatus.missing + ' producto real. El algodón y los extras no cuentan como otra unidad.');
      }

      var addiMinimum = Number(CONFIG.addiCheckout.minimumPurchase || 50000);
      var addiPurchaseTotal = Math.max(getCodCartSubtotalPesos(state.cart), 0);

      if (addiPurchaseTotal < addiMinimum) {
        throw new Error('Completa la misión agregando 2 productos reales para desbloquear el pago con Addi.');
      }

      if (!skipFormValidation && !validateRequired()) {
        throw new Error(CONFIG.texts.requiredError);
      }

      var formData = getFormData();
      var addiPromoCode = cleanPromoCode(formData.promo_code || '');

      if (addiPromoCode === 'BACANIME10') {
        throw new Error('BACANIME10 es exclusivo para pago anticipado con Mercado Pago. Puedes usar otro código universal vigente con Addi.');
      }

      if (!skipFormValidation && !validPhone(formData.phone)) {
        throw new Error(CONFIG.texts.phoneError);
      }

      if (!skipFormValidation && formData.email && !validEmail(formData.email)) {
        markField('email', true, CONFIG.texts.emailError);
      }

      state.addiCheckoutClicked = true;
      state.nativeCheckoutClicked = true;

      await updateBacanimeCartDiscount('');
      resetPromoVisual(addiPromoCode
        ? ('Shopify validará el código ' + addiPromoCode + ' antes de crear el checkout Addi.')
        : 'BACANIME10 no aplica al pago financiado con Addi.');
      renderTotals();

      var payload = buildPayload('addi_checkout_create');
      payload.payment_method = 'addi';
      payload.payment_route = 'addi';
      payload.discount_code = addiPromoCode;
      payload.promo_code = addiPromoCode;
      payload.shipping = Number(state.totals.shipping || 0);
      payload.shipping_total = Number(state.totals.shipping || 0);
      payload.addi = {
        fee_rate: CONFIG.addiCheckout.feeRateLabel,
        fee_rate_decimal: CONFIG.addiCheckout.feeRate,
        applies_to: 'productos_y_envio',
        customer_notice_accepted: true
      };

      fireTracking(CONFIG.pixel.events.nativeCheckout, payload);

      var response = await fetch(CONFIG.addiCheckout.endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      });

      var responseText = await response.text();
      var result = null;

      try {
        result = responseText ? JSON.parse(responseText) : null;
      } catch (parseError) {
        result = null;
      }

      if (!response.ok || !result || !result.ok || !result.checkout_url) {
        throw new Error((result && (result.message || result.error)) || 'No pudimos crear el checkout Addi. Intenta nuevamente.');
      }

      try {
        sessionStorage.setItem('bca_addi_checkout_started', '1');
        sessionStorage.setItem('bca_addi_checkout_started_at', String(Date.now()));
        sessionStorage.setItem('bca_addi_financed_total', String(result.financed_total || ''));
      } catch (storageError) {}

      showMessage('Listo. Te llevamos al pago seguro con Addi...', 'ok');
      if (skipFormValidation) showDirectPaymentMessage('Listo. Te llevamos al pago seguro con Addi...', 'ok');

      if (CONFIG.addiCheckout.openInSameTab) location.href = result.checkout_url;
      else window.open(result.checkout_url, '_blank');
    } catch (error) {
      state.addiCheckoutClicked = false;
      state.nativeCheckoutClicked = false;
      setAddiCheckoutLoadingState(false);
      showMessage(error && error.message ? error.message : 'No pudimos iniciar el pago con Addi.', 'error');
      if (skipFormValidation) {
        showDirectPaymentMessage(error && error.message ? error.message : 'No pudimos iniciar el pago con Addi.', 'error');
      }
    }
  }

  async function goNativeCheckout(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }

    if (state.nativeCheckoutClicked) return;

    await loadCart('before_native_checkout');

    if (CONFIG.behavior.requireCartItems && (!state.cart || !state.cart.items || !state.cart.items.length)) {
      showDirectPaymentMessage('Tu carrito está vacío. Agrega productos para activar el pago anticipado.', 'error');
      return cancelSubmitLoadingWithMessage(CONFIG.texts.emptyCart, 'error');
    }

    var nativeProductStatus = getCodMinimumStatus();

    if (!nativeProductStatus.valid) {
      var nativeMissingMessage = '¡Ya casi completas el logro! Te falta ' + nativeProductStatus.missing + ' producto real. El algodón y los extras no cuentan como otra unidad.';
      showDirectPaymentMessage(nativeMissingMessage, 'error');
      return cancelSubmitLoadingWithMessage(nativeMissingMessage, 'error');
    }

    state.nativeCheckoutClicked = true;
    setNativeCheckoutLoadingState(true);
    showMessage('Redirigiendo al checkout seguro...', 'ok');

    try {
      sessionStorage.setItem('bca_native_checkout_started', '1');
      sessionStorage.setItem('bca_native_checkout_discount_code', String(CONFIG.nativeCheckout.discountCode || '').trim());
      sessionStorage.setItem('bca_native_checkout_started_at', String(Date.now()));
    } catch (e2) {}

    var payload = buildPayload('native_checkout_redirect');
    await window.BCA_CAMPAIGN_ATTRIBUTION.syncCart(payload.attribution);

    fireTracking(CONFIG.pixel.events.nativeCheckout, payload);
    sendCapture('native_checkout_redirect', true, 'native_checkout_click');

    var nativeCode = cleanPromoCode(CONFIG.nativeCheckout.discountCode || '');
    var checkoutUrl = '/checkout';

    if (CONFIG.behavior.nativeCheckoutFastRedirect && nativeCode) {
      checkoutUrl = '/discount/' + encodeURIComponent(nativeCode) + '?redirect=/checkout';
    } else if (nativeCode) {
      await updateBacanimeCartDiscount(nativeCode);
    }

    if (CONFIG.nativeCheckout.openInSameTab) {
      location.href = checkoutUrl;
    } else {
      window.open(checkoutUrl, '_blank');
    }
  }

  async function openCodFromCartOnly(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }

    if (typeof window.BCA_BLOCK_AUTO_CART_NOW === 'function') {
      window.BCA_BLOCK_AUTO_CART_NOW();
    }

    showDirectPaymentMessage('Revisando los productos de tu carrito...', 'ok');

    var cart = await updateBacanimeCartDiscount('');
    if (!cart) cart = await loadCart('cod_cart_only_check');

    if (!cart || !cart.items || !cart.items.length) {
      showDirectPaymentMessage('Tu carrito está vacío. Agrega productos para activar la compra contraentrega.', 'error');
      state.preferredPaymentRoute = 'cod';
      await openModal(null, { cartAlreadyPrepared: true });
      return;
    }

    var codProductStatus = getCodMinimumStatus();

    if (!codProductStatus.valid) {
      showDirectPaymentMessage('¡Ya casi completas el logro! Te falta ' + codProductStatus.missing + ' producto real. El algodón y los extras no cuentan como otra unidad.', 'error');
      state.preferredPaymentRoute = 'cod';
      await openModal(null, { cartAlreadyPrepared: true });
      return;
    }

    showDirectPaymentMessage('', '');
    state.preferredPaymentRoute = 'cod';
    await openModal(null, { cartAlreadyPrepared: true });
  }

  async function openModal(e, options) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();

      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }

    ensureModalRendered();
    lockPaymentControlsForCartRefresh('modal_opened');

    var updatedCart = await updateBacanimeCartDiscount('');
    if (!updatedCart) await loadCart('cod_modal_opened');

    refreshLocationSelectOptions();

    try {
      ensureColombiaLocationsLoaded(false).then(function () {
        refreshLocationSelectOptions();
      }).catch(function () {});
    } catch (locationError) {}

    var modal = qs('#bca-modal');

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bca-modal-open');

    loadLazyMedia(modal);

    var body = qs('.bca-body');

    if (body) {
      body.scrollTop = 0;
    }

    try {
      var active = document.activeElement;

      if (active && active.blur) {
        active.blur();
      }
    } catch (e2) {}

    try {
      ensureClientIpCaptured(false);
    } catch (ipWarmError) {}

    state.abandonmentSendsThisModal = 0;

    resetIdleAbandonmentTimer();
    startAbandonmentHeartbeat();

    fireTracking(CONFIG.pixel.events.modalOpened, buildPayload('cod_modal_opened'));
  }

  function isModalOpen() {
    return !!qs('#bca-modal.is-open');
  }

  function showExitConfirm() {
    if (!CONFIG.behavior.showExitIntent) return forceCloseModal();

    var ex = qs('#bca-exit');

    if (ex) {
      ex.classList.add('is-open');
    }
  }

  function hideExitConfirm() {
    var ex = qs('#bca-exit');

    if (ex) {
      ex.classList.remove('is-open');
    }
  }

  function forceCloseModal() {
    if (
      CONFIG.abandonedCart.enabled &&
      CONFIG.abandonedCart.sendOnExit &&
      !state.codSubmitClicked &&
      !state.orderSubmitted &&
      !state.nativeCheckoutClicked
    ) {
      sendCapture('cod_form_abandoned', true, 'modal_close');
      sendAbandonmentFastBeacon('modal_close_fast_backup');
    }

    hideExitConfirm();
    stopAbandonmentHeartbeat();

    var modal = qs('#bca-modal');

    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('bca-modal-open');
    clearTimeout(state.idleTimer);
  }

  async function hideThankYouPopup() {
    await clearShopifyCartAfterOrder();

    stopAbandonmentHeartbeat();

    var thanks = qs('#bca-thanks');

    if (thanks) {
      thanks.classList.remove('is-open');
      thanks.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('bca-modal-open');
    window.location.href = '/';
  }

  function showThankYouPopup(payload) {
    if (!CONFIG.thankYouPopup.enabled) return;

    var thanks = qs('#bca-thanks');
    var summary = qs('#bca-thanks-summary');
    var body = qs('#bca-thanks-summary-body');

    if (!thanks) return;

    loadLazyMedia(thanks);

    if (summary && body && CONFIG.thankYouPopup.showSummary && payload) {
      var customer = payload.customer || {};
      var totals = payload.totals_frontend_only || {};
      var items = payload.items || [];

      var productSummary = items.map(function (i) {
        var name = (i.title || 'Producto') + (i.variant_title && i.variant_title !== 'Default Title' ? ' - ' + i.variant_title : '');

        return name + ' x' + Number(i.quantity || 0);
      }).join(' | ');

      var rows = [
        ['Cliente', customer.full_name || ''],
        ['WhatsApp', customer.phone_raw || ''],
        ['Correo', customer.email || ''],
        ['Productos', productSummary],
        ['Total', money(totals.total || 0)],
        ['Método', payload.payment_method || 'Pago contraentrega']
      ];

      body.innerHTML = rows.map(function (row) {
        return '<div class="bca-thanks-row"><span>' + escapeHtml(row[0]) + '</span><strong>' + escapeHtml(row[1]) + '</strong></div>';
      }).join('');

      summary.classList.add('is-open');
    }

    thanks.classList.add('is-open');
    thanks.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bca-modal-open');
  }

  async function clearShopifyCartAfterOrder() {
    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({})
      });

      state.cart = {
        items: [],
        item_count: 0,
        items_subtotal_price: 0,
        total_price: 0,
        token: null
      };

      state.totals = {
        subtotal: 0,
        discount: 0,
        shipping: 0,
        total: 0,
        qty: 0
      };

      try {
        localStorage.removeItem('cart');
        localStorage.removeItem('shopify_cart');
        sessionStorage.removeItem('cart');
        sessionStorage.removeItem('shopify_cart');
      } catch (e) {}

      try {
        dispatchDawnCartEvents('cart_cleared_after_cod_order', state.cart);
      } catch (e2) {}

      syncThemeCartCounter(0);
      await refreshDawnThemeCart('cart_cleared_after_cod_order', state.cart);

      setTimeout(function () {
        syncThemeCartCounter(0);
        scheduleDawnThemeCartRefresh('cart_cleared_after_cod_order_retry_250', state.cart, 20);
      }, 250);

      setTimeout(function () {
        syncThemeCartCounter(0);
        scheduleDawnThemeCartRefresh('cart_cleared_after_cod_order_retry_1000', state.cart, 20);
      }, 1000);

      return true;
    } catch (e3) {
      console.warn('Bacanime: pedido creado, pero no se pudo limpiar el carrito.', e3);

      return false;
    }
  }

  function resetAfterSuccessfulOrder() {
    try {
      var newSession = 'bca_' + Date.now() + '_' + Math.random().toString(16).slice(2);

      localStorage.setItem('bca_cod_session_id', newSession);

      state.sessionId = newSession;
      state.eventIds = {};
      state.inputEventSent = false;
      state.codSubmitClicked = false;
      state.orderSubmitted = false;
      state.nativeCheckoutClicked = false;
      state.nativeCheckoutEventSent = false;
      state.currentOrderAttemptId = '';

      qsa('#bca-form input').forEach(function (input) {
        if (input.type === 'checkbox') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });

      qsa('.bca-field').forEach(function (f) {
        f.classList.remove('has-error');
      });

      qsa('.bca-invalid').forEach(function (i) {
        i.classList.remove('bca-invalid');
      });

      ['province','city'].forEach(function (name) {
        var input = qs('[name="' + name + '"]');

        if (input) input.value = '';

        var span = qs('.bca-select[data-select="' + name + '"] .bca-select-btn span');

        if (span) {
          span.textContent = CONFIG.fields[name].placeholder;
          span.classList.add('ph');
        }
      });

      setBogotaHelp(false);

      var citySelect = qs('.bca-select[data-select="city"]');
      var cityBtn = citySelect ? citySelect.querySelector('.bca-select-btn') : null;

      if (citySelect) citySelect.classList.add('is-disabled');
      if (cityBtn) cityBtn.disabled = true;
    } catch (e) {}
  }

  async function submitOrder(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    var btn = qs('.bca-submit'); if (btn && btn.disabled) return;
    setSubmitLoadingState(true);
    try {
      await loadCart('before_submit');
      if (!getCodMinimumStatus().valid) throw new Error(getCodMinimumErrorMessage(getCodMinimumStatus()));
      if (!validateRequired()) throw new Error(CONFIG.texts.requiredError);
      var data = getFormData();
      if (!validPhone(data.phone)) throw new Error(CONFIG.texts.phoneError);
      if (data.email && !validEmail(data.email)) throw new Error(CONFIG.texts.emailError);
      var displayedTotal = state.cloudQuote && state.cloudQuote.total;
      var pending = window.BacanimeFormTransport.load();
      if (!pending || !pending.attempt) {
        var current = await updateCloudQuote(true);
        if (displayedTotal !== current.total) { showMessage('Revisa el total actualizado y vuelve a confirmar tu pedido.', 'ok'); return; }
      }
      state.codSubmitClicked = true;
      var result = await sendCapture('cod_order_submit', false, 'submit_click');
      state.orderSubmitted = true;
      state.lastSuccessfulCartFingerprint = getCartFingerprint(state.cart);
      var payload = result.payload;
      fireTracking(CONFIG.pixel.events.codSubmit, payload);
      if (CONFIG.pixel.firePurchaseOnCodSubmit) fireTracking(CONFIG.pixel.events.purchase, payload);
      showMessage(CONFIG.texts.success + ' ' + result.order.name, 'ok');
      forceCloseModal(); showThankYouPopup(payload);
      if (CONFIG.behavior.clearCartAfterCodSubmit) await clearShopifyCartAfterOrder();
      await window.BacanimeFormTransport.finishConfirmed();
      state.cloudQuote = null; resetAfterSuccessfulOrder();
    } catch (error) {
      state.codSubmitClicked = false;
      showMessage(error.message || CONFIG.texts.genericError, 'error');
    } finally { setSubmitLoadingState(false); }
  }

  function showMessage(text, type) {
    var el = qs('#bca-message');

    if (!el) return;

    el.textContent = text || '';
    el.className = 'bca-message ' + (type || '') + (type === 'error' && !getCodMinimumStatus().valid ? ' minimum-error' : '');
  }

  function showDirectPaymentMessage(text, type) {
    var el = qs('#bca-direct-payment-message');

    if (!el) return;

    el.textContent = text || '';
    el.className = 'bca-direct-payment-message ' + (type || '');
  }

  function yieldToBrowser() {
    return new Promise(function (resolve) {
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function () {
          requestAnimationFrame(resolve);
        });
      } else {
        setTimeout(resolve, 0);
      }
    });
  }

  function warmUpWorkerConnection() {
    if (!CONFIG.behavior.workerPreconnect || !CONFIG.makeWebhookUrl) return;

    try {
      var endpoint = new URL(CONFIG.makeWebhookUrl, window.location.origin);
      var origin = endpoint.origin;

      ['preconnect', 'dns-prefetch'].forEach(function (rel) {
        var selector = 'link[rel="' + rel + '"][href="' + origin + '"]';

        if (document.head.querySelector(selector)) return;

        var link = document.createElement('link');
        link.rel = rel;
        link.href = origin;

        if (rel === 'preconnect') {
          link.crossOrigin = 'anonymous';
        }

        document.head.appendChild(link);
      });
    } catch (e) {}
  }

  function setSubmitLoadingState(isLoading) {
    var btn = qs('.bca-submit');
    var main = qs('#bca-submit-main');
    var sub = qs('#bca-submit-sub');

    if (!btn) return;

    btn.disabled = !!isLoading;
    btn.classList.toggle('is-loading', !!isLoading);

    if (isLoading) {
      btn.setAttribute('aria-busy', 'true');
      if (main) main.textContent = CONFIG.texts.submitProcessing;
      if (sub) sub.textContent = CONFIG.texts.submitProcessingSub;
    } else {
      btn.removeAttribute('aria-busy');
      renderTotals();
    }
  }

  function cancelSubmitLoadingWithMessage(text, type) {
    setSubmitLoadingState(false);
    showMessage(text, type || 'error');
    return null;
  }

  function setAddiCheckoutLoadingState(isLoading) {
    var btn = qs('#bca-addi-checkout');
    var title = btn ? btn.querySelector('.bca-btn-title') : null;
    var subtitle = btn ? btn.querySelector('.bca-btn-subtitle') : null;

    if (!btn) return;

    btn.classList.toggle('is-loading', !!isLoading);
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (title) title.textContent = isLoading ? 'CREANDO CHECKOUT ADDI...' : CONFIG.addiCheckout.buttonText;
    if (subtitle) subtitle.textContent = isLoading ? 'Validando productos, envío y cargo del servicio' : CONFIG.addiCheckout.subtitle;
  }

  function setNativeCheckoutLoadingState(isLoading) {
    var btn = qs('#bca-native-checkout');
    var title = btn ? btn.querySelector('.bca-btn-title') : null;
    var subtitle = btn ? btn.querySelector('.bca-btn-subtitle') : null;

    if (!btn) return;

    btn.classList.toggle('is-loading', !!isLoading);
    btn.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    if (title) {
      title.textContent = isLoading ? CONFIG.texts.nativeProcessing : CONFIG.nativeCheckout.buttonText;
    }

    if (subtitle) {
      subtitle.textContent = isLoading ? CONFIG.texts.nativeProcessingSub : CONFIG.nativeCheckout.subtitle;
    }
  }

  function warmUpModal(reason) {
    try {
      ensureColombiaLocationsLoaded(false).finally(function () {
        try {
          ensureModalRendered();
          refreshLocationSelectOptions();
        } catch (renderError) {
          console.warn('Bacanime: no se pudo precargar modal.', reason || '', renderError);
        }
      });
    } catch (e) {
      console.warn('Bacanime: no se pudo precargar modal.', reason || '', e);
    }
  }

  function init() {
    warmUpWorkerConnection();
    initLandingContext();
    renderInitialButton();
    setupDawnThemeObserver();
    setupLiveCartProgress();

    try {
      ensureColombiaLocationsLoaded(false);
    } catch (locationWarmError) {}

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        try {
          initAttribution();
          ensureClientIpCaptured(false);
        } catch (e) {}
      }, { timeout: 2500 });

      requestIdleCallback(function () {
        warmUpModal('idle_after_page_load');
      }, { timeout: 3500 });
    } else {
      setTimeout(function () {
        try {
          initAttribution();
          ensureClientIpCaptured(false);
        } catch (e) {}
      }, 1200);

      setTimeout(function () {
        warmUpModal('timeout_after_page_load');
      }, 2200);
    }

    document.addEventListener('pointerover', function (e) {
      if (e.target && e.target.closest && e.target.closest('#bca-open-modal')) {
        warmUpModal('pointerover_open_button');
      }
    }, { passive: true });

    document.addEventListener('touchstart', function (e) {
      if (e.target && e.target.closest && e.target.closest('#bca-open-modal')) {
        warmUpModal('touchstart_open_button');
      }
    }, { passive: true });
  }

  window.BCA_COD_FORM_PRO_VERSION = 'v81_15_cobija_sola_minimo_unificado';
  window.BCA_COD_FORM_PRO_INIT = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
